{
    "\"Date From\" must be Before then the \"Date To\"": "\"Fecha desde\" debe ser anterior a la \"Fecha hasta\"",
    "\"Time To\" must be Greater than the \"Time From\"": "\"Hora hasta\" debe ser mayor que la \"Hora desde\"",
    "$10 minimum": "$10 mínimo",
    "$25 minimum": "$25 mínimo",
    "$100000 maximum": "$100,000 máximo",
    "'0 Second(s)' means unlimited time": "'0 Segundo(s)' significa tiempo ilimitado",
    "'0 sec' means unlimited time": "'0 seg' significa tiempo ilimitado",
    "(SLA Calls + Abandoned in SLA) / Total Calls": "(Llamadas SLA + Abandonadas en SLA) / Total de llamadas",
    "+ Create": "+ Crear",
    "1 Minute": "1 Minuto",
    "1 month": "1 mes",
    "1 or more participants": "1 o más participantes",
    "1/1: Charge per second": "1/1: Cobro por segundo",
    "2 Factor Authentication": "Autenticación de dos factores",
    "2 Factor Authentication has been successfully enabled": "La autenticación de dos factores se ha habilitado correctamente",
    "2 Factor Authentication: ": "Autenticación de dos factores: ",
    "2 or more participants": "2 o más participantes",
    "24/7 support": "Soporte 24/7",
    "60/1: Minimum 60 seconds, 1 second increment": "60/1: Mínimo 60 segundos, incremento de 1 segundo",
    "60/60: Minimum 60 seconds, 60 second increment": "60/60: Mínimo 60 segundos, incremento de 60 segundos",
    "A list of announcements": "Una lista de anuncios",
    "A list of conference rooms": "Una lista de salas de conferencia",
    "A list of contacts associated with your account": "Una lista de contactos asociados con tu cuenta",
    "A list of default Caller IDs used to make calls": "Una lista de IDs de llamada predeterminadas usadas para hacer llamadas.",
    "A list of team members for this account": "Una lista de miembros del equipo para esta cuenta",
    "A list of users for this account and their assigned roles": "Una lista de usuarios para esta cuenta y sus roles asignados.",
    "A telephone designed to work with SIP technology for making and receiving calls": "Un teléfono diseñado para trabajar con tecnología SIP para hacer y recibir llamadas.",
    "A transcription is being generated for this call.": "Se está generando una transcripción para esta llamada.",
    "A webphone allows making and receiving phone calls directly from the web browser using a dial panel": "Un teléfono web permite hacer y recibir llamadas telefónicas directamente desde el navegador web usando un panel de marcación.",
    "A2P 10DLC registration approved for Campaign ID: {id}": "Registro A2P 10DLC aprobado para el ID de campaña: {id}",
    "A2P 10DLC registration needed to send SMS messages": "Se requiere registro A2P 10DLC para enviar mensajes SMS",
    "ACD, Auto Attendant, Skill-based routing": "ACD, asistente automático, enrutamiento basado en habilidades",
    "ACD, Auto Attendant, Skills-Based routing": "ACD, asistente automático, enrutamiento basado en habilidades",
    "AI Analytics": "Análisis de IA",
    "AI analytics": "Análisis de IA",
    "AI analytics include automatic call transcripts and keyword research": "El análisis de IA incluye transcripciones automáticas de llamadas e investigación de palabras clave.",
    "API": "API",
    "API Key": "Clave API",
    "API key generated successfully": "Clave API generada exitosamente",
    "AWS": "AWS",
    "Abandoned Calls": "Llamadas abandonadas",
    "Abandoned Calls Ignored: SLA Calls / (Total Calls - Abandoned in SLA)": "Llamadas abandonadas ignoradas: Llamadas SLA / (Total de llamadas - Abandonadas en SLA)",
    "Abandoned Calls Negative Impact:": "Impacto negativo de llamadas abandonadas:",
    "Abandoned Calls Negative Impact: SLA Calls / Total Calls": "Impacto negativo de llamadas abandonadas: Llamadas SLA / Total de llamadas",
    "Abandoned Calls Positive Impact:": "Impacto positivo de llamadas abandonadas:",
    "Abandoned Calls Positive Impact: (SLA Calls + Abandoned in SLA) / Total Calls": "Impacto positivo de llamadas abandonadas: (Llamadas SLA + Abandonadas en SLA) / Total de llamadas",
    "Abort Cancellation": "Abortar cancelación",
    "Accept TOC and PP": "Al continuar, acepta nuestros <terms>Términos y Condiciones</terms> y <privacy>Política de Privacidad</privacy>.",
    "Access code": "Código de acceso",
    "Account": "Cuenta",
    "Account Address": "Dirección de la cuenta",
    "Account Default": "Configuración predeterminada de la cuenta",
    "Account Security": "Seguridad de la cuenta",
    "Account Setup": "Configuración de la cuenta",
    "Account balance": "Saldo de la cuenta",
    "Account default": "Configuración predeterminada de la cuenta",
    "Account has been successfully logged out": "La cuenta ha cerrado sesión correctamente",
    "Account security": "Seguridad de la cuenta",
    "Account security description": "Asegúrate de que solo tú tengas acceso a la cuenta. Escanea el código QR a continuación utilizando la aplicación Google Authenticator.",
    "Account settings updated": "Configuraciones de la cuenta actualizadas",
    "Account settings updated successfully": "La configuración de la cuenta se ha actualizado con éxito.",
    "Account setup": "Configuración de la cuenta",
    "Account setup description": "Necesitamos algunos detalles más para configurar su cuenta.",
    "Account successfully created": "Cuenta creada con éxito",
    "Account under review. Some features are currently disabled until the account verification is complete.": "Cuenta en revisión. Algunas funciones están actualmente deshabilitadas hasta que se complete la verificación de la cuenta.",
    "Account under review. Some features are disabled. Please complete the identity verification process to activate full access.": "Cuenta en revisión. Algunas funciones están deshabilitadas. Complete el proceso de verificación de identidad para activar el acceso completo.",
    "Accounts": "Cuentas",
    "Action": "Acción",
    "Actions": "Acciones",
    "Activation": "Activación",
    "Activation requirements": "Requisitos de activación",
    "Active": "Activo",
    "Active session detected": "Sesión activa detectada",
    "Add": "Agregar",
    "Add Account": "Agregar cuenta",
    "Add Agent Status": "Agregar estado del agente",
    "Add Auto Attendant": "Agregar asistente automático",
    "Add Call Log": "Agregar registro de llamadas",
    "Add Call Queue": "Agregar cola de llamadas",
    "Add Contact": "Agregar contacto",
    "Add DID Number": "Agregar número DID",
    "Add DID number": "Agregar número DID",
    "Add Delay": "Agregar retraso",
    "Add Extension": "Add Extension",
    "Add Note": "Agregar nota",
    "Add Number": "Agregar número",
    "Add Phone Number": "Agregar número de teléfono",
    "Add Queue": "Agregar cola",
    "Add Role": "Agregar rol",
    "Add User": "Agregar usuario",
    "Add Users": "Agregar usuarios",
    "Add Voicemail": "Agregar buzón de voz",
    "Add announcement": "Agregar anuncio",
    "Add card": "Agregar tarjeta",
    "Add conference room": "Agregar sala de conferencia",
    "Add contact": "Agregar contacto",
    "Add delay": "Agregar retraso",
    "Add dial rule": "Agregar regla de marcado",
    "Add endpoint": "Agregar extremo",
    "Add extension": "Agregar extensión",
    "Add forward": "Agregar reenvío",
    "Add funds as you go, based on usage": "Agrega fondos según sea necesario, basado en el uso",
    "Add funds automatically when the balance falls below the threshold": "Agregar fondos automáticamente cuando el saldo caiga por debajo del umbral",
    "Add funds by topping up or subscribing": "Agregar fondos recargando o suscribiéndose",
    "Add inboxes": "Agregar bandejas",
    "Add intercept group": "Agregar grupo de interceptación",
    "Add media": "Agregar multimedia",
    "Add media file": "Agregar archivo multimedia",
    "Add new": "Agregar nuevo",
    "Add new account": "Agregar nueva cuenta",
    "Add new announcement": "Agregar nuevo anuncio",
    "Add new card": "Agregar nueva tarjeta",
    "Add new conference room": "Agregar nueva sala de conferencia",
    "Add new media file": "Agregar nuevo archivo multimedia",
    "Add new voicemail": "Agregar nuevo buzón de voz",
    "Add numbers using the form on the left": "Agregue números usando el formulario de la izquierda",
    "Add payment method": "Agregar método de pago",
    "Add ring group": "Agregar grupo de timbre",
    "Add subdomain *": "Agregar subdominio *",
    "Add team": "Agregar equipo",
    "Add time condition": "Agregar horario comercial",
    "Add time group": "Agregar grupo de tiempo",
    "Add voicemail": "Agregar buzón de voz",
    "Additional call limit": "Límite adicional de llamadas",
    "Additional calls in time period": "Llamadas adicionales en un período de tiempo",
    "Additional calls to the same destination": "Llamadas adicionales al mismo destino",
    "Additional information is required to activate the numbers": "Se requiere información adicional para activar los números",
    "Address": "Dirección",
    "Admin Email": "Correo electrónico del administrador",
    "Admin Pin": "Pin de administrador",
    "Administrator": "Administrador",
    "Advanced": "Avanzado",
    "After Media": "Después del archivo multimedia",
    "After level wait time, move to next level": "Después del tiempo de espera del nivel, pasar al siguiente nivel",
    "Agent Calls": "Llamadas del agente",
    "Agent Name": "Nombre del agente",
    "Agent Number": "Número del agente",
    "Agent Pre-Answer": "Agente pre-respuesta",
    "Agent Status": "Estado del agente",
    "Agent With Fewest Calls": "Agente con menos llamadas",
    "Agent With Least Talk Time": "Agente con menos tiempo de conversación",
    "Agent ring settings": "Configuración del timbre del agente",
    "Agent ring time": "Tiempo de timbre del agente",
    "Agents": "Agentes",
    "Agents In Queues": "Agentes en colas",
    "Agents Ready": "Agentes disponibles",
    "Agents in call": "Agentes en llamada",
    "Alert dialog description": "Esta acción no se puede deshacer. Esto eliminará permanentemente los datos de nuestros servidores.",
    "All countries": "Todos los países",
    "All groups": "Todos los grupos",
    "All teams": "Todos los equipos",
    "All the features of our plans": "Todas las características de nuestros planes",
    "Allow": "Permitir",
    "Allow Call Waiting": "Permitir llamada en espera",
    "Allow calls waiting": "Permitir llamadas en espera",
    "Allow inbound calls": "Permitir llamadas entrantes",
    "Allow only IPv4, IP Range or CIDR": "Permitir solo IPv4, rango de IP o CIDR",
    "Allow outbound calls": "Permitir llamadas salientes",
    "Allowed": "Permitido",
    "Allowed Extensions": "Extensiones permitidas",
    "Allowed Pauses": "Pausas permitidas",
    "Allowed pauses": "Pausas permitidas",
    "Allowed statuses": "Estados permitidos",
    "Already have a number? Start porting your number after sign-up.": "¿Ya tienes un número? Comienza a portar tu número después de registrarte.",
    "Already have an account?": "¿Ya tienes una cuenta?",
    "Amount": "Monto",
    "Amount billed monthly per user": "Monto facturado mensualmente por usuario:",
    "An audio played to the caller upon entering the queue": "Un audio reproducido al llamante al ingresar a la cola",
    "An error occurred while sending the invite": "Ocurrió un error al enviar la invitación",
    "An extension created for Chrome and Edge allowing you to manage calls from anywhere in the browser": "Una extensión creada para Chrome y Edge que permite gestionar llamadas desde cualquier parte del navegador.",
    "An invite email has been send to the entered email": "Se ha enviado una invitación al correo electrónico ingresado",
    "An invite email has been sent to the entered email": "Se ha enviado una invitación al correo electrónico ingresado",
    "Announcement": "Anuncio",
    "Announcement description": "Reproducir mensajes pregrabados a los llamantes entrantes sin importar en qué parte del proceso de espera se encuentren.",
    "Announcements": "Anuncios",
    "Answered": "Respondido",
    "Answered Calls": "Llamadas respondidas",
    "Answered Calls Ignored:": "Llamadas respondidas ignoradas:",
    "Answered and Unanswered": "Atendidas y no atendidas",
    "AppTitle": "PBX.IM",
    "Applicable Disclaimers": "Avisos legales aplicables",
    "Are you absolutely sure?": "¿Está completamente seguro?",
    "Are you sure you want to cancel?": "¿Estás seguro de que quieres cancelar?",
    "Are you sure you want to delete account?": "¿Está seguro de que desea eliminar la cuenta?",
    "Are you sure you want to delete this agent status?": "¿Estás seguro de que deseas eliminar este estado del agente?",
    "Are you sure you want to delete this automatic top-up": "¿Estás seguro de que deseas eliminar esta recarga automática?",
    "Are you sure you want to delete this call queue?": "¿Estás seguro de que deseas eliminar esta cola de llamadas?",
    "Are you sure you want to delete this card": "¿Estás seguro de que deseas eliminar esta tarjeta?",
    "Are you sure you want to delete this contact?": "¿Estás seguro de que deseas eliminar este contacto?",
    "Are you sure you want to delete this dial rule?": "¿Estás seguro de que deseas eliminar esta regla de marcado?",
    "Are you sure you want to delete this invitation?": "¿Está seguro de que desea eliminar esta invitación?",
    "Are you sure you want to delete this media?": "¿Estás seguro de que deseas eliminar este archivo multimedia?",
    "Are you sure you want to log out?": "¿Está seguro de que desea cerrar sesión?",
    "Are you sure you want to revoke access for this user?": "¿Está seguro de que desea revocar el acceso para este usuario?",
    "Are you sure you want to top up your account with {amount}": "¿Estás seguro de que deseas recargar tu cuenta con {amount}?",
    "Are you sure?": "¿Está seguro?",
    "Area Code": "Codigo de Area",
    "As an extra security measure we need to add your phone number": "Como medida de seguridad adicional, necesitamos agregar su número de teléfono.",
    "Assign agent status": "Asignar estado de agente",
    "Assign unique short codes for easy communication": "Asignar códigos cortos únicos para una comunicación fácil.",
    "Assigned": "Asignado",
    "Assigned Agents": "Agentes asignados",
    "Assigned Inboxes": "Bandejas asignadas",
    "Assigned Phone Numbers": "Números de teléfono asignados",
    "Assigned Users": "Usuarios asignados",
    "Assigned agents": "Agentes asignados",
    "Assigned to": "Asignado a",
    "Assigned to queues": "Asignado a colas",
    "Assigned users": "Usuarios asignados",
    "At least 8 characters": "Al menos 8 caracteres",
    "Attach Message File": "Adjuntar archivo de mensaje",
    "Attach Voicemail Recording": "Adjuntar grabación de correo de voz",
    "Audio": "Audio",
    "Audio Playback": "Reproducción de audio",
    "Audio played after the selected media file": "Audio reproducido después del archivo multimedia seleccionado",
    "Audio played before the selected media file": "Audio reproducido antes del archivo multimedia seleccionado",
    "Audio played once at the start of a call": "Audio reproducido una vez al inicio de una llamada",
    "Audio played when an invalid key is pressed": "Audio reproducido cuando se presiona una tecla inválida",
    "Audio that plays repeatedly after the main message It repeats instructions without the welcome message": "Audio que se reproduce repetidamente después del mensaje principal. Repite instrucciones sin el mensaje de bienvenida.",
    "Audio that plays when the caller reaches the limit of options or doesn't input anything, then directs to the exit": "Audio que se reproduce cuando el llamante alcanza el límite de opciones o no ingresa nada, y luego se dirige a la salida.",
    "Auto": "Automático",
    "Auto Answer": "Respuesta automática",
    "Auto Attendant": "Atendedor automático",
    "Auto Attendant was successfully saved": "El asistente automático se guardó correctamente.",
    "Auto Top-up deleted": "Recarga automática eliminada",
    "Auto Top-up saved": "Recarga automática guardada",
    "Auto Top-up successful": "Recarga automática exitosa",
    "Auto dialer": "Marcador automático",
    "Auto gain level": "Nivel de ganancia automática",
    "Auto record": "Grabación automática",
    "Auto top-up": "Recarga automática",
    "Auto-answer calls for available agents": "Respuesta automática de llamadas para agentes disponibles",
    "Auto-pause on unanswered queue calls": "Pausa automática en llamadas de cola no respondidas",
    "Auto: An agent joins a queue automatically on check in": "Automático: Un agente se une a una cola automáticamente al registrarse",
    "Automatically top up balance with <b>{upTo}</b> when it falls below <b>{below}</b>": "Recarga automáticamente el saldo con <b>{upTo}</b> cuando caiga por debajo de <b>{below}</b>",
    "Available": "Disponible",
    "Available Extensions": "Extensiones disponibles",
    "Available User Seats": "Asientos de usuarios disponibles",
    "Available agents": "Agentes disponibles",
    "Available queues": "Colas disponibles",
    "Available users": "Usuarios disponibles",
    "Average Call Duration": "Duración promedio de llamada",
    "Average Wait Time": "Tiempo promedio de espera",
    "Average call length": "Duración promedio de llamada",
    "Average caller wait time": "Tiempo promedio de espera del llamante",
    "Avg call duration": "Duración promedio de la llamada",
    "Avg talk time": "Tiempo promedio de conversación",
    "Avg wait time": "Tiempo promedio de espera",
    "BLF Extension": "Extensión BLF",
    "Back": "Volver",
    "Back To Dashboard": "Volver al tablero",
    "Back to login": "Volver al inicio de sesión",
    "Balance": "Saldo",
    "Balance / Credit Limit": "Saldo / Límite de crédito",
    "Balance Below Threshold": "Saldo por debajo del umbral",
    "Balance is too low": "El saldo es demasiado bajo",
    "Barged In": "Irrumpió en la llamada",
    "Barged in": "Irrumpió en la llamada",
    "Basic Info": "Información básica",
    "Basic Phone Features": "Funciones básicas del teléfono",
    "Basic phone features": "Funciones básicas del teléfono",
    "Before Media": "Antes del archivo multimedia",
    "Begins with": "Comienza con",
    "Billable": "Facturable",
    "Billing": "Facturación",
    "Billing Address": "Dirección de facturación",
    "Billing Email": "Correo electrónico de facturación",
    "Billing Incr": "Incremento de facturación",
    "Billing Increments": "Incrementos de facturación",
    "Billing Info": "Información de facturación",
    "Billing Information": "Información de facturación",
    "Billing Period": "Período de facturación",
    "Billing address": "Dirección de facturación",
    "Billing info": "Información de facturación",
    "Billing period": "Período de facturación:",
    "Block Calls To Countries": "Bloquear llamadas a países",
    "Blocked countries": "Países bloqueados",
    "Bottom Left": "Abajo a la izquierda",
    "Bottom Right": "Abajo a la derecha",
    "Branding": "Marca",
    "Break": "Pausa",
    "Browse": "Examinar",
    "Browse file": "Buscar archivo",
    "Browser Extension": "Browser Extension",
    "Business": "Empresa",
    "Busy": "Ocupado",
    "Busy delay": "Retraso por ocupado",
    "Buy DID": "Comprar DID",
    "Buy Now": "Comprar ahora",
    "By canceling you will lose access to the advanced features": "Al cancelar perderás acceso a las características avanzadas",
    "By canceling your plan you will lose access to these features:": "Al cancelar tu plan perderás acceso a estas funciones:",
    "By downgrading you plan you will lose access to these features": "Al degradar tu plan perderás acceso a estas funciones:",
    "CDR": "CDR",
    "CIDR": "CIDR",
    "CRM Integration": "Integración con CRM",
    "CRM integration": "Integración con CRM",
    "CRM integrations": "Integraciones de CRM",
    "Call": "Llamada",
    "Call & Chat": "Llamada y chat",
    "Call & Chat — coming soon": "Call & Chat — coming soon",
    "Call Center Agent": "Agente de centro de llamadas",
    "Call Center Manager": "Gerente de centro de llamadas",
    "Call Failed": "Llamada fallida",
    "Call Forwarding": "Reenvío de llamadas",
    "Call Handling": "Manejo de llamadas",
    "Call History": "Historial de llamadas",
    "Call Logs": "Registros de llamadas",
    "Call Queues": "Colas de llamadas",
    "Call Routing": "Enrutamiento de llamadas",
    "Call Stats": "Estadísticas de llamadas",
    "Call Timeout": "Tiempo de espera de la llamada",
    "Call Types": "Tipos de llamadas",
    "Call Volume": "Volumen de llamadas",
    "Call Waiting Tone": "Tono de llamada en espera",
    "Call center": "Centro de llamadas",
    "Call center API": "API del centro de llamadas",
    "Call distribution": "Distribución de llamadas",
    "Call for as low as": "Llama por tan solo",
    "Call forwarding": "Reenvío de llamadas",
    "Call forwarding description": "Redirigir llamadas a otro número o servicio.",
    "Call limit": "Límite de llamadas",
    "Call limits": "Límites de llamadas",
    "Call logs": "Registros de llamadas",
    "Call queue": "Cola de llamadas",
    "Call queues": "Colas de llamadas",
    "Call recording": "Grabación de llamadas",
    "Call recordings are stored by default for the amount of time corresponding to a plan": "Las grabaciones de llamadas se almacenan por defecto durante el tiempo correspondiente a un plan.",
    "Call routing": "Enrutamiento de llamadas",
    "Call timeout": "Tiempo de espera de la llamada",
    "Call type": "Tipo de llamada",
    "Call types": "Tipos de llamada",
    "Call waiting in queue": "Llamada en espera en la cola",
    "Call waiting settings": "Configuración de llamada en espera",
    "Call {Company Name}": "Llamar a {Company Name}",
    "Caller": "Llamante",
    "Caller ID": "Identificador de llamadas",
    "Caller ID Name": "Nombre del identificador de llamadas",
    "Caller ID Number": "Número de identificador de llamadas",
    "Caller ID by country": "Identificador de llamadas por país",
    "Caller ID is required": "El identificador de llamadas es obligatorio",
    "Caller IDs": "IDs de llamada",
    "Caller IDs set by country take priority over the default caller ID listed above": "Los IDs de llamada configurados por país tienen prioridad sobre el ID de llamada predeterminado listado arriba.",
    "Caller Information": "Información del llamante",
    "Caller Pre-Join": "Llamante pre-unión",
    "CallerID Num": "Número de identificador de llamadas",
    "Calls": "Llamadas",
    "Calls Caller ID": "Identificador de llamadas en llamadas",
    "Calls Recordings Access Restriction by Countries and/or IP Ranges": "Restricción de acceso a grabaciones de llamadas por países y/o rangos de IP",
    "Calls in Queues": "Llamadas en colas",
    "Campaign ID: {id}, use case: {message}": "ID de campaña: {id}, caso de uso: {message}",
    "Campaigns": "Campañas",
    "Can only be removed by a manager": "Solo puede ser removido por un gerente",
    "Cancel": "Cancelar",
    "Cancel DID Number": "Cancelar número DID",
    "Cancel Number": "Cancelar número",
    "Cancel Phone Number": "Cancelar número de teléfono",
    "Cancel Plan": "Cancelar plan",
    "Cannot exceed Messages Per Day": "Cannot exceed Messages Per Day",
    "Cannot log out during user creation": "No se puede cerrar sesión durante la creación de usuario",
    "Card added successfully": "Tarjeta agregada con éxito",
    "Card deleted successfully": "Tarjeta eliminada con éxito",
    "Card number": "Número de tarjeta",
    "Cart": "Carrito",
    "Categories": "Categories",
    "Categories — coming soon": "Categories — coming soon",
    "Change Own Password": "Cambiar mi contraseña",
    "Change Password": "Cambiar contraseña",
    "Change password": "Cambiar contraseña",
    "Change plan": "Cambiar plan",
    "Change your password": "Cambia tu contraseña",
    "Channel limits": "Límites de canales",
    "Channels assigned to a DID number": "Canales asignados a un número DID.",
    "Chat": "Chat",
    "Chat returned to queue by \"{by}\"": "Chat devuelto a la cola por \"{by}\"",
    "Chat routed by \"{by}\"": "Chat enrutado por \"{by}\"",
    "Chat with SIP IO Support": "Chatear con el soporte de SIP.IO",
    "Checking…": "Verificando…",
    "Checkout": "Pagar",
    "Chief Customer Officer": "Director de atención al cliente",
    "Choose Country": "Elegir país",
    "Choose Destination": "Elegir destino",
    "Choose Greeting": "Elija un saludo",
    "Choose Integration Type": "Elegir tipo de integración",
    "Choose a dial rule": "Elige una regla de marcación",
    "Choose a plan that's right for you": "Elige un plan que sea adecuado para ti",
    "Choose a prefix": "Elegir un prefijo",
    "Choose a value": "Elija un valor",
    "Choose another method": "Elige otro método",
    "Choose approved campaign": "Elegir campaña aprobada",
    "Choose audio": "Elegir audio",
    "Choose campaign": "Elegir campaña",
    "Choose country preset": "Elegir preajuste de país",
    "Choose digit": "Elegir dígito",
    "Choose distribution": "Elegir distribución",
    "Choose labels": "Elija etiquetas",
    "Choose media file": "Elegir archivo multimedia",
    "Choose music": "Elegir música",
    "Choose one extension that you want to monitor from the dropdown menu": "Elige una extensión que deseas monitorear del menú desplegable.",
    "Choose payment method": "Elige método de pago",
    "Choose placeholder": "Elija {what}",
    "Choose role": "Elige rol",
    "Choose site": "Elegir sitio",
    "Choose strategy": "Elegir estrategia",
    "Choose teams": "Elige equipos",
    "Choose type": "Elegir tipo",
    "Choose value": "Elegir valor",
    "Choose voice": "Elegir voz",
    "Chose an user": "Elige un usuario",
    "Chrome/Edge Extension": "Extensión para Chrome/Edge",
    "Chrome/edge extension": "Extensión para Chrome/Edge",
    "City": "Ciudad",
    "City *": "Ciudad *",
    "Clear Filters": "Limpiar filtros",
    "Clear filters": "Limpiar filtros",
    "Close": "Cerrar",
    "Cloud Phone System": "Sistema telefónico en la nube",
    "Collapse sidebar": "Colapsar barra lateral",
    "Color": "Color",
    "Comfort noise": "Ruido de confort",
    "Coming soon": "Próximamente...",
    "Command sent successfully": "Comando enviado con éxito",
    "Commerce": "Comercio",
    "Company": "Compañía",
    "Company Details": "Detalles de la compañía",
    "Company Logo": "Logotipo de la empresa",
    "Company Name": "Nombre de la compañía",
    "Company Name *": "Nombre de la empresa *",
    "Company Phone *": "Teléfono de la empresa *",
    "Company Role": "Rol en la empresa",
    "Company Role *": "Rol en la empresa *",
    "Company address": "Dirección de la empresa",
    "Company details": "Detalles de la compañía",
    "Company details description": "Información relevante sobre tu compañía.",
    "Company details have been updated succesfully": "¡Los detalles de la empresa se han actualizado con éxito!",
    "Company details updated": "Detalles de la compañía actualizados",
    "Company name": "Nombre de la compañía",
    "Company name *": "Nombre de la compañía *",
    "Company registration No": "Número de registro de la empresa",
    "Company registration No *": "Número de registro de la empresa *",
    "Company role": "Rol de la compañía",
    "Complete": "Completo",
    "Compliance": "Cumplimiento",
    "Conditional Actions": "Acciones condicionales",
    "Conditions": "Condiciones",
    "Conference": "Conferencia",
    "Conference Rooms": "Salas de conferencia",
    "Conference rooms": "Salas de conferencia",
    "Conference rooms description": "Gestionar todas tus salas de conferencias.",
    "Configuration": "Configuración",
    "Configure business hours and peak times for call routing": "Configura los horarios comerciales y los tiempos pico para el enrutamiento de llamadas.",
    "Configure call menus": "Configurar menús de llamadas.",
    "Confirm": "Confirmar",
    "Confirm Purchase": "Confirmar compra",
    "Confirm code": "Confirmar código",
    "Confirm new password": "Confirmar nueva contraseña",
    "Confirm top-up": "Confirmar recarga",
    "Connect": "Conectar",
    "Contact": "Contacto",
    "Contact Created": "Contacto creado",
    "Contact Details": "Detalles de contacto",
    "Contact Info": "Información de contacto",
    "Contact Person": "Persona de contacto",
    "Contact Updated": "Contacto actualizado",
    "Contacts": "Contactos",
    "Content": "Contenido",
    "Continue": "Continuar",
    "Continue with Google": "Continuar con Google",
    "Continue with Microsoft": "Continuar con Microsoft",
    "Enter the code that was sent to your new phone number": "Introduce el código que se envió a tu nuevo número de teléfono.",
    "This organization requires single sign-on.": "Esta organización requiere inicio de sesión único (SSO).",
    "Login is temporarily unavailable. Please try again in a few minutes.": "El inicio de sesión no está disponible temporalmente. Inténtalo de nuevo en unos minutos.",
    "This account signs in with an email and password. Please use those instead.": "Esta cuenta inicia sesión con correo electrónico y contraseña. Utilícelos en su lugar.",
    "Single sign-on is not available for this organization.": "El inicio de sesión único (SSO) no está disponible para esta organización.",
    "Sign-in was cancelled. Please try again.": "Se canceló el inicio de sesión. Inténtelo de nuevo.",
    "This account belongs to a different organization.": "Esta cuenta pertenece a otra organización.",
    "This account is disabled. Please contact your administrator.": "Esta cuenta está deshabilitada. Póngase en contacto con su administrador.",
    "Your account does not have access. Please contact your administrator.": "Su cuenta no tiene acceso. Póngase en contacto con su administrador.",
    "Your account is not set up for single sign-on. Please contact your administrator.": "Su cuenta no está configurada para inicio de sesión único. Póngase en contacto con su administrador.",
    "Your organization has no seats available. Please contact your administrator.": "Su organización no tiene licencias disponibles. Póngase en contacto con su administrador.",
    "We couldn't find an account for that email. Please check which account you used.": "No encontramos una cuenta para ese correo electrónico. Compruebe qué cuenta ha utilizado.",
    "Your organization isn't set up for sign-in yet. Please contact your administrator.": "Su organización aún no está configurada para el inicio de sesión. Póngase en contacto con su administrador.",
    "We couldn't sign you in. Please try again.": "No pudimos iniciar su sesión. Inténtelo de nuevo.",
    "Contrast too low.": "Contraste demasiado bajo.",
    "Copied": "Copied",
    "Copy": "Copiar",
    "Copy script": "Copy script",
    "Core": "Core",
    "Cost": "Costo",
    "Could not create account": "No se pudo crear la cuenta",
    "Could not delete the table row": "No se pudo eliminar la fila de la tabla",
    "Could not invite user ": "No se pudo invitar al usuario",
    "Could not resend invitation": "No se pudo reenviar la invitación",
    "Could not save company details": "No se pudieron guardar los detalles de la compañía",
    "Could not set up billing information": "No se pudo configurar la información de facturación",
    "Could not setup 2FA": "No se pudo configurar la autenticación de dos factores",
    "Could not start ID verification": "No se pudo iniciar la verificación de ID",
    "Could not update dial rule settings": "No se pudieron actualizar los ajustes de la regla de marcación",
    "Could not update general settings": "No se pudieron actualizar las configuraciones generales",
    "Could not update media settings": "No se pudieron actualizar los ajustes de medios.",
    "Could not update the company details": "No se pudieron actualizar los detalles de la compañía",
    "Could not update the profile": "No se pudo actualizar el perfil",
    "Could not validate the invitation": "No se pudo validar la invitación",
    "Could not verify the user": "No se pudo verificar el usuario",
    "Countries": "Países",
    "Country": "País",
    "Country *": "País *",
    "Country preset": "Preajuste de país",
    "Create and manage all your media files": "Crear y gestionar todos tus archivos multimedia.",
    "Create password *": "Crear contraseña *",
    "Create transcription": "Crear transcripción",
    "Create your account": "Cree su cuenta",
    "Creating Transcription": "Creando transcripción",
    "Credit card": "Tarjeta de crédito",
    "Current Users": "Usuarios actuales",
    "Current password": "Contraseña actual",
    "Custom": "Personalizado",
    "Customer Number": "Número del cliente",
    "Customer Service Manager": "Gerente de servicio al cliente",
    "Customize": "Personalizar",
    "DEFAULT CARD": "TARJETA PREDETERMINADA",
    "DID": "DID",
    "DID Channels": "{count} Canales DID",
    "DID Number": "Número DID",
    "DID Numbers": "Números DID",
    "DID numbers": "Números DID",
    "Dashboard": "Panel de control",
    "Dashboard description": "Panel de control próximamente...",
    "Dashboard title": "¡Bienvenido {name}!",
    "Date": "Fecha",
    "Date from": "Fecha desde",
    "Date issued": "Fecha de emisión",
    "Date to": "Fecha hasta",
    "Days": "Días",
    "Days of the week": "Días de la semana",
    "Decimals not allowed": "No se permiten decimales",
    "Default": "Predeterminado",
    "Default DID Destination": "Destino DID predeterminado",
    "Default account dial rule": "Regla de marcación predeterminada de la cuenta",
    "Default caller IDs": "Identificadores de llamadas predeterminados",
    "Default color: White": "Default color: White",
    "Default destination": "Destino predeterminado",
    "Default destination type": "Tipo de destino predeterminado",
    "Default exit destination": "Destino de salida predeterminado",
    "Default music": "Música predeterminada",
    "Defaults": "Predeterminados",
    "Define how outbound calls are processed and formatted": "Define cómo se procesan y formatean las llamadas salientes.",
    "Degraded": "Degradado",
    "Delay": "Retraso",
    "Delay time added after the caller inputs their selection": "Tiempo de retraso agregado después de que el llamante ingrese su selección.",
    "Delete": "Eliminar",
    "Delete Agent Status": "Eliminar estado del agente",
    "Delete Invitation": "Eliminar invitación",
    "Delete account": "Eliminar cuenta",
    "Delete automatic top-up": "Eliminar recarga automática",
    "Delete call queue": "Eliminar cola de llamadas",
    "Delete card": "Eliminar tarjeta",
    "Delete contact": "Eliminar contacto",
    "Delete dial rule": "Eliminar regla de marcado",
    "Delete media": "Eliminar archivo multimedia",
    "Delete row description": "¿Está seguro de que desea eliminar esta fila? Esta acción es irreversible.",
    "Deny": "Denegar",
    "Description": "Descripción",
    "Description is required": "La descripción es obligatoria",
    "Destination": "Destino",
    "Destination - condition Matched": "Destino - condición coincidente",
    "Destination - condition NOT Matched": "Destino - condición NO coincidente",
    "Destination Country": "País de destino",
    "Destination Name": "Nombre del destino",
    "Destination name": "Nombre del destino",
    "Destination type": "Tipo de destino",
    "Details": "Detalles",
    "Detect Timeout": "Detectar tiempo de espera",
    "Dial Rule": "Regla de marcado",
    "A dial rule with this name already exists": "Ya existe una regla de marcación con este nombre",
    "Dial rule created": "Regla de marcación creada",
    "Dial rule updated": "Regla de marcación actualizada",
    "Dial Rules": "Reglas de marcado",
    "Dial Status": "Estado de marcación",
    "Dial rule": "Regla de marcación",
    "Dial rules": "Reglas de marcado",
    "Dial rules (override)": "Reglas de marcado (anulación)",
    "Dialer": "Marcador",
    "Did you scan the QR code?": "¿Escaneaste el código QR?",
    "Digit": "Dígito",
    "Digit length": "Longitud de dígito",
    "Digits": "Dígitos",
    "Direct Fax": "Fax directo",
    "Direct Inward dialing Channels": "Canales de marcación directa entrante",
    "Direct extensions": "Extensiones directas",
    "Direct incoming calls to multiple phone numbers or extensions simultaneous or in sequence": "Dirigir las llamadas entrantes a varios números de teléfono o extensiones de manera simultánea o en secuencia.",
    "Disable 2FA": "Desactivar la autenticación de dos factores",
    "Disable Mute": "Deshabilitar silencio",
    "Disable Mute Button in WD": "Deshabilitar botón de silencio en WD",
    "Disabled": "Deshabilitado",
    "Disabled for all users": "Deshabilitado para todos los usuarios",
    "Disallow changing Pause": "No permitir cambiar Pausa",
    "Discard unsaved changes?": "¿Descartar los cambios no guardados?",
    "Disconnected": "Desconectado",
    "Do Not Disturb": "No molestar",
    "Do you want to add <b>{price}</b> now": "¿Deseas agregar <b>{price}</b> ahora?",
    "Do you want to close the previous session and continue here": "¿Quieres cerrar la sesión anterior y continuar aquí?",
    "Do you want to proceed": "¿Desea continuar?",
    "Do you want to proceed?": "¿Deseas continuar?",
    "Do you want to proceeed?": "¿Deseas continuar?",
    "Do you want to stay logged in?": "¿Quieres permanecer conectado?",
    "Docs": "Documentos",
    "Documentation": "Documentación",
    "Does not match your password": "No coincide con tu contraseña.",
    "Domain": "Dominio",
    "Don't have access to the web phone": "No tienes acceso al teléfono web",
    "Don't mask": "No enmascarar",
    "Don't record": "No grabar",
    "Download": "Descargar",
    "Download All Countries' Rates (CSV)": "Descargar tarifas de todos los países (CSV)",
    "Dropped before being answered": "Cortadas antes de ser atendidas",
    "Due Later": "A pagar después",
    "Due Now": "A pagar ahora",
    "Duration": "Duración",
    "Edit": "Editar",
    "Edit Account": "Editar cuenta",
    "Edit Agent Status": "Editar estado del agente",
    "Edit Call Queue": "Editar cola de llamadas",
    "Edit Contact": "Editar contacto",
    "Edit DID number": "Editar número DID",
    "Edit Node": "Editar nodo",
    "Edit Phone Number": "Editar número de teléfono",
    "Edit Role": "Editar rol",
    "Edit User": "Editar usuario",
    "Edit User Details": "Editar detalles del usuario",
    "Edit announcement": "Editar anuncio",
    "Edit conference room": "Editar sala de conferencia",
    "Edit dial rule": "Editar regla de marcado",
    "Edit endpoint": "Editar extremo",
    "Edit extension": "Editar extensión",
    "Edit forward": "Editar reenvío",
    "Edit intercept group": "Editar grupo de interceptación",
    "Edit media file": "Editar archivo multimedia",
    "Edit queue": "Editar cola",
    "Edit ring group": "Editar grupo de timbre",
    "Edit team": "Editar equipo",
    "Edit time condition": "Editar horario comercial",
    "Edit time group": "Editar grupo de tiempo",
    "Edit voicemail": "Editar buzón de voz",
    "Email": "Correo electrónico",
    "Email & Chat Support": "Soporte por correo electrónico y chat",
    "Email *": "Correo electrónico *",
    "Email / Chat": "Correo electrónico / Chat",
    "Email / Chat / Phone": "Correo electrónico / Chat / Teléfono",
    "Email Code": "Código de correo electrónico",
    "Email Code *": "Código de correo electrónico *",
    "Email Subject": "Asunto del correo electrónico",
    "Email address": "Dirección de correo electrónico",
    "Email notification": "Notificación por correo electrónico",
    "Email sent successfully": "Correo electrónico enviado con éxito",
    "Emails": "Correos electrónicos",
    "Embed script": "Embed script",
    "Enable": "Habilitar",
    "Enable 2 Factor Authentication": "Habilitar la autenticación de dos factores",
    "Enable Auto-Top Up to automatically recharge your account balance": "Habilita la recarga automática para recargar el saldo de tu cuenta automáticamente",
    "Enable Call Recording": "Habilitar grabación de llamadas",
    "Enable Caller ID by Destination Country": "Habilitar ID de llamada por país de destino",
    "Enable Calling": "Enable Calling",
    "Enable Call or Chat on at least one route": "Habilita una llamada o chat en al menos una ruta",
    "Enable Chat": "Enable Chat",
    "Enable For All Users": "Habilitar para todos los usuarios",
    "Enable Mute": "Habilitar silencio",
    "Enable SMS Routing": "Habilitar enrutamiento de SMS",
    "Enable Welcome Message": "Habilitar mensaje de bienvenida",
    "Enable agent levels": "Habilitar niveles de agentes",
    "Enabled": "Habilitado",
    "Enabled Direct Dial": "Marcación directa habilitada",
    "Enabled Outside of IP Range": "Habilitado fuera del rango de IP",
    "Enabled Outside of IP range": "Habilitado fuera del rango de IP",
    "Enabled Outside of Login IP Range": "Habilitado fuera del rango de IP de inicio de sesión",
    "Enabled for all users": "Habilitado para todos los usuarios",
    "End Current Call": "Finalizar llamada actual",
    "End Test": "Finalizar prueba",
    "End the test call before saving": "Finalice la llamada de prueba antes de guardar",
    "End the test call before changing status": "Finalice la llamada de prueba antes de cambiar el estado",
    "Endpoint": "Extremo",
    "Endpoint created": "Extremo creado",
    "Endpoint updated": "Extremo actualizado",
    "Endpoint / Flow": "Extremo / Flujo",
    "Endpoint not Available": "Extremo no disponible",
    "Endpoint parameters": "Parámetros del extremo",
    "Endpoints": "Extremos",
    "English": "Inglés",
    "English (Default)": "Inglés (Predeterminado)",
    "Enjoy $5 in free credit to try our service right away": "Disfrute de $5 de crédito gratuito para probar nuestro servicio de inmediato.",
    "Enter URL": "Ingresar URL",
    "Enter Value": "Ingrese valor",
    "Enter a Name": "Ingrese un nombre",
    "Enter a PIN": "Ingrese un PIN",
    "Enter an Email Address": "Ingrese una dirección de correo electrónico",
    "Enter name": "Ingrese un nombre",
    "Enter names separated by comma or new line": "Ingrese nombres separados por coma o nueva línea",
    "Enter the six digits displayed in the app": "Ingrese los seis dígitos mostrados en la aplicación",
    "Enter the verification code sent to your email": "Ingrese el código de verificación enviado a su correo electrónico",
    "Enter your card details and top up your account": "Ingrese los detalles de su tarjeta y recargue su cuenta.",
    "Enterprise": "Empresa",
    "Entries": "Entradas:",
    "Error": "Error",
    "Error in reviewing cart, please try again!": "Error al revisar el carrito, ¡inténtalo de nuevo!",
    "Essential": "Esencial",
    "Estimated Transfer Date": "Fecha estimada de transferencia",
    "Event Push Notifications": "Notificaciones push de eventos",
    "Event push notifications": "Notificaciones push de eventos",
    "Everybody": "Todos",
    "Everyday": "Todos los días",
    "Everything in Advanced, and": "Todo en Advanced, y",
    "Everything in Core, and": "Todo en Core, y",
    "Everything in Essential, and": "Todo en Essential, y",
    "Everything in Start-up, and": "Todo en Start-up, y",
    "Examples": "Ejemplos",
    "Exclude Groups": "Excluir grupos",
    "Exit Destinations": "Destinos de salida",
    "Exit audio": "Audio de salida",
    "Exit by digit": "Salir por dígito",
    "Exit destination": "Destino de salida",
    "Exit destination type": "Tipo de destino de salida",
    "Exit sound": "Sonido de salida",
    "Expand sidebar": "Expandir barra lateral",
    "Expiration": "Vencimiento",
    "Expiration date": "Fecha de vencimiento",
    "Export": "Exportar",
    "Expression used for replacing matches in the regex pattern": "Expresión utilizada para reemplazar coincidencias en el patrón regex.",
    "Expression used to find a match in the input text": "Expresión utilizada para encontrar una coincidencia en el texto de entrada.",
    "Extend account settings": "Extender configuraciones de cuenta",
    "Extension": "Extensión",
    "Extension currently available for Chrome and Edge only": "Extension currently available for Chrome and Edge only",
    "Extension is required": "La extensión es obligatoria",
    "Extension should be number": "La extensión debe ser un número",
    "Extensions": "Extensiones",
    "External ID": "ID externo",
    "FILTERED BY": "FILTRADO POR",
    "FS Domain": "Dominio FS",
    "Failed to delete template": "Error al eliminar la plantilla",
    "Failed to save the widget": "Error al guardar el widget",
    "Failed to update template": "Error al actualizar la plantilla",
    "Fax": "Fax",
    "Fax option": "Opción de fax",
    "FaxBox": "FaxBox",
    "File": "Archivo",
    "File is required": "El archivo es obligatorio",
    "Filter": "Filtro",
    "Finance": "Finanzas",
    "Financial User": "Usuario financiero",
    "Financial user": "Usuario financiero",
    "Finish": "Finalizar",
    "Finish Purchase": "Finalizar compra",
    "First Name": "Nombre",
    "First name": "Nombre",
    "First name *": "Nombre *",
    "Flush Registration": "Eliminar registro",
    "Flush registration": "Eliminar registro",
    "Flush registration command sent": "Comando para eliminar registro enviado",
    "Follow me 10s delay": "Seguirme 10s de retraso",
    "Follow me 15s delay": "Seguirme 15s de retraso",
    "Follow me 20s delay": "Seguirme 20s de retraso",
    "Follow me 30s delay": "Seguirme 30s de retraso",
    "Follow me 40s delay": "Seguirme 40s de retraso",
    "Follow me 50s delay": "Seguirme 50s de retraso",
    "Follow me 5s delay": "Seguirme 5s de retraso",
    "Follow me 60s delay": "Seguirme 60s de retraso",
    "Follow me 70s delay": "Seguirme 70s de retraso",
    "Follow me 80s delay": "Seguirme 80s de retraso",
    "Follow me 90s delay": "Seguirme 90s de retraso",
    "For example, 60/1 means a minimum charge of 60 seconds, then billed in 1-second increments": "Por ejemplo, 60/1 significa una carga mínima de 60 segundos, luego facturado en incrementos de 1 segundo.",
    "Force Password Reset": "Forzar restablecimiento de contraseña",
    "Force password change": "Forzar cambio de contraseña",
    "Forced": "Forzado",
    "Forced: An agent joins a queue automatically on check in": "Forzado: Un agente se une a una cola automáticamente al registrarse",
    "Forgot Password?": "¿Olvidó su contraseña?",
    "Forgot password description": "Ingrese el correo electrónico asociado con su cuenta y obtenga un enlace para restablecer su contraseña.",
    "Forgot your password?": "¿Olvidó su contraseña?",
    "Forward": "Reenviar",
    "Found numbers": "{count, plural, one {# número encontrado} other {# números encontrados}}",
    "Free": "Gratis",
    "From": "Desde",
    "From now": "Desde ahora",
    "General": "General",
    "General information": "Información general",
    "Get Started": "Comenzar",
    "Get Started For Free": "Comienza gratis",
    "Get Verified": "Verificar cuenta",
    "Get started with your new number ": "Comienza con tu nuevo número ",
    "Getting number...": "Obteniendo número...",
    "Go to first page": "Ir a la primera página",
    "Go to last page": "Ir a la última página",
    "Go to next page": "Ir a la siguiente página",
    "Go to previous page": "Ir a la página anterior",
    "Google": "Google",
    "Google Authenticator": "Google Authenticator",
    "Google Authenticator code": "Código de Google Authenticator",
    "Greeting": "Saludo",
    "Greeting is required": "Se requiere saludo",
    "Greeting long": "Saludo largo",
    "Greeting short": "Saludo corto",
    "Group": "Grupo",
    "Group Name": "Nombre del grupo",
    "Hangup Cause": "Causa de colgado",
    "Header": "Encabezado",
    "Header Title": "Título del encabezado",
    "Hebrew": "Hebreo",
    "Hello": "Hola",
    "Help us minimize the risk of fraud on your account": "Ayúdanos a minimizar el riesgo de fraude en tu cuenta.",
    "Hide filters": "Ocultar filtros",
    "High": "Alto",
    "Hold": "Esperar",
    "Hours": "{value} horas",
    "How calls are distributed in the queue to available agents": "Cómo se distribuyen las llamadas en la cola a los agentes disponibles.",
    "ID": "ID",
    "ID Verification": "Verificación de identidad",
    "ID Verification coming soon": "Verificación de ID próximamente...",
    "ID Verification description": "Ayúdanos a minimizar el riesgo de fraude en tu cuenta.",
    "ID Verification full description": "Usamos Stripe Identity para la verificación de ID. Para prevenir el fraude, requerimos la verificación de ID si deseas hacer o recibir llamadas telefónicas. También puedes configurar esto más tarde en la página de tu perfil.",
    "ID Verification:": "Verificación de ID:",
    "IP:port": "IP:puerto",
    "IPv4": "IPv4",
    "IPv4 range": "Rango IPv4",
    "IPv4, Range or CIDR": "IPv4, Rango o CIDR",
    "Idle": "Inactivo",
    "Idle time": "Tiempo inactivo",
    "If Replay greeting is missing it will be played multiple times": "Si falta el saludo repetido, se reproducirá varias veces",
    "If a match is found, stop applying the next rules": "Si se encuentra una coincidencia, dejar de aplicar las siguientes reglas.",
    "If the agent goes over the time limit, the manager is notified, and the agent's timer gets highlighted in red": "Si el agente supera el límite de tiempo, se notifica al gerente y el temporizador del agente se resalta en rojo",
    "If you don't set up your two-factor authentication (TFA) now, you will need to do it the next time you log in": "Si no configuras tu autenticación de dos factores (TFA) ahora, tendrás que hacerlo la próxima vez que inicies sesión",
    "Immediately": "Inmediatamente",
    "In the meantime, find us on": "Mientras tanto, encuéntranos en",
    "Included": "Incluido",
    "Inbound": "Entrante",
    "Inbound Calls": "Llamadas entrantes",
    "Inbound Cost": "Costo entrante",
    "Inbound SMS": "SMS entrante",
    "Inbound calls": "Llamadas entrantes",
    "Inbound external": "Entrada externa",
    "Inbound internal": "Entrada interna",
    "Inbound queue": "Cola entrante",
    "Include in reports": "Incluir en informes",
    "Increment": "Incremento",
    "Industry": "Industria",
    "Industry *": "Industria *",
    "Info": "Información",
    "Init Incr": "Incremento inicial",
    "Initial Increment": "Incremento inicial",
    "Input": "Entrada",
    "Insert Token": "Insertar token",
    "Instantly add funds to your account": "Agrega fondos a tu cuenta al instante",
    "Integrates with some of the most popular CRMs": "Se integra con algunos de los CRMs más populares.",
    "Integration": "Integración",
    "Integrations": "Integraciones",
    "Inter digit": "Inter-dígito",
    "Inter digit timeout": "Tiempo de espera entre dígitos",
    "Intercept Groups": "Grupos de interceptación",
    "Intercept other groups": "Interceptar otros grupos",
    "Internal Calls": "Llamadas internas",
    "Internal calls": "Llamadas internas",
    "Interval": "Intervalo",
    "Intro audio": "Audio introductorio",
    "Invalid amount": "Cantidad inválida",
    "Invalid audio": "Audio inválido",
    "Invalid code": "Código inválido",
    "Invalid color": "Color inválido",
    "Invalid number": "Número inválido",
    "Invalid phone number": "Número de teléfono no válido",
    "Invalid selection audio": "Audio de selección inválida",
    "Invalid sound": "Sonido inválido",
    "Invalid type for number": "Tipo de número no válido",
    "Invitation 2FA description": "La persona que te invitó requiere que tengas la autenticación de dos factores habilitada. Escanea el código QR a continuación utilizando la aplicación Google Authenticator para mejorar la seguridad.",
    "Invitations": "Invitaciones",
    "Invitations description": "Gestionar usuarios invitados y su estado",
    "Invite Sent": "Invitación enviada",
    "Invite created, email not sent": "Invitación creada, correo no enviado",
    "Invited At": "Invitado el",
    "Invoice": "Factura",
    "Invoice Total": "Total de la factura",
    "Invoice number": "Número de factura",
    "Invoices": "Facturas",
    "Is agent": "Es agente",
    "Is required": "{field} es obligatorio.",
    "It can repeat instructions, without the welcome message": "Puede repetir las instrucciones, sin el mensaje de bienvenida",
    "It uses a high-speed internet connection to connect to a VoIP service provider": "Utiliza una conexión de internet de alta velocidad para conectarse a un proveedor de servicios VoIP.",
    "It's paid until <b>{date}</b> and can be reactivated until then": "Está pagado hasta <b>{date}</b> y puede reactivarse hasta entonces",
    "Join / leave by time group": "Unirse / salir por grupo de tiempo",
    "Join Option": "Opción de unirse",
    "Join option": "Opción de unirse",
    "Join/Leave Time Group": "Unirse/Salir del grupo de tiempo",
    "Keep Local File": "Mantener archivo local",
    "Keep editing": "Seguir editando",
    "Key": "Tecla",
    "Labels": "Etiquetas",
    "Labels or keywords for easier management, sorting, or categorization": "Etiquetas o palabras clave para facilitar la gestión, clasificación o categorización.",
    "Lang": "Idioma",
    "Language": "Idioma",
    "Language of the dynamic audio": "Idioma del audio dinámico",
    "Last Login": "Último acceso",
    "Last Name": "Apellido",
    "Last Reg": "Última reg.",
    "Last Update": "Última actualización",
    "Last name": "Apellido",
    "Last name *": "Apellido *",
    "Lead Link Url": "URL del enlace de cliente potencial",
    "Leave your number for exclusive updates:": "Deja tu número para actualizaciones exclusivas:",
    "Length": "Longitud",
    "Length of the digit inputs": "Longitud de las entradas de dígitos",
    "Less filters": "Menos filtros",
    "Let's talk": "Hablemos",
    "Let's verify your email": "Verifiquemos su correo electrónico",
    "Level": "Nivel",
    "Level wait time": "Tiempo de espera por nivel",
    "Linked Inbox": "Bandeja de entrada vinculada",
    "Listen": "Escuchar",
    "Listen to Own Calls Recordings": "Escuchar grabaciones de mis llamadas",
    "Listening": "Escuchando",
    "Live": "En vivo",
    "Live Calls": "Llamadas en vivo",
    "Live calls": "Llamadas en vivo",
    "Location": "Ubicación",
    "Log Out": "Cerrar sesión",
    "Log in": "Iniciar sesión",
    "Log in to your account": "Iniciar sesión en su cuenta",
    "Log out all users": "Cerrar sesión de todos los usuarios",
    "Log user out": "Cerrar sesión del usuario",
    "Log users out": "Cerrar sesión de los usuarios",
    "Logging out": "Cerrando sesión",
    "Logging you out": "Cerrando sesión",
    "Login": "Iniciar sesión",
    "Login & SIP registration by countries and/or IP ranges": "Inicio de sesión y registro SIP por países y/o rangos de IP",
    "Login Access": "Acceso de inicio de sesión",
    "Logout": "Cerrar sesión",
    "Logs for all previous calls": "Registros de todas las llamadas anteriores",
    "Longest Idle Agent": "Agente más inactivo",
    "Longest Waiting Call": "Llamada con mayor tiempo de espera",
    "Longest waiting call": "Llamada en espera más larga",
    "Low": "Bajo",
    "Low balance threshold": "Umbral de saldo bajo",
    "Lower than Range Start": "Menor que el inicio del rango",
    "Lowercase letters (a-z)": "Letras minúsculas (a-z)",
    "MB": "MB",
    "MIN": "MIN",
    "MP3 Call Recording": "Grabación de llamadas en MP3",
    "MP3 call recordings Storage": "Almacenamiento de grabaciones de llamadas en MP3",
    "Mac": "Mac",
    "Mail": "Correo",
    "Main audio": "Audio principal",
    "Main greeting": "Saludo principal",
    "Make default": "Establecer como predeterminado",
    "Make default card": "Establecer como tarjeta predeterminada",
    "Makes and receives calls": "Realiza y recibe llamadas.",
    "Making calls, receiving calls, voicemail, email, ring groups, class-5 telephone switch": "Hacer llamadas, recibir llamadas, correo de voz, correo electrónico, grupos de timbre, conmutador telefónico clase 5.",
    "Manage IVRs": "Gestionar IVRs",
    "Manage accounts": "Gestionar cuentas",
    "Manage all the users for this account": "Gestionar todos los usuarios para esta cuenta.",
    "Manage all your phones (softphones or physical) in one place": "Gestiona todos tus teléfonos (softphones o físicos) en un solo lugar.",
    "Manage incoming calls when all lines are busy or agents are unavailable": "Gestionar llamadas entrantes cuando todas las líneas están ocupadas o los agentes no están disponibles.",
    "Manage numbers, check details, and define call routing per number.": "Manage numbers, check details, and define call routing per number.",
    "Manage teams": "Gestionar equipos.",
    "Manage the account's general settings": "Gestionar la configuración general de la cuenta.",
    "Manage the company info and settings": "Gestionar la información y configuración de la empresa.",
    "Manage the list of dial rules affecting the calls": "Gestionar la lista de reglas de marcado que afectan las llamadas",
    "Manage the list of statuses an agent can have": "Gestionar la lista de estados que un agente puede tener",
    "Manage the profile info and settings": "Gestiona la información y configuración del perfil.",
    "Manage timegroups and their destinations": "Gestionar grupos de tiempo y sus destinos",
    "Manage user data and settings": "Administrar los datos y configuraciones del usuario",
    "Manage your company profile, payment plans and security": "Gestiona el perfil de tu empresa, planes de pago y seguridad.",
    "Management Emails": "Correos electrónicos de administración",
    "Manages most financial aspects": "Gestiona la mayoría de los aspectos financieros.",
    "Manages the account": "Gestiona la cuenta.",
    "Manual": "Manual",
    "Manual: An agent joins a queue manually": "Manual: Un agente se une a una cola manualmente",
    "Mask All calls": "Enmascarar todas las llamadas",
    "Mask Inbound calls": "Enmascarar llamadas entrantes",
    "Mask Outbound calls": "Enmascarar llamadas salientes",
    "Mask phone number": "Enmascarar número de teléfono",
    "Mastercard": "Mastercard",
    "Match destination": "Destino con coincidencia",
    "Matched": "Coincidió",
    "Max": "Máx",
    "Max Channels": "Canales máximos",
    "Max N": "Max {n}",
    "Max N chars": "Debe tener como máximo {n} caracteres",
    "Max N for US/CA": "Max {n} for US/CA",
    "Max N labels": "Puedes añadir como máximo {n} etiquetas",
    "Max characters": "Máximo de {number} caracteres",
    "Max characters: 100": "Max characters: 100",
    "Max digit length": "Longitud máxima de dígitos",
    "Max digits": "Máximo de dígitos",
    "Max failures": "Máximo de fallos",
    "Max members": "Miembros máximos",
    "Max number of users for this account": "Número máximo de usuarios para esta cuenta.",
    "Max snooze number": "Número máximo de posponer",
    "Max time a caller will wait in the queue before being directed to the exit destination": "Tiempo máximo que un llamante esperará en la cola antes de ser dirigido al destino de salida.",
    "Max value": "El valor máximo es {max}",
    "Max wait time": "Tiempo máximo de espera",
    "Max wait time - no agents": "Tiempo máximo de espera - sin agentes",
    "Maximum call wait time": "Tiempo máximo de espera de llamada",
    "Media": "Medios",
    "Media File": "Archivo multimedia",
    "Media Files": "Archivos multimedia",
    "Media expired — no longer available.": "El contenido multimedia ha caducado — ya no está disponible.",
    "Media file is not used": "El archivo multimedia no se utiliza",
    "Medium": "Medio",
    "Member authentication": "Autenticación de miembros",
    "Message could not be delivered.": "No se pudo entregar el mensaje.",
    "Messages Per Day": "Messages Per Day",
    "Messages Per Hour": "Messages Per Hour",
    "Messages allocated disk space": "Espacio en disco asignado a mensajes",
    "Middle name": "Segundo nombre",
    "Min": "Mín",
    "Min N chars": "Debe tener al menos {n} caracteres",
    "Min value": "El valor mínimo es {min}",
    "Min. Subscription Period": "Período mínimo de suscripción",
    "Minute": "Minuto",
    "Minute Cost (Inbound)": "Costo por minuto (entrante)",
    "Minutes": "{value} minutos",
    "Mobile phone number should be in international format (e164)": "El número de teléfono móvil debe estar en formato internacional (e164)",
    "Module": "Módulo",
    "Module permissions": "Permisos del módulo",
    "Monitoring not available": "Monitoreo no disponible",
    "Monitors information without making changes": "Monitorea la información sin realizar cambios.",
    "Month": "Mes",
    "Monthly": "Mensual",
    "Monthly Cost": "Costo mensual",
    "Monthly Price": "Precio mensual",
    "Monthly Recurring": "Recurrente mensual",
    "Monthly cost": "Costo mensual",
    "Months": "{number} Meses",
    "Months count": "{count} Meses",
    "More actions": "Más acciones",
    "More filters": "Más filtros",
    "Music": "Música",
    "Music on hold": "Música en espera",
    "Must be a positive integer": "Must be a positive integer",
    "Mute on Join": "Silenciar al unirse",
    "My Company": "Mi empresa",
    "My Profile": "Mi perfil",
    "N/A": "N/D",
    "NAME": "NOMBRE",
    "Name": "Nombre",
    "Name is required": "El nombre es obligatorio",
    "Name of the Auto Attendant": "Nombre del asistente automático",
    "Name's inbox": "Bandeja de entrada de {name}",
    "Need an Account?": "¿Necesitas una cuenta?",
    "Need to add another card?": "¿Necesitas agregar otra tarjeta?",
    "New contact has been saved": "Se ha guardado el nuevo contacto",
    "New contact has been updated": "Se ha actualizado el nuevo contacto",
    "New endpoint": "Nuevo extremo",
    "New extension": "Nueva extensión",
    "New forward": "Nuevo reenvío",
    "New intercept group": "Nuevo grupo de interceptación",
    "New password": "Nueva contraseña",
    "New password must be different from current password": "La nueva contraseña debe ser diferente de la contraseña actual.",
    "New queue": "Nueva cola",
    "New time condition": "Nuevo horario comercial",
    "New time group": "Nuevo grupo de tiempo",
    "New voicemail - {vm_box_name} [{datetime}]": "Nuevo buzón de voz - {vm_box_name} [{datetime}]",
    "Next": "Siguiente",
    "Next Invoice Date": "Próxima fecha de factura",
    "Next billing": "Próxima facturación:",
    "No": "No",
    "No Answer": "Sin respuesta",
    "No Presets": "Sin preajustes",
    "No Repeat": "No repetir",
    "No SLA": "Sin SLA",
    "No agents assigned": "No hay agentes asignados",
    "No answer": "Sin respuesta",
    "No answer delay": "Retraso por no respuesta",
    "No countries found": "No se encontraron países",
    "No data to show": "No hay datos para mostrar",
    "No filters or search applied": "No se aplicaron filtros ni búsquedas",
    "No hardware and maintenance costs": "Sin costos de hardware y mantenimiento.",
    "No input max": "Máximo de intentos sin entrada",
    "No input threshold": "Umbral sin entrada",
    "No input wait time": "Tiempo de espera sin entrada",
    "No live calls": "No hay llamadas en vivo",
    "No match destination": "Destino sin coincidencia",
    "No numbers found": "No se encontraron números",
    "No payment method on record": "No hay método de pago registrado",
    "No results": "No hay resultados",
    "No results found": "No se encontraron resultados",
    "No state found": "No se encontró estado",
    "No templates found": "No se encontraron plantillas",
    "No timeout": "Sin tiempo de espera",
    "Nobody": "Nadie",
    "None": "Ninguno",
    "Not Matched": "No coincidió",
    "Not Verified": "No verificado",
    "Not checked-in": "No registrado",
    "Not in use": "No en uso",
    "Note": "Nota",
    "Notes": "Notas",
    "Notification Email": "Correo electrónico de notificaciones",
    "Number": "Número",
    "Number Range": "Rango de números",
    "Number is required": "El número es obligatorio",
    "Number of Agents In Queues": "Número de agentes en colas",
    "Number of Users": "Número de usuarios",
    "Number of agents ready for calls": "Número de agentes disponibles para llamadas",
    "Number of calls": "Número de llamadas",
    "Number of calls answered by agents": "Número de llamadas atendidas por agentes",
    "Number of users": "Número de usuarios:",
    "Number transformation rules": "Reglas de transformación de números",
    "Numbers": "Números",
    "Offline": "Desconectado",
    "Ok": "Ok",
    "On Call": "En llamada",
    "On Hold": "En espera",
    "On Pause": "En pausa",
    "On low balance": "Con saldo bajo",
    "One or more email addresses are invalid": "Una o más direcciones de correo electrónico son inválidas",
    "One or more names are invalid": "Uno o más nombres son inválidos",
    "One time password": "Contraseña de un solo uso",
    "One time password is required": "Se requiere una contraseña de un solo uso",
    "One time password must be 6 characters": "La contraseña de un solo uso debe tener 6 caracteres",
    "One time password must be 6 characters long": "La contraseña de un solo uso debe tener 6 caracteres",
    "One-time": "Una vez",
    "One-time password": "Contraseña de un solo uso",
    "Online": "En línea",
    "Oops! This page does not exist": "¡Vaya! Esta página no existe",
    "Open menu": "Abrir menú",
    "Operating time": "Tiempo de operación",
    "Options": "Opciones",
    "Organization admin": "Administrador de la organización",
    "Organization owner": "Propietario de la organización",
    "Other": "Otro",
    "Other Industry": "Otra industria",
    "Our customer service will email you to get the required details and documents": "Nuestro servicio de atención al cliente le enviará un correo electrónico para obtener los datos y documentos necesarios",
    "Our team will contact you shortly with next steps on the port-in request": "Nuestro equipo se pondrá en contacto con usted en breve con los próximos pasos de la solicitud de portabilidad",
    "Outbound": "Saliente",
    "Outbound Calls": "Llamadas salientes",
    "Outbound SMS": "SMS saliente",
    "Outbound calls": "Llamadas salientes",
    "Outbound external": "Salida externa",
    "Outbound internal": "Salida interna",
    "Outro audio": "Audio de salida",
    "Override endpoint parameters": "Anular parámetros del extremo",
    "Overrides": "Anulaciones",
    "Overwrite account settings": "Sobrescribir configuraciones de cuenta",
    "Owner Email": "Correo electrónico del propietario",
    "PIN": "PIN",
    "PRICE": "PRECIO",
    "Pagination message": "{current_page} de {last_page}",
    "Paid Until": "Pagado hasta",
    "Paid Untill": "Pagado hasta",
    "Parameters": "Parámetros",
    "Part": "Parte {index}",
    "Password": "Contraseña",
    "Password *": "Contraseña *",
    "Password Reset Confirmation": "Confirmación de restablecimiento de contraseña",
    "Password Reset Successfully": "Contraseña restablecida con éxito",
    "Password confirmation": "Confirmación de contraseña",
    "Password confirmation doesn’t match the new password": "La confirmación de la contraseña no coincide con la nueva contraseña.",
    "Password expiration period": "Período de caducidad de la contraseña",
    "Password must be at least 6 characters": "La contraseña debe tener al menos 6 caracteres",
    "Password must be at least 8 characters long": "La contraseña debe tener al menos 8 caracteres",
    "Password must be at most 25 characters long": "La contraseña debe tener como máximo 25 caracteres",
    "Password must be minimum 8 characters and should contain numbers letters and uppercase letters": "La contraseña debe tener un mínimo de 8 caracteres y debe contener números, letras y mayúsculas",
    "Password must contain at least 1 digit": "La contraseña debe contener al menos un dígito",
    "Password must contain at least 1 lowercase letter": "La contraseña debe contener al menos una letra minúscula",
    "Password must contain at least 1 special symbol": "La contraseña debe contener al menos un símbolo especial",
    "Password must contain at least 1 uppercase letter": "La contraseña debe contener al menos una letra mayúscula",
    "Password must include": "La contraseña debe incluir:",
    "Password must include:": "La contraseña debe incluir:",
    "Password must not contain spaces": "La contraseña no debe contener espacios",
    "Password repeat": "Repetir contraseña",
    "Password successfully changed": "Contraseña cambiada con éxito",
    "Password was copied": "La contraseña fue copiada",
    "Passwords do not match": "Las contraseñas no coinciden",
    "Pause": "Pausa",
    "Pause time": "Tiempo de pausa",
    "Pauses": "Pausas",
    "Pay": "Pagar",
    "Payment method": "Método de pago",
    "Payment methods": "Métodos de pago",
    "Payment methods associated with your account": "Métodos de pago asociados con tu cuenta.",
    "Payments": "Pagos",
    "Pending": "Pendiente",
    "Pending Removal": "Eliminación pendiente",
    "Pending email": "Correo pendiente",
    "Period": "Período",
    "Period ends": "El periodo termina",
    "Permission": "Permiso",
    "Personal": "Personal",
    "Phone": "Teléfono",
    "Phone (optional)": "Teléfono (opcional)",
    "Phone *": "Teléfono *",
    "Phone Call Extension": "Extensión de llamada telefónica",
    "Phone Code": "Código de teléfono",
    "Phone Code *": "Código de teléfono *",
    "Phone No": "Número de teléfono",
    "Phone Number": "Número de teléfono",
    "Phone Numbers": "Números de teléfono",
    "Phone Support": "Soporte telefónico",
    "Phone inactivity": "Inactividad del teléfono",
    "Phone number": "Número de teléfono",
    "Phone number not provided": "Número de teléfono no proporcionado",
    "Pin Retries": "Reintentos de PIN",
    "Plan Successfully Changed": "Plan cambiado con éxito",
    "Play Name": "Reproducir nombre",
    "Play sound on call connection": "Reproducir sonido al conectar la llamada",
    "Play sound on call disconnection": "Reproducir sonido al desconectar la llamada",
    "Play sound when the call is connected": "Reproducir sonido cuando la llamada se conecte",
    "Play sound when the call is disconnected": "Reproducir sonido cuando la llamada se desconecte",
    "Please Search again": "Por favor, busca de nuevo",
    "Please add a payment method!": "¡Por favor agrega un método de pago!",
    "Please add at least one node": "Por favor, agrega al menos un nodo",
    "Please add at least one rule": "Por favor, agrega al menos una regla",
    "Please check in to WebDialer first to make calls": "Primero regístrate en WebDialer para realizar llamadas",
    "Please choose a new password for your account": "Por favor, elija una nueva contraseña para su cuenta",
    "Please choose user or groups": "Por favor elija usuario o grupos",
    "Please complete the captcha by ticking the checkbox": "Por favor, completa el captcha marcando la casilla.",
    "Please ensure the link from the email is valid": "Por favor, asegúrese de que el enlace del correo electrónico sea válido",
    "Please enter a valid": "Por favor ingrese un {what} válido",
    "Please enter a valid URL": "Por favor ingresa una URL válida, ej. 'https://www.example.com'",
    "Please enter a valid credit card": "Por favor ingrese una tarjeta de crédito válida",
    "Please enter a valid email": "Por favor ingrese un correo electrónico válido",
    "Please enter a valid email or username": "Por favor ingrese un correo electrónico o nombre de usuario válido",
    "Please enter a valid username or email": "Por favor ingrese un nombre de usuario o correo electrónico válido",
    "Please enter an username": "Por favor ingrese un nombre de usuario",
    "Please enter the company name": "Por favor ingrese el nombre de la compañía",
    "Please enter the subdomain": "Por favor ingrese el subdominio",
    "Please enter your company address": "Por favor ingrese la dirección de su compañía",
    "Please enter your company city": "Por favor ingrese la ciudad de su compañía",
    "Please enter your company country": "Por favor ingrese el país de su compañía",
    "Please enter your company postal code": "Por favor ingrese el código postal de su compañía",
    "Please enter your country": "Por favor ingrese su país",
    "Please enter your first name": "Por favor ingrese su nombre",
    "Please enter your last name": "Por favor ingrese su apellido",
    "Please fill in time row(s)": "Por favor complete la(s) fila(s) de tiempo",
    "Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy": "Por favor, indique que ha leído y está de acuerdo con los Términos y Condiciones y la Política de Privacidad",
    "Please let me know what I can help with, I’ll do my best to answer based on the documentation.": "Please let me know what I can help with, I’ll do my best to answer based on the documentation.",
    "Please provide a valid phone number": "¡Por favor, proporciona un número de teléfono válido!",
    "Please search phone numbers": "Busque números de teléfono",
    "Please select a role": "Por favor seleccione un rol",
    "Please select a top up amount": "Por favor seleccione un monto de recarga",
    "Please select a value": "Por favor seleccione un valor",
    "Please select any row first": "Por favor seleccione una fila primero",
    "Please select at least one endpoint": "Por favor seleccione al menos un extremo",
    "Please select at least one user": "Por favor seleccione al menos un usuario",
    "Please select destination type": "Por favor seleccione el tipo de destino",
    "Please select the role": "Por favor, seleccione el rol",
    "Please select the strategy": "Por favor seleccione la estrategia",
    "Please select time group": "Por favor seleccione el grupo de tiempo",
    "Please set up Two-Factor Authentication (TFA) to continue using the application": "Configura la autenticación de dos factores (TFA) para continuar usando la aplicación",
    "Please set up Two-Factor Authentication (TFA) to continue using the application Scan the QR code below using the Google Authenticator app to enhance security": "Configura la autenticación de dos factores (TFA) para continuar usando la aplicación. Escanea el código QR a continuación usando la aplicación Google Authenticator para mejorar la seguridad",
    "Please set up a payment method": "¡Por favor, configura un método de pago!",
    "Please sign in again to resume your session": "Por favor, inicia sesión nuevamente para reanudar tu sesión.",
    "Please tell us where your company is located": "Por favor, indíquenos dónde se encuentra su empresa",
    "Please try again": "Por favor, inténtalo de nuevo.",
    "Please try different filters": "Por favor, intenta con diferentes filtros",
    "Please verify your phone number": "Verifique su número de teléfono",
    "Port-In Limit Exceeded": "Límite de portabilidad excedido",
    "Port-In Number": "Número de portabilidad",
    "Port-In Numbers": "Números de portabilidad",
    "Port-in is limited to N phone numbers": "La portabilidad está limitada a N números de teléfono",
    "Port-in request Submitted": "Solicitud de portabilidad enviada",
    "Position": "Posición",
    "Position On Page": "Posición en la página",
    "Post Format": "Formato de publicación",
    "Post format": "Formato de publicación",
    "Pre-Bridge Announcement": "Anuncio previo al puente",
    "Pre-Bridge Announcement is required": "Se requiere un anuncio previo al puente",
    "Predictive Auto Dialer": "Marcador automático predictivo",
    "Prefix": "Prefijo",
    "Prefix/Number": "Prefijo/Número",
    "Preset: Adds CODE prefix": "Preajuste: Agrega el prefijo {country_code}",
    "Presets": "Preajustes",
    "Prev": "Anterior",
    "Price": "Precio",
    "Price / User": "Precio / Usuario",
    "Price / user": "Precio / usuario:",
    "Private": "Privado",
    "Private contact": "Contacto privado",
    "Profile Details": "Detalles del perfil",
    "Profile updated": "Perfil actualizado",
    "Progressive": "Progresivo",
    "Progressive / Preview": "Progresivo / Vista previa",
    "Progressive / Preview / Predictive": "Progresivo / Vista previa / Predictivo",
    "Progressive Auto Dialer": "Marcador automático progresivo",
    "Prorated": "Prorrateado",
    "Prorated Cost": "Costo prorrateado",
    "Provide your answer here": "Proporcione su respuesta aquí",
    "Province": "Provincia",
    "Provision": "Provisión",
    "Purchase Successful": "Compra exitosa",
    "Quantity": "Cantidad",
    "Quantity must be greater than 0": "La cantidad debe ser mayor que 0",
    "Quantity must be less than or equal to": "La cantidad debe ser menor o igual a",
    "Quantity must be less than or equal to stock": "La cantidad debe ser menor o igual al inventario",
    "Question": "Pregunta {number}",
    "Queue": "Cola",
    "Queue Calls": "Llamadas en cola",
    "Queues": "Colas",
    "Random": "Aleatorio",
    "Range": "Rango",
    "Rate Group": "Grupo de tarifas",
    "Reapply": "Reaplicar",
    "Reason for rejection": "Motivo del rechazo",
    "Reboot": "Reiniciar",
    "Reboot command sent": "Comando de reinicio enviado",
    "Record Calls": "Grabar llamadas",
    "Record calls": "Grabar llamadas",
    "Record stereo": "Grabar en estéreo",
    "RegExp": "Expresión regular",
    "Regenerate": "Regenerar",
    "Regenerate hash": "Regenerate hash",
    "Regex rules": "Reglas de regex",
    "Register invite description": "Gracias por aceptar la invitación. Ayúdanos a configurar tu cuenta.",
    "Registered": "Registrado",
    "Registration Domain": "Dominio de registro",
    "Registration domain": "Dominio de registro",
    "Registration domain was copied": "El dominio de registro fue copiado",
    "Regular expression": "Expresión regular",
    "Reject delay": "Retraso por rechazo",
    "Remove": "Eliminar",
    "Repeat": "Repetir",
    "Repeat Password": "Repetir contraseña",
    "Replace": "Reemplazar",
    "Replace / Type": "Reemplazar / Tipo",
    "Replay audio": "Repetir audio",
    "Replay greeting": "Repetir saludo",
    "Reports": "Informes",
    "Require 2FA": "Requerir autenticación de dos factores",
    "Require 2FA description": "Cuando esté habilitado, se requerirá que el usuario configure la autenticación de dos factores al crear su cuenta.",
    "Require two-Factor Authentication for all users": "Requerir autenticación de dos factores para todos los usuarios",
    "Required": "Obligatorio",
    "Required documents": "Documentos requeridos",
    "Required information": "Información requerida",
    "Resend": "Reenviar",
    "Resend Code": "Reenviar código {seconds}",
    "Resend Invitation ?": "¿Reenviar invitación?",
    "Resend invitation description": "Al reenviar, el usuario recibirá un nuevo correo de invitación. ¿Está seguro de que desea reenviar?",
    "Reserve": "Reservar",
    "Reserved: A manager adds/removes an agent from a queue that is only visible to the manager": "Reservado: Un gerente agrega/elimina un agente de una cola que solo es visible para el gerente",
    "Reset Password": "Restablecer contraseña",
    "Reset password": "Restablecer contraseña",
    "Reset password description": "Elija una nueva contraseña para su cuenta.",
    "Reset your password": "Restablezca su contraseña",
    "Restore Phone Number": "Restaurar número de teléfono",
    "Restrict by Countries and IP Ranges": "Restringir por países y rangos de IP",
    "Result": "Resultado",
    "Return to login": "Volver al inicio de sesión",
    "Review": "Revisar",
    "Review cart": "Revisar carrito",
    "Revoke Access": "Revocar acceso",
    "Ring": "Timbre",
    "Ring & Endpoints": "Timbre y extremos",
    "Ring All": "Llamar a todos",
    "Ring Group": "Grupo de timbre",
    "Ring Group name": "Nombre del grupo de timbre",
    "Ring Groups": "Grupos de timbre",
    "Ring groups": "Grupos de timbre",
    "Ringback Tone": "Tono de retorno de llamada",
    "Role": "Rol",
    "Roles": "Roles",
    "Roles & Permissions": "Roles y permisos",
    "Roles available in the application": "Roles disponibles en la aplicación",
    "Round Robin": "Ronda Robin",
    "Routes": "Rutas",
    "Routing": "Enrutamiento",
    "Rows per page": "Filas por página",
    "Rules": "Reglas",
    "SIP Desk Phones": "Teléfonos de escritorio SIP",
    "SIP Domain": "Dominio SIP",
    "SIP Domain hint": "Introdúzcalo en el campo Domain o Registrar del teléfono.",
    "SIP Server": "Servidor SIP",
    "SIP Server hint": "Introdúzcalo en el campo Outbound Proxy o Server del teléfono.",
    "SIP IP": "IP SIP",
    "SLA": "SLA",
    "SLA Calls / (Total Calls - Abandoned in SLA)": "Llamadas SLA / (Total de llamadas - Abandonadas en SLA)",
    "SLA Calls / Total Calls": "Llamadas SLA / Total de llamadas",
    "SLA Strategy": "Estrategia SLA",
    "SLA Strategy Explanation": "Explicación de la estrategia SLA",
    "SLA formula": "Fórmula SLA",
    "SLA target": "Objetivo SLA",
    "SMS": "SMS",
    "SMS Caller ID": "Identificador de llamadas en SMS",
    "SMS Forwarding": "Reenvío de SMS",
    "SMS caller ID": "Identificador de llamadas en SMS",
    "SMS default sender": "Remitente predeterminado de SMS",
    "SMS enabled": "SMS habilitado",
    "SMS sender names": "Nombres de remitentes de SMS",
    "STATUS": "ESTADO",
    "Same as contact info": "Igual que la información de contacto",
    "Save": "Guardar",
    "Save Contact": "Guardar contacto",
    "Saving...": "Guardando…",
    "Say hello to your new PBX number!": "¡Saluda a tu nuevo número PBX!",
    "Scan QR code warning": "Por favor, confirma que has escaneado el código QR con tu aplicación de autenticación. Siempre puedes configurar la autenticación de dos factores más tarde en tu perfil.",
    "Scan the QR code below using the Google Authenticator app to enhance security": "Escanee el código QR a continuación utilizando la aplicación Google Authenticator para mejorar la seguridad.",
    "Search": "Buscar",
    "Second(s)": "Segundo(s)",
    "Seconds": "{value} segundos",
    "Security": "Seguridad",
    "Security Email": "Correo electrónico de seguridad",
    "See Requirements & Disclaimers": "Ver requisitos y avisos legales",
    "See transcription": "Ver transcripción",
    "Select": "Seleccionar",
    "Select Destination Route": "Seleccione ruta de destino",
    "Select Greeting": "Seleccionar saludo",
    "Select Role": "Seleccionar rol",
    "Select Site": "Seleccionar sitio",
    "Select Strategy": "Seleccionar estrategia",
    "Select a question": "Seleccionar una pregunta",
    "Select a template": "Seleccionar una plantilla",
    "Select call type": "Seleccionar tipo de llamada",
    "Select country": "Seleccionar país",
    "Select date": "Seleccionar fecha",
    "Select date to simulate": "Seleccione la fecha para simular",
    "Select days": "Seleccionar días",
    "Select destination": "Seleccionar destino",
    "Select inbox": "Seleccionar bandeja de entrada",
    "Select industry": "Seleccione la industria",
    "Select join option": "Seleccionar opción de unirse",
    "Select language": "Seleccionar idioma",
    "Select state": "Seleccione el estado",
    "Select type": "Seleccionar tipo",
    "Selected": "Seleccionado",
    "Send": "Enviar",
    "Send Code": "Enviar código",
    "Send Code Via SMS": "Enviar código por SMS",
    "Send Code Via WhatsApp": "Enviar código por WhatsApp",
    "Send Invite": "Enviar invitación",
    "Send SMS": "Enviar SMS",
    "Send an SMS starting at": "Envía un SMS a partir de",
    "Send code in email": "Enviar código por correo electrónico",
    "Send recovery email": "Enviar correo de recuperación",
    "Send test email": "Enviar correo de prueba",
    "Sending Rate": "Sending Rate",
    "Sending SMS in the US & Canada": "Envío de SMS en EE. UU. y Canadá",
    "Sent Count": "Contador de envíos",
    "Sequentially By Agent Order": "Secuencialmente por orden de agente",
    "Sequentially By Next Agent Order": "Secuencialmente por el siguiente orden de agente",
    "Service Level Agreement (SLA)": "Acuerdo de nivel de servicio (SLA)",
    "Service level for a selected strategy": "Nivel de servicio para una estrategia seleccionada",
    "Set New Password": "Establecer nueva contraseña",
    "Set by agent": "Establecido por el agente",
    "Set password expiration": "Establecer expiración de contraseña",
    "Set the group members who will receive calls when they ring for another user in the group": "Configura los miembros del grupo que recibirán llamadas cuando llamen a otro usuario en el grupo.",
    "Set up later": "Configurar más tarde",
    "Set your password": "Establezca su contraseña",
    "Settings": "Configuraciones",
    "Settings applied to the whole account": "Configuraciones aplicadas a toda la cuenta",
    "Setup": "Configuración",
    "Setup Your new password": "Configurar su nueva contraseña",
    "Setup cost": "Costo de instalación",
    "Setup your security questions": "Configura tus preguntas de seguridad",
    "Should be a number": "{field} debe ser un número",
    "Should be a number between": "Debe ser un número entre {min} y {max}",
    "Should be a number with max digits": "Debe ser un número con un máximo de {digits} dígitos",
    "Show Deactivated Users": "Mostrar usuarios desactivados",
    "Show Draft Users": "Mostrar usuarios en borrador",
    "Show Estimated Wait Time": "Mostrar tiempo de espera estimado",
    "Show Invited Users": "Mostrar usuarios invitados",
    "Show Welcome Message After": "Mostrar mensaje de bienvenida después de",
    "Show filters": "Mostrar filtros",
    "Show password": "Mostrar contraseña",
    "Sign Up": "Regístrate",
    "Sign Up Verify email subtitle": "Mantenga su cuenta segura y verifique su correo electrónico. Ingrese el código enviado a {email}",
    "Sign Up and Start Calling": "Regístrese y comience a llamar",
    "Sign up with Google": "Registrarse con Google",
    "Simulate password expiration": "Simular expiración de contraseña",
    "Simultaneous": "Simultáneo",
    "Simultaneous calls": "Llamadas simultáneas",
    "Sip term status": "Estado del término SIP",
    "Sites": "Sitios",
    "Skip": "Omitir",
    "Skip Tiers with no Available Agents": "Omitir niveles sin agentes disponibles",
    "Skip Voicemail Operation Instructions": "Omitir instrucciones de operación del buzón de voz",
    "Skip greeting": "Omitir saludo",
    "Skip if variable is empty": "Omitir si la variable está vacía",
    "Skip levels with no available agents": "Omitir niveles sin agentes disponibles",
    "Some SBC hubs are unreachable; calls still route but redundancy is degraded": "Algunos hubs SBC no son accesibles; las llamadas siguen enrutándose pero la redundancia está degradada",
    "Something went wrong": "Algo salió mal.",
    "Something went wrong, please try again": "Algo salió mal, por favor intente de nuevo",
    "Sorry, the page you're looking for cannot be found": "Lo sentimos, la página que estás buscando no se puede encontrar",
    "Sound": "Sonido",
    "Sources:": "Sources:",
    "Special characters (!@#$%^&*)": "Caracteres especiales (!@#$%^&*)",
    "Special permissions": "Permisos especiales",
    "Specific exit destinations": "Destinos de salida específicos",
    "Speech": "Discurso",
    "Standard": "Estándar",
    "Standard Business Hours": "Horas comerciales estándar",
    "Standard DID": "DID estándar",
    "Start Chat": "Iniciar chat",
    "Start Date": "Fecha de inicio",
    "Start registration": "Iniciar registro",
    "Start time": "Hora de inicio",
    "Start topping up when the balance falls below this threshold": "Comienza a recargar cuando el saldo caiga por debajo de este umbral",
    "Start-up": "Start-up",
    "State": "Estado",
    "State / Province": "Estado / Provincia",
    "Status": "Estado",
    "Status name": "Nombre del estado",
    "Stock": "Inventario",
    "Stop Rule": "Detener regla",
    "Storage": "Almacenamiento",
    "Strategy": "Estrategia",
    "Street Address": "Dirección",
    "Street Address *": "Dirección *",
    "Stripe verification": "Usamos Stripe Identity para verificar tu ID. Por favor, haz clic en el botón de abajo para comenzar el proceso.",
    "Subdomain can only contain lower case letters and numbers": "El subdominio solo puede contener letras minúsculas y números",
    "Subdomain must be at least 3 characters": "El subdominio debe tener al menos 3 caracteres",
    "Subject": "Asunto",
    "Submit": "Enviar",
    "Submit Port-In Request": "Enviar solicitud de portabilidad",
    "Subscription Plan": "Plan de suscripción",
    "Subscriptions": "Suscripciones",
    "Success": "Éxito",
    "Suffix": "Sufijo",
    "Suite": "Suite",
    "Supervisor": "Supervisor",
    "Support Email": "Correo electrónico de soporte",
    "Support availability": "Disponibilidad de soporte",
    "Support channels": "Canales de soporte",
    "Support channels available to each plan": "Canales de soporte disponibles para cada plan.",
    "Supported formats": "Formatos compatibles",
    "Supports incoming SMS messages": "Admite mensajes SMS entrantes",
    "Supports outgoing SMS messages": "Admite mensajes SMS salientes",
    "Synced {count} template(s) from Meta": "Se sincronizaron {count} plantilla(s) de Meta",
    "System wait time for caller input, before prompting for next action": "Tiempo de espera del sistema para la entrada del llamante, antes de solicitar la siguiente acción.",
    "Tags": "Etiquetas",
    "Talk": "Hablar",
    "Talk time": "Talk time",
    "Target": "Objetivo",
    "Team": "Equipo",
    "Team Leader": "Líder de equipo",
    "Teams": "Equipos",
    "Technical Support Specialist": "Especialista en soporte técnico",
    "Technologies used in call centers to manage incoming calls and connect them with the most appropriate agent": "Tecnologías utilizadas en centros de llamadas para gestionar llamadas entrantes y conectarlas con el agente más adecuado.",
    "Tell us a bit about your company": "Cuéntenos un poco sobre su empresa.",
    "Tell us a bit more about your company": "Cuéntanos un poco más sobre tu compañía",
    "Template": "Plantilla",
    "Template deleted successfully": "Plantilla eliminada correctamente",
    "Template updated successfully": "Plantilla actualizada correctamente",
    "Templates": "Plantillas",
    "Testing area": "Área de pruebas",
    "Text color is used for the text and logo.": "Text color is used for the text and logo.",
    "Text is required for this type of media file": "Se requiere texto para este tipo de archivo multimedia",
    "Text to speech": "Texto a voz",
    "Thank you": "Gracias",
    "Thanks for you order, your DID numbers have been added to the list": "Gracias por tu pedido, tus números DID se han agregado a la lista.",
    "Thanks for you order, your phone numbers have been added to the list": "Gracias por tu pedido, tus números de teléfono han sido añadidos a la lista.",
    "The Date From must be before the Date To": "La fecha 'Desde' debe ser anterior a la fecha 'Hasta'.",
    "The Number has been Successfully Cancelled": "El número ha sido cancelado con éxito",
    "The Number has been Successfully Restored": "El número ha sido restaurado con éxito",
    "The Time To must be later than the Time From": "La hora 'Hasta' debe ser posterior a la hora 'Desde'.",
    "The account password has been updated": "La contraseña de la cuenta ha sido actualizada.",
    "The amount of time allotted for an agent to answer a call, before it's transferred to another agent": "El tiempo asignado para que un agente responda una llamada, antes de que se transfiera a otro agente.",
    "The card ending in will be charged for this amount": "La tarjeta que termina en {last4} será cargada por esta cantidad.",
    "The cost per minute of inbound calls on this phone number": "Costo por minuto de llamadas entrantes en este número de teléfono.",
    "The destination the call will be directed to, if any thresholds or limits are exceeded": "El destino al que se dirigirá la llamada, si se exceden los umbrales o límites",
    "The expected level of service for a queue defined by the strategy and target interval": "El nivel de servicio esperado para una cola definido por la estrategia y el intervalo objetivo.",
    "The input must be a number within the range of {min} to {max}, or the characters \"#\" or \"*\"": "La entrada debe ser un número dentro del rango de {min} a {max}, o los caracteres \"#\" o \"*\"",
    "The interval when support channels are available": "El intervalo en que los canales de soporte están disponibles.",
    "The invoice history for your subscription plan, top-ups, and DID numbers": "El historial de facturas de tu plan de suscripción, recargas y números DID",
    "The max number of times without any selection before the call is directed to the exit destination": "El número máximo de veces sin selección antes de que la llamada se dirija al destino de salida",
    "The maximum amount of time a caller waits when no agents are available before being directed to the exit destination": "El tiempo máximo que un llamante espera cuando no hay agentes disponibles antes de ser dirigido al destino de salida.",
    "The maximum length of this field": "La longitud máxima de este campo es {number}",
    "The maximum length of this field is 6": "La longitud máxima de este campo es 6",
    "The maximum number of times a caller can make an invalid input before being directed to the exit destination": "El número máximo de veces que un llamante puede hacer una entrada inválida antes de ser dirigido al destino de salida.",
    "The minimum billable call duration (in seconds) and the increment used for billing": "El período mínimo facturable de la llamada (en segundos) y el incremento utilizado para la facturación.",
    "The minimum commitment duration for which the phone number must be purchased": "La duración mínima de compromiso por la cual debe adquirirse el número de teléfono",
    "The minimum length for this field should be": "La longitud mínima para este campo debe ser {value}",
    "The new plan has been added to your account": "El nuevo plan ha sido añadido a tu cuenta",
    "The numbers will be activated after review and approval": "Los números se activarán tras la revisión y aprobación",
    "The password has been reset successfully": "La contraseña se ha restablecido con éxito",
    "The password must meet all requirements": "La contraseña debe cumplir con todos los requisitos.",
    "The reset will happen next time the member logs in": "El restablecimiento ocurrirá la próxima vez que el miembro inicie sesión",
    "The session is now closed": "La sesión está ahora cerrada",
    "The system will automatically dial numbers from uploaded list and connect leads with agents": "The system will automatically dial numbers from uploaded list and connect leads with agents.",
    "The time an agent has to answer a call before it’s transferred to another agent": "El tiempo que tiene un agente para responder una llamada antes de que se transfiera a otro agente.",
    "The type of destination the call will be directed to": "El tipo de destino al que se dirigirá la llamada",
    "The uploaded file is not an audio file": "El archivo subido no es un archivo de audio.",
    "The uploaded file is not an image": "El archivo seleccionado no es una imagen. Por favor, sube un archivo de imagen válido.",
    "The user has been created": "El usuario ha sido creado",
    "The username and password are automatically generated Use them to connect your phone": "El nombre de usuario y la contraseña se generan automáticamente. Úsalos para conectar tu teléfono.",
    "The uuid was copied:": "El UUID fue copiado:",
    "There are no available DID for selected country": "No hay DID disponibles para el país seleccionado",
    "There can be only one active session": "Solo puede haber una sesión activa",
    "There was a problem retrieving the numbers": "Hubo un problema al recuperar los números",
    "There's no transcription available for this call.": "No hay transcripción disponible para esta llamada.",
    "This balance is available for making phone calls": "Este saldo está disponible para hacer llamadas telefónicas.",
    "This is the URL assigned to your account": "Esta es la URL asignada a su cuenta",
    "This is the password used to log into this account": "Esta es la contraseña utilizada para iniciar sesión en esta cuenta.",
    "This member will need to change their password next time he logs into the app": "Este miembro necesitará cambiar su contraseña la próxima vez que inicie sesión en la aplicación",
    "This message shows up in a bubble above the widget icon, after the delay set here.": "This message shows up in a bubble above the widget icon, after the delay set here.",
    "This month": "Este mes",
    "This option is not available yet": "Esta opción aún no está disponible",
    "This name is already in use": "Este nombre ya está en uso",
    "This represents the number of users available in the current plan minus total number of account users (in any status)": "Esto representa el número de usuarios disponibles en el plan actual menos el número total de usuarios de la cuenta (en cualquier estado)",
    "This value is already taken": "Este valor ya está tomado",
    "This week": "Esta semana",
    "This will also remove your current auto top-up": "Esto también eliminará tu recarga automática actual",
    "This will send verification code to saved mobile": "Esto enviará un código de verificación al móvil guardado",
    "This will send verification code to the saved e-mail": "Esto enviará un código de verificación al correo electrónico guardado",
    "Threshold": "Umbral",
    "Thresholds": "Umbrales",
    "Tier": "Nivel",
    "Tier Rules Apply": "Aplicar reglas de nivel",
    "Tier rules": "Reglas de nivel",
    "Tier wait time": "Tiempo de espera por nivel",
    "Time": "Hora",
    "Time Condition": "Horario comercial",
    "Time Conditions": "Horario comercial",
    "Time Groups": "Grupos de tiempo",
    "Time base score": "Puntaje basado en tiempo",
    "Time condition": "Horario comercial",
    "Time condition name": "Nombre del horario comercial",
    "Time conditions": "Horario comercial",
    "Time from": "Hora desde",
    "Time group": "Grupo de tiempo",
    "Time groups": "Grupos de tiempo",
    "Time limit": "Límite de tiempo",
    "Time to": "Hora hasta",
    "Timeout": "Tiempo de espera",
    "Timeout destination": "Destino de tiempo de espera",
    "Timeouts": "Tiempos de espera",
    "Timezone": "Zona horaria",
    "Title": "Título",
    "To": "Para",
    "To be implemented": "Por implementar",
    "To start monitoring, your current call will be ended.": "Para comenzar a monitorear, su llamada actual será finalizada.",
    "Today": "Hoy",
    "Toggle": "Alternar",
    "Top Down": "De arriba a abajo",
    "Top up amount": "Monto de recarga",
    "Top-up": "Recargar",
    "Top-up now": "Recargar ahora",
    "Top-up successful": "Recarga exitosa",
    "Total": "Total",
    "Total Cost": "Costo total",
    "Total Live Calls": "Total de llamadas en vivo",
    "Total agents": "Total de agentes",
    "Total calls": "Total de llamadas",
    "Total daily activity time, encompassing all active, idle and pause periods": "Tiempo total de actividad diaria, que abarca todos los periodos activos, inactivos y de pausa",
    "Total daily pause duration, including both billable and non-billable pauses": "Duración total diaria de pausas, incluyendo pausas facturables y no facturables",
    "Total duration of ring time while attempting to contact customers": "Duración total del tiempo de timbre mientras se intenta contactar a los clientes",
    "Total number of calls": "Número total de llamadas",
    "Total talk time": "Total talk time",
    "Total time": "Tiempo total",
    "Total time the user was neither on the phone nor paused": "Tiempo total en que el usuario no estuvo en el teléfono ni en pausa",
    "Total wait time": "Tiempo total de espera",
    "Transcription Unavailable": "Transcripción no disponible",
    "Transcription generation has started.": "La generación de transcripción ha comenzado.",
    "Transcription in progress": "Transcripción en progreso",
    "Transcription unavailable": "Transcripción no disponible",
    "Two factor authentication": "Autenticación de dos factores",
    "Type": "Tipo",
    "Type Email": "Escriba el correo electrónico",
    "Type city": "Escribir ciudad",
    "Type email": "Escriba el correo electrónico",
    "Type name": "Escribir nombre",
    "Type notes": "Escribir notas",
    "Type placeholder": "Ingrese {what}",
    "UI inactivity": "Inactividad de la interfaz de usuario",
    "UNVERIFIED": "NO VERIFICADO",
    "URL": "URL",
    "UUID": "UUID",
    "UUID Copied": "UUID copiado",
    "Unable to process your request. Please try again later.": "Unable to process your request. Please try again later.",
    "Unanswered": "Sin respuesta",
    "Unavailable while account is under review": "No disponible mientras la cuenta está en revisión",
    "Unit Cost": "Costo por unidad",
    "Unknown": "Desconocido",
    "Unlimited": "Ilimitado",
    "Unlimited DID Channels": "Canales DID ilimitados",
    "Unlimited Users": "Usuarios ilimitados",
    "Unsupported file format": "Unsupported file format",
    "Up To Users": "Hasta {count} usuarios",
    "Update": "Actualizar",
    "Update media file": "Actualizar archivo multimedia",
    "Upgrade plan": "Mejorar plan",
    "Upload": "Subir",
    "Upon call answer, a voice recording is played to the agent before connecting to the caller": "Al responder la llamada, se reproduce una grabación de voz al agente antes de conectarse con el llamante",
    "Uppercase letters (A-Z)": "Letras mayúsculas (A-Z)",
    "Use Authentication app to generate code": "Usa la aplicación de autenticación para generar el código",
    "Use Google Authentificator": "Usa Google Authenticator",
    "Use Google authentificator to generate code": "Usa Google Authenticator para generar el código",
    "Use the code sent to your email address {email}": "Usa el código enviado a tu dirección de correo electrónico {email}",
    "Used by": "Usado por",
    "User": "Usuario",
    "User Name": "Nombre de usuario",
    "User Pin": "Pin de usuario",
    "User Profile Edit": "Editar perfil de usuario",
    "User agent": "Agente de usuario",
    "User created": "Usuario creado",
    "User has been successfully logged out": "El usuario ha cerrado sesión con éxito",
    "User password will be invalidated and a link to set a new password will be sent to the verified user Email and/or Phone": "La contraseña del usuario será invalidada y se enviará un enlace para establecer una nueva contraseña al correo electrónico y/o teléfono verificado.",
    "User type": "Tipo de usuario",
    "Username": "Nombre de usuario",
    "Username *": "Nombre de usuario *",
    "Users": "Usuarios",
    "Users & Roles": "Usuarios y roles",
    "Users / Endpoints": "Usuarios / Extremos",
    "Users has been successfully logged out": "Los usuarios han cerrado sesión correctamente",
    "Users override": "Anulación de usuarios",
    "Usually contains a welcome message and instructions": "Usualmente contiene un mensaje de bienvenida e instrucciones",
    "Usually, it repeats instructions, but without the welcome message": "Usualmente, repite las instrucciones, pero sin el mensaje de bienvenida",
    "Uuid": "Uuid",
    "VAT number": "Número de IVA",
    "VAT number (optional)": "Número de IVA (opcional)",
    "Value": "Valor",
    "Value is required": "El valor es obligatorio",
    "Value should start with": "El valor debe comenzar con $",
    "Variable": "Variable",
    "Variable '{name}' already in use": "La variable '{name}' ya está en uso",
    "Verified": "Verificado",
    "Verify Email": "Verificar correo electrónico",
    "Verify Mobile": "Verificar móvil",
    "Verify your ID": "Verifica tu ID",
    "Verifying user": "Estamos configurando su cuenta...",
    "View Invoices": "Ver facturas",
    "Virtual": "Virtual",
    "Visa": "Visa",
    "Voice": "Voz",
    "Voice Only Destinations": "Destinos solo de voz",
    "Voice is required": "La voz es obligatoria",
    "Voice with Fax Detection": "Voz con detección de fax",
    "Voicemail": "Buzón de voz",
    "Voicemail description": "Gestionar la lista de mensajes de voz.",
    "Wait": "Esperar",
    "Wait moderator": "Esperar moderador",
    "Waiting calls": "Llamadas en espera",
    "Wallboard": "Tablero",
    "Warning": "Advertencia",
    "We need a few details to set up your account": "Necesitamos algunos detalles para configurar su cuenta.",
    "We use encryption to make sure your calls stay private": "Usamos cifrado para asegurarnos de que sus llamadas permanezcan privadas.",
    "We value your interest and are eager to share it with you!": "Valoramos su interés y estamos ansiosos por compartirlo con usted",
    "We will soon be rolling out PBX, which is currently in its final stages of development": "Pronto lanzaremos PBX, que actualmente está en sus etapas finales de desarrollo",
    "We've automatically logged you out due to inactivity to safeguard your account": "Te hemos desconectado automáticamente por inactividad para proteger tu cuenta.",
    "We've sent you a SMS with verification code": "Le hemos enviado un SMS con el código de verificación",
    "We've sent you an email with further instructions": "Le hemos enviado un correo electrónico con más instrucciones",
    "We've sent you an email with verification code": "Le hemos enviado un correo electrónico con el código de verificación",
    "Web Domain": "Dominio web",
    "Web Phone": "Teléfono web",
    "Web Widget Builder": "Constructor de widget web",
    "WebDialer is not properly initialized": "WebDialer no está inicializado correctamente",
    "Webphone": "Teléfono web",
    "Website": "Sitio web",
    "Week count": "{count} Semana",
    "Welcome Message": "Mensaje de bienvenida",
    "We’ll send financial notifications to the email below": "Enviaremos notificaciones financieras al correo electrónico que aparece a continuación.",
    "When checked, the audio will play more than once": "Cuando esté marcado, el audio se reproducirá más de una vez",
    "When the balance falls below the threshold, top up to a target balance, example: top up until the balance is $50": "Cuando el saldo caiga por debajo del umbral, recargar hasta un saldo objetivo, por ejemplo: recargar hasta que el saldo sea de $50",
    "When the balance falls below the threshold, top-up with specified amount": "Cuando el saldo caiga por debajo del umbral, recargar con el monto especificado",
    "Whispering": "Susurrando",
    "Wrap up time (outbound)": "Tiempo de finalización (salientes)",
    "Wrap up time (queue)": "Tiempo de finalización (cola)",
    "Year count": "{count} Año",
    "Yes": "Sí",
    "Yes, I'm here": "Sí, estoy aquí",
    "Yes, delete": "Sí, eliminar",
    "Yes, discard": "Sí, descartar",
    "Yesterday": "Ayer",
    "You are about to cancel": "Estás a punto de cancelar",
    "You are about to invite as a team member": "Está a punto de invitar a {email} como miembro del equipo",
    "You are about to purchase": "Estás a punto de comprar {quantity} números DID por un total de {total}.",
    "You are about to restore": "Estás a punto de restaurar",
    "You are already in the call": "Ya estás en la llamada",
    "You are not checked-in": "No estás registrado",
    "You cannot delete the last payment method because you have an active subscription plan": "No puedes eliminar el último método de pago porque tienes un plan de suscripción activo.",
    "You have been logged out due to inactivity": "Has sido desconectado debido a inactividad",
    "You may enter multiple Emails, separated by Comma": "Puede ingresar varios correos electrónicos, separados por coma",
    "You need to check-in before listening to a call": "Debe registrarse antes de escuchar una llamada",
    "Active and invited users. Each one holds a seat on your plan.": "Usuarios activos e invitados. Cada uno ocupa un asiento en tu plan.",
    "You will automatically be logged out in <b>{seconds}s</b> due to inactivity": "Serás desconectado automáticamente en <b>{seconds}s</b> debido a inactividad",
    "You'll be among the first to receive a personal call from our team with all the details about our rollout": "Serás de los primeros en recibir una llamada personal de nuestro equipo con todos los detalles sobre nuestro lanzamiento",
    "Your Profile": "Tu perfil",
    "Your changes will be lost.": "Se perderán los cambios.",
    "Your current balance is below the set threshold": "Tu saldo actual está por debajo del umbral establecido.",
    "Your new business number is live. Call, text, and connect instantly.": "Tu nuevo número de negocio está activo. Llama, envía mensajes y conéctate al instante.",
    "ZIP / Postal code": "Código postal",
    "ZIP Code": "Código postal",
    "ZIP Code *": "Código postal *",
    "Zip / Postal Code": "Código postal",
    "Zip / Postal code": "Código postal",
    "activity time": "tiempo de actividad",
    "address": "dirección",
    "adds + to a number not starting with 0": "agrega + a un número que no comienza con 0",
    "adds the 123 prefix to the number": "agrega el prefijo 123 al número",
    "adds the 789 suffix to the number": "agrega el sufijo 789 al número",
    "admin email": "correo electrónico del administrador",
    "advanced": "avanzado",
    "advanced settings": "configuraciones avanzadas",
    "ai_first_message": "Hi {name}! How can I help you",
    "allowed countries": "países permitidos",
    "and": "y",
    "are listening": "están escuchando",
    "are whispering": "están susurrando",
    "billing": "facturación",
    "billing email": "correo electrónico de facturación",
    "by paying yearly": "pagando anualmente.",
    "call queues": "colas de llamadas",
    "call recording": "grabación de llamadas",
    "call talk time": "tiempo de conversación",
    "calls stats": "estadísticas de llamadas",
    "cancel plan": "cancelar plan",
    "city": "ciudad",
    "company": "empresa",
    "company address": "dirección de la empresa",
    "company name": "nombre de la empresa",
    "copied_to_clipboard": "Copiado al portapapeles.",
    "copy_failed": "Error al copiar",
    "core": "básico",
    "counter of": "{start} de {end}",
    "country": "país",
    "credit": "crédito",
    "current balance": "saldo actual",
    "current plan": "plan actual",
    "debit": "débito",
    "default": "predeterminado",
    "default card": "tarjeta predeterminada",
    "description": "descripción",
    "digit": "dígito",
    "email": "correo electrónico",
    "email or username": "correo electrónico o nombre de usuario",
    "enterprise": "empresa",
    "essential": "esencial",
    "ext_card_description": "Install the extension to instantly start calls from any browser tab.",
    "external ID": "ID externo",
    "fax": "fax",
    "female": "femenino",
    "first name": "nombre",
    "general": "general",
    "has joined": "se unió a la llamada",
    "have joined": "se unieron a la llamada",
    "hours": "{value} horas",
    "https://": "https://",
    "idle time": "tiempo inactivo",
    "is listening": "está escuchando",
    "is too long": "{what} es demasiado largo",
    "is whispering": "está susurrando",
    "last name": "apellido",
    "male": "masculino",
    "middle name": "segundo nombre",
    "minimum charge seconds": "segundos de cargo mínimo",
    "month": "mes",
    "monthly": "mensual",
    "months": "{number} meses",
    "multiple channels": "múltiples canales",
    "name": "nombre",
    "never": "nunca",
    "no of users": "{numberOfSeats} usuarios",
    "no-limits music on hold": "música en espera sin límites",
    "notes": "notas",
    "number": "número",
    "numbers max": "máximo de números",
    "of": "de",
    "offline": "desconectado",
    "on call": "en llamada",
    "on hold": "en espera",
    "onboarding-tour-flow-step-1": "¡Bienvenido a PBX.IM! Sigue los siguientes pasos para realizar tu primera llamada de prueba.",
    "onboarding-tour-flow-step-10": "La dirección IP a través de la cual tu endpoint está conectado a PBX.IM",
    "onboarding-tour-flow-step-11": "Detalles sobre el tipo de dispositivo o versión de software.",
    "onboarding-tour-flow-step-12": "Dirección MAC del endpoint.",
    "onboarding-tour-flow-step-13": "La última vez que el endpoint se conectó a PBX.IM",
    "onboarding-tour-flow-step-14": "Muestra el estado del endpoint.",
    "onboarding-tour-flow-step-15": "Revisa tu saldo. Hemos añadido $5 a tu cuenta para llamadas de prueba.",
    "onboarding-tour-flow-step-16": "Haz clic en el teléfono web.",
    "onboarding-tour-flow-step-17": "Asegúrate de que tu micrófono esté conectado.",
    "onboarding-tour-flow-step-18": "Escribe el número de teléfono al que deseas llamar.",
    "onboarding-tour-flow-step-19": "Presiona llamar.",
    "onboarding-tour-flow-step-2": "Ve al menú lateral.",
    "onboarding-tour-flow-step-3": "Haz clic en \"Configuraciones\".",
    "onboarding-tour-flow-step-4": "Haz clic en \"Endpoints\".",
    "onboarding-tour-flow-step-5": "El ícono indicará el tipo de endpoint. El ícono de globo representa un teléfono web.",
    "onboarding-tour-flow-step-6": "Tu nombre de endpoint.",
    "onboarding-tour-flow-step-7": "El nombre de usuario asociado al endpoint.",
    "onboarding-tour-flow-step-8": "La extensión telefónica asignada al endpoint.",
    "onboarding-tour-flow-step-9": "El usuario al que se le asigna el endpoint.",
    "or": "o",
    "owner email": "correo electrónico del propietario",
    "password repeat": "repetir contraseña",
    "pause": "pausa",
    "pause time": "tiempo de pausa",
    "per page": "por página",
    "phone": "teléfono",
    "plan": "plan",
    "please top-up to proceed": "por favor recarga para continuar",
    "powered by": "con tecnología de",
    "powered by PBX": "powered by PBX",
    "premium support": "soporte premium",
    "prepaid": "prepago",
    "queue calls": "llamadas en cola",
    "queues": "colas",
    "range end": "fin del rango",
    "range start": "inicio del rango",
    "ready": "listo",
    "replace prefix 44 with 0 in a number with length of 8-15 digits": "reemplaza el prefijo 44 por 0 en un número con una longitud de 8 a 15 dígitos",
    "required_field_error": "Este campo es obligatorio.",
    "ringing": "sonando",
    "row(s) selected": "fila(s) seleccionadas.",
    "s": "s",
    "same as company address": "igual a la dirección de la empresa",
    "sec": "seg",
    "security": "seguridad",
    "security email": "correo electrónico de seguridad",
    "selected": "seleccionado",
    "should be a minimum length of": "{what} debe tener una longitud mínima de {length}.",
    "startup": "emprendimiento",
    "state": "estado",
    "state / province": "estado / provincia",
    "subdomain": "subdominio",
    "support email": "correo electrónico de soporte",
    "time stats": "estadísticas de tiempo",
    "timezone": "zona horaria",
    "total rows": "{rows, plural, =0 {no hay filas} =1 {1 fila} other {# filas}}",
    "two-Factor Authentication": "Autenticación de dos factores",
    "upgrade plan": "mejorar plan",
    "username": "nombre de usuario",
    "users count": "+ {users} usuarios",
    "var": "$var",
    "wait ~30s": "espera ~30 s",
    "waiting": "esperando",
    "web domain": "dominio web",
    "web widgets": "widgets web",
    "website": "sitio web",
    "when it falls below a specified threshold": "cuando caiga por debajo de un umbral especificado",
    "year": "año",
    "yearly": "anual",
    "your password again": "tu contraseña nuevamente",
    "zip / postal code": "código postal",
    "{count} others": "1 más | {count} más",
    "{n} Seconds": "{n} segundos",
    "{field} should be number": "{field} debe ser un número",
    "A server error occurred during request execution": "Se produjo un error del servidor durante la ejecución de la solicitud",
    "Forbidden": "Prohibido",
    "Plan User Limit Reached": "Se alcanzó el límite de usuarios del plan",
    "Server Error": "Error del servidor",
    "Sorry, you have exceeded the number of tries. Please try again in {minutes} minute.": "Lo sentimos, has superado el número de intentos. Vuelve a intentarlo en {minutes} minuto.",
    "Sorry, you have exceeded the number of tries. Please try again in {minutes} minutes.": "Lo sentimos, has superado el número de intentos. Vuelve a intentarlo en {minutes} minutos.",
    "Sorry, you have exceeded the number of tries. Please try again in {seconds} second.": "Lo sentimos, has superado el número de intentos. Vuelve a intentarlo en {seconds} segundo.",
    "Sorry, you have exceeded the number of tries. Please try again in {seconds} seconds.": "Lo sentimos, has superado el número de intentos. Vuelve a intentarlo en {seconds} segundos.",
    "Too many attempts": "Demasiados intentos",
    "Validation Error": "Error de validación",
    "Your session expired. Please login in again to use the application": "Tu sesión expiró. Inicia sesión nuevamente para usar la aplicación",
    "The email has already been taken": "El correo electrónico ya está en uso.",
    "The phone has already been taken": "El teléfono ya está en uso.",
    "Choose messages to forward!": "¡Elige mensajes para reenviar!",
    "Voice note rejected": "Nota de voz rechazada",
    "{count} new message": "{count} mensaje nuevo",
    "{count} new messages": "{count} mensajes nuevos",
    "Search user": "Buscar usuario",
    "Select Type": "Seleccionar tipo",
    "Image": "Imagen",
    "Video": "Vídeo",
    "{ext} file": "Archivo {ext}",
    "Something went wrong, please try again later": "Algo salió mal, inténtalo de nuevo más tarde",
    "Sticker": "Pegatina",
    "+ Add:": "+ Añadir:",
    "Link Preview Image": "Imagen de vista previa del enlace",
    "Template not yet supported": "Plantilla aún no compatible",
    "Drag & drop here or": "Arrastra y suelta aquí o",
    "upload a local file": "sube un archivo local",
    "Drop here": "Suelta aquí",
    "Upload failed": "Error al subir",
    "Click to retry": "Haz clic para reintentar",
    "Image (JPEG or PNG)": "Imagen (JPEG o PNG)",
    "Video (MP4)": "Vídeo (MP4)",
    "Animated (MP4)": "Animado (MP4)",
    "Document (PDF only)": "Documento (solo PDF)",
    "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator or complete setup under Settings › Channels.": "Para enviar SMS desde este número se requieren una marca y una campaña A2P 10DLC aprobadas. Comunícate con tu administrador o completa la configuración en Ajustes › Canales.",
    "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator.": "Para enviar SMS desde este número se requieren una marca y una campaña A2P 10DLC aprobadas. Comunícate con tu administrador.",
    "This conversation is blocked because this number cannot send SMS.": "Esta conversación está bloqueada porque este número no puede enviar SMS.",
    "This inbox doesn’t have a phone number linked yet. Please contact your administrator or link a number to enable messaging.": "Esta bandeja de entrada aún no tiene un número de teléfono vinculado. Comunícate con tu administrador o vincula un número para habilitar la mensajería.",
    "You do not have permission to send SMS.": "No tienes permiso para enviar SMS.",
    "The 24-hour WhatsApp conversation window has expired. You can only send a pre-approved template message.": "La ventana de conversación de WhatsApp de 24 horas ha expirado. Solo puedes enviar un mensaje de plantilla previamente aprobado.",
    "Type to search contacts...": "Escribe para buscar contactos...",
    "1 hour": "1 hora",
    "15 minutes": "15 minutos",
    "30 minutes": "30 minutos",
    "5 minutes": "5 minutos",
    "Add Route": "Agregar ruta",
    "Add Question": "Agregar pregunta",
    "Added from question library.": "Agregado desde la biblioteca de preguntas.",
    "Added to question library.": "Agregado a la biblioteca de preguntas.",
    "Are you sure? This action cannot be undone.": "¿Estás seguro? Esta acción no se puede deshacer.",
    "At least one route is required": "Se requiere al menos una ruta",
    "Call Screen": "Pantalla de llamada",
    "Route name": "Nombre de la ruta",
    "Chat Destination": "Destino del chat",
    "Chat Never Expires": "El chat nunca expira",
    "Chat Screen": "Pantalla de chat",
    "Choose a category to get started.": "Elige una categoría para comenzar.",
    "Client Context": "Contexto del cliente",
    "Closed Hours Message": "Mensaje de horario cerrado",
    "Decimal Number": "Número decimal",
    "Delete Route": "Eliminar ruta",
    "Email Address": "Dirección de correo electrónico",
    "End call": "Finalizar llamada",
    "Expires After": "Expira después de",
    "Hello, Victor.": "Hola, Victor.",
    "Hey there! Hope you're having a good one.": "¡Hola! Espero que tengas un buen día.",
    "How can we help you?": "¿Cómo podemos ayudarte?",
    "Letters Only": "Solo letras",
    "Long Text": "Texto largo",
    "Maximum 5 routes allowed": "Máximo 5 rutas permitidas",
    "Message shown when closed": "Mensaje mostrado cuando está cerrado",
    "Message...": "Mensaje...",
    "Mute microphone": "Silenciar micrófono",
    "New Route": "Nueva ruta",
    "Numbers Only": "Solo números",
    "Question label": "Etiqueta de la pregunta",
    "Question Library": "Biblioteca de preguntas",
    "Remove from question library.": "Eliminar de la biblioteca de preguntas.",
    "Save & Continue": "Guardar y continuar",
    "Save to question library for reuse.": "Guardar en la biblioteca de preguntas para reutilizar.",
    "Saved to question library.": "Guardado en la biblioteca de preguntas.",
    "Subtitle": "Subtítulo",
    "Validation Rule": "Regla de validación",
    "Victor joined the conversation": "Victor se unió a la conversación",
    "Welcome!": "¡Bienvenido!",
    "What can I help you with?": "¿En qué puedo ayudarte?",
    "What can we help you with?": "¿En qué podemos ayudarte?",
    "webphone-tour-step-agent-1": "Tu estado se muestra aquí antes de activar el teléfono.",
    "Activate the flow to make a test call.": "Activa el flujo para realizar una llamada de prueba.",
    "Cancel the test call.": "Cancela la llamada de prueba.",
    "chat menu {name}": "menú de chat {name}",
    "Connect the webphone to make a test call.": "Conecta el webphone para realizar una llamada de prueba.",
    "Downgrading to {name} on {date}": "Cambio a {name} el {date}",
    "Please select a script in the current tab": "Por favor, selecciona un script en la pestaña actual",
    "No queues joined yet": "Aún no te has unido a ninguna cola.",
    "Plan canceled": "Plan cancelado",
    "Test call active in another flow. End it to start a new one.": "Llamada de prueba activa en otro flujo. Finalízala para iniciar una nueva.",
    "Test call failed": "La llamada de prueba falló",
    "Test call timed out": "La llamada de prueba expiró",
    "The number of seats can’t exceed the plan maximum.": "El número de asientos no puede superar el máximo del plan.",
    "This queue is locked by an admin": "Esta cola está bloqueada por un administrador",
    "Upgrade your plan to add more seats.": "Mejora tu plan para agregar más asientos.",
    "Your subscription has been canceled.": "Tu suscripción ha sido cancelada.",
    "He": "Él",
    "Leave": "Salir",
    "Pin": "Fijar",
    "Unpin": "Desfijar",
    "Add Business Hours": "Agregar horario comercial",
    "Edit Business Hours": "Editar horario comercial",
    "Account was created on {date}. Start date has been adjusted.": "La cuenta se creó el {date}. La fecha de inicio ha sido ajustada.",
    "Customer waiting duration": "Duración de espera del cliente",
    "Customer talking duration": "Duración de conversación del cliente",
    "Max Wait Time": "Tiempo máximo de espera",
    "Customer max waiting duration": "Duración máxima de espera del cliente",
    "Number of abandoned calls": "Número de llamadas abandonadas",
    "Calls Within SLA": "Llamadas dentro del SLA",
    "Timeout Calls": "Llamadas expiradas",
    "Answered on time": "Contestadas a tiempo",
    "Not answered in time": "No contestadas a tiempo",
    "Remove from library": "Eliminar de la biblioteca",
    "Web Widget Preview": "Vista previa del widget web",
    "Close Preview": "Cerrar vista previa",
    "Enable Call or Chat for this route": "Habilita Llamada o Chat para esta ruta",
    "Existing embeds will stop working.": "Las integraciones existentes dejarán de funcionar.",
    "Your current integration script will no longer work after regeneration. All existing integrations must be updated with the new script to continue working. Do you want to continue?": "Tu script de integración actual dejará de funcionar después de la regeneración. Todas las integraciones existentes deben actualizarse con el nuevo script para seguir funcionando. ¿Deseas continuar?",
    "Maximum date range is 3 months. End date has been adjusted.": "El rango máximo de fechas es de 3 meses. La fecha de fin ha sido ajustada.",
    "Maximum date range is 90 days. End date has been adjusted.": "El rango máximo de fechas es de 90 días. La fecha de fin ha sido ajustada.",
    "Please fix the date range before exporting": "Corrige el rango de fechas antes de exportar",
    "Segments / SMS": "Segmentos / SMS",
    "Segments SMS format": "{segments} ({charCount} caracteres)",
    "Segments per message": "Segmentos por mensaje",
    "Segment cost": "Costo por segmento",
    "Total cost": "Costo total",
    "Balance below estimated cost — top up to launch": "Saldo por debajo del costo estimado: recarga para lanzar",
    "Unable to pause campaign": "No se pudo pausar la campaña",
    "Unable to resume campaign": "No se pudo reanudar la campaña",
    "Search phone number": "Buscar número de teléfono",
    "Skip greeting tooltip": "Omite el mensaje de saludo y dirige a los llamantes directamente al tono de grabación. Actívalo si no quieres que los llamantes escuchen un saludo antes de dejar su mensaje.",
    "Skip Voicemail Operation Instructions tooltip": "Omite los mensajes automáticos del sistema (por ejemplo, 'graba después del tono, presiona 1 al terminar'). Actívalo para una experiencia más limpia en la que los llamantes solo escuchen tu saludo y el pitido.",
    "24 hours": "24 horas",
    "Accent": "Acento",
    "Background": "Fondo",
    "Business Hours": "Horario de atención",
    "Call Now": "Llamar ahora",
    "Call {name}": "Llamar a {name}",
    "Contact us web widget created successfully": "Widget web de contacto creado con éxito",
    "Contact us web widget updated successfully": "Widget web de contacto actualizado con éxito",
    "Content Text": "Texto del contenido",
    "Destinations": "Destinos",
    "Edit Contact Us Web Widget": "Editar widget web de contacto",
    "How do I integrate it?": "¿Cómo lo integro?",
    "Integration Script": "Script de integración",
    "Keypad": "Teclado",
    "Label": "Etiqueta",
    "Mute": "Silenciar",
    "Paste the script in your HTML just before the closing </body> tag": "Pega el script en tu HTML justo antes de la etiqueta de cierre </body>",
    "Please enter a valid hex color (e.g., #FF0000 or #F00)": "Por favor ingrese un color hexadecimal válido (p. ej., #FF0000 o #F00)",
    "Preview": "Vista previa",
    "Send message": "Enviar mensaje",
    "Show Keypad": "Mostrar teclado",
    "Shown once a route has Call enabled.": "Se muestra una vez que una ruta tiene Llamada habilitada.",
    "Test Widget": "Probar widget",
    "Time Group": "Grupo de tiempo",
    "Create Contact Us Web Widget": "Crear widget web de contacto",
    "Edit SMS Campaign": "Editar campaña de SMS",
    "Approved": "Aprobado",
    "Access Denied": "Acceso denegado",
    "You don't have permission to view this page.": "No tienes permiso para ver esta página.",
    "Failed to load report data": "Error al cargar los datos del informe",
    "Sign in securely with your Reshetcall identity.": "Inicia sesión de forma segura con tu identidad de Reshetcall.",
    "These filters are not yet available in the new reports engine.": "Estos filtros aún no están disponibles en el nuevo motor de informes.",
    "Agent status created": "Estado de agente creado",
    "Agent status updated": "Estado de agente actualizado",
    "Always": "Siempre",
    "Call forwarding created": "Desvío de llamadas creado",
    "Call forwarding updated": "Desvío de llamadas actualizado",
    "Conference created": "Conferencia creada",
    "Conference updated": "Conferencia actualizada",
    "End on moderator exit": "Finalizar al salir el moderador",
    "Extension created": "Extensión creada",
    "Extension updated": "Extensión actualizada",
    "Leave empty to keep the current value": "Dejar vacío para mantener el valor actual",
    "Passthrough": "Original",
    "Remove admin pin": "Eliminar PIN de administrador",
    "Remove user pin": "Eliminar PIN de usuario",
    "Require answer confirmation": "Requerir confirmación de respuesta",
    "This extension is already in use": "Esta extensión ya está en uso",
    "Trigger": "Disparador",
    "Unreachable": "Inalcanzable",
    "The selected destination is no longer available": "El destino seleccionado ya no está disponible",
    "The selected media file is no longer available": "El archivo multimedia seleccionado ya no está disponible",
    "One of the selected labels is no longer available": "Una de las etiquetas seleccionadas ya no está disponible",
    "One of the selected teams is no longer available": "Uno de los equipos seleccionados ya no está disponible",
    "Invalid credentials": "Credenciales inválidas",
    "Showing data for your teams only": "Mostrando datos solo de tus equipos",
    "Couldn't remove the picture": "No se pudo eliminar la imagen",
    "The file size must not exceed 4 MB": "El tamaño del archivo no debe superar los 4 MB",
    "Loading": "Cargando",
    "This file format is not supported": "Este formato de archivo no es compatible",
    "Template created": "Plantilla creada",
    "A template needs a body": "Una plantilla necesita un cuerpo",
    "Template name must be lowercase letters, digits and underscores": "El nombre de la plantilla debe tener minúsculas, dígitos y guiones bajos",
    "Failed to create template": "No se pudo crear la plantilla",
    "Nothing to update": "Nada que actualizar",
    "Meta rejected the template change": "Meta rechazó el cambio de la plantilla",
    "Template submitted to Meta for approval": "Plantilla enviada a Meta para aprobación",
    "This template was already submitted": "Esta plantilla ya fue enviada",
    "Meta rejected the template": "Meta rechazó la plantilla",
    "Failed to submit template": "No se pudo enviar la plantilla",
    "That template no longer exists": "Esa plantilla ya no existe",
    "Synced {count} number(s) from Meta": "Se sincronizaron {count} número(s) desde Meta",
    "Only one WhatsApp Business Account can be connected per account. Not connected: {ids}.": "Solo se puede conectar una cuenta de WhatsApp Business por cuenta. No conectadas: {ids}.",
    "A sync is already running. Try again in a moment.": "Ya hay una sincronización en curso. Inténtalo de nuevo en un momento.",
    "Number updated successfully": "Número actualizado correctamente",
    "That number no longer exists": "Ese número ya no existe",
    "Failed to update number": "No se pudo actualizar el número",
    "You do not have permission to view WhatsApp settings": "No tienes permiso para ver la configuración de WhatsApp",
    "Could not load WhatsApp settings": "No se pudo cargar la configuración de WhatsApp",
    "Try again": "Inténtalo de nuevo",
    "Inbox assignment becomes available once inboxes are set up": "La asignación de bandejas estará disponible cuando se configuren",
    "Removed at Meta": "Eliminada en Meta",
    "Not available yet": "Aún no disponible",
    "Assignment updated": "Asignación actualizada",
    "hours label": "horas",
    "minutes label": "minutos",
    "Phone number in use named": "Este número de teléfono ya pertenece a {name}.",
    "Phone number in use": "Este número de teléfono ya pertenece a otro contacto.",
    "Permissions": "Permisos",
    "Ring group created": "Grupo de timbre creado",
    "Ring group updated": "Grupo de timbre actualizado",
    "Sequential": "Secuencial",
    "One of the selected users is no longer available": "Uno de los usuarios seleccionados ya no está disponible",
    "Voicemail created": "Buzón de voz creado",
    "Voicemail updated": "Buzón de voz actualizado",
    "Remove access code": "Eliminar código de acceso",
    "Failed to load options": "Error al cargar las opciones",
    "An error occurred while saving the inbox.": "Ocurrió un error al guardar la bandeja de entrada.",
    "invalid_verification_code": "Código de verificación inválido",
    "verification_code_expired": "El código de verificación ha expirado",
    "too_many_attempts": "Demasiados intentos incorrectos. Ese código ya no es válido: use Reenviar para obtener uno nuevo.",
    "Time group created": "Grupo de tiempo creado",
    "Time group updated": "Grupo de tiempo actualizado",
    "Business hours created": "Horario de atención creado",
    "Business hours updated": "Horario de atención actualizado",
    "One of the selected time groups is no longer available": "Uno de los grupos de tiempo seleccionados ya no está disponible",
    "The selected time group is no longer available": "El grupo de tiempo seleccionado ya no está disponible",
    "Business hours cannot route to themselves": "El horario de atención no puede enrutar hacia sí mismo",
    "You do not have permission to view time groups": "No tienes permiso para ver los grupos de tiempo",
    "Hangup": "Colgar",
    "Congestion": "Congestión",
    "Select time group": "Seleccionar grupo de tiempo",
    "Cannot delete, still in use by {items}": "No se puede eliminar, todavía está en uso por {items}",
    "Access code must be 1 to 10 digits": "El código de acceso debe tener de 1 a 10 dígitos",
    "Cannot delete row in use": "No se puede eliminar: todavía está en uso por {what}. Elimínelo de allí primero.",
    "Cannot delete row in use generic": "No se puede eliminar: todavía está en uso.",
    "Leave empty to remove the PIN": "Deje vacío para eliminar el PIN",
    "View": "Ver",
    "PIN must be 4 to 6 digits": "El PIN debe tener de 4 a 6 dígitos",
    "Invalid value": "Valor no válido",
    "The start and end times cannot be the same": "La hora de inicio y la de fin no pueden ser iguales",
    "skipped team members": "{count, plural, one {# usuario seleccionado ya no está disponible y no se agregó} other {# usuarios seleccionados ya no están disponibles y no se agregaron}}",
    "skipped team statuses": "{count, plural, one {# estado seleccionado ya no está disponible y no se agregó} other {# estados seleccionados ya no están disponibles y no se agregaron}}",
    "An error occurred while saving the team.": "Ocurrió un error al guardar el equipo.",
    "Media file created": "Archivo multimedia creado",
    "Media file updated": "Archivo multimedia actualizado",
    "This file has already been uploaded": "Este archivo ya ha sido subido.",
    "Converting audio...": "Convirtiendo audio...",
    "This audio file could not be read": "No se pudo leer este archivo de audio. Prueba con otro archivo.",
    "Media file is in use": "Este archivo multimedia está en uso y no se puede eliminar.",
    "Media file is in use by": "No se puede eliminar este archivo multimedia: todavía lo usa {entities}.",
    "Announcement created": "Anuncio creado",
    "Announcement updated": "Anuncio actualizado",
    "Media file not found": "Archivo multimedia no encontrado",
    "Label not found": "Etiqueta no encontrada",
    "The file is too large": "El archivo es demasiado grande. El tamaño máximo es {size}.",
    "Text to speech is unavailable right now": "La síntesis de voz no está disponible en este momento. Inténtalo de nuevo más tarde.",
    "No longer available": "Ya no está disponible",
    "Extensions longer than Max digits cannot be dialed": "Las extensiones {digits} superan el Máximo de dígitos y no se pueden marcar",
    "Longer than Max digits": "No puede superar el Máximo de dígitos ({max})",
    "An auto attendant cannot point at itself": "Un operador automático no puede apuntar a sí mismo",
    "One of the selected extensions is no longer available": "Una de las extensiones seleccionadas ya no está disponible",
    "Too many items": "Demasiados elementos",
    "You do not have permission to view users": "No tienes permiso para ver los usuarios",
    "This audio is too long": "Este audio es demasiado largo. El máximo es de unos {minutes} minutos una vez convertido.",
    "Too many requests. Please try again in a moment.": "Demasiadas solicitudes. Inténtalo de nuevo en un momento.",
    "Call queue created": "Cola de llamadas creada",
    "Call queue updated": "Cola de llamadas actualizada",
    "Dynamic - Position in Queue": "Dinámico - Posición en la cola",
    "Dynamic - Estimated Wait Time in Queue": "Dinámico - Tiempo de espera estimado en la cola",
    "Plays the selected audio in the order defined below to callers waiting in the queue": "Reproduce el audio seleccionado en el orden definido a continuación a las personas que llaman y esperan en la cola",
    "Invalid value in field": "Valor no válido: {field}",
    "Currently routes to": "Actualmente dirige a {name}",
    "Retry": "Reintentar",
    "Too many requests. Please try again in {seconds} seconds.": "Demasiadas solicitudes. Vuelve a intentarlo en {seconds, plural, one {# segundo} other {# segundos}}.",
    "Too many requests. Please try again in {minutes} minutes.": "Demasiadas solicitudes. Vuelve a intentarlo en {minutes, plural, one {# minuto} other {# minutos}}.",
    "Connecting your WhatsApp Business account and syncing numbers and templates…": "Conectando tu cuenta de WhatsApp Business y sincronizando números y plantillas…",
    "Waiting for Meta to finish registering — this can take a moment": "Esperando a que Meta termine el registro; puede tardar un momento",
    "Account settings are unavailable right now. Please try again shortly.": "La configuración de la cuenta no está disponible en este momento. Vuelve a intentarlo en unos instantes.",
    "These prices have expired. Please search again.": "Estos precios han caducado. Vuelve a buscar.",
    "That selection is no longer valid. Please search again.": "Esa selección ya no es válida. Vuelve a buscar.",
    "That number sold out while ordering. Please search again.": "Ese número se agotó durante el pedido. Vuelve a buscar.",
    "That number is no longer available. Please search again.": "Ese número ya no está disponible. Vuelve a buscar.",
    "Your card would not authorize this purchase.": "Tu tarjeta no autorizó esta compra.",
    "Your balance does not cover this purchase.": "Tu saldo no cubre esta compra.",
    "Some numbers could not be bought": "No se pudieron comprar algunos números",
    "We could not complete that purchase. Please try again shortly.": "No pudimos completar la compra. Inténtalo de nuevo en un momento.",
    "Please buy at most {max} numbers at a time": "Compra como máximo {max} números a la vez",
    "That sign-in was cancelled. Please try again.": "That sign-in was cancelled. Please try again.",
    "Your sign-in with that provider has expired. Please start again.": "Tu inicio de sesión con ese proveedor ha caducado. Vuelve a empezar.",
    "Conversation history": "Historial de conversaciones",
    "No earlier conversations.": "No hay conversaciones anteriores.",
    "Supervisors": "Supervisores",
    "Mine": "Míos",
    "Unread": "No leídos",
    "Pick a conversation": "Elige una conversación",
    "New group": "Nuevo grupo",
    "Create group": "Crear grupo",
    "Add people": "Añadir personas",
    "Leave group": "Salir del grupo",
    "Leave this group?": "¿Salir de este grupo?",
    "You will stop receiving its messages.": "Dejarás de recibir sus mensajes.",
    "Direct message": "Mensaje directo",
    "Internal chat": "Chat interno",
    "Search people": "Buscar personas",
    "No colleagues found": "No se encontraron compañeros",
    "Members": "Miembros",
    "New message": "Nuevo mensaje",
    "Start a conversation from one of your numbers.": "Inicia una conversación desde uno de tus números.",
    "No numbers can send messages": "Ningún número puede enviar mensajes",
    "Choose a number": "Elige un número",
    "Type a message": "Escribe un mensaje",
    "The message could not be sent. Check the number and try again.": "No se pudo enviar el mensaje. Comprueba el número e inténtalo de nuevo.",
    "What would you like to start?": "¿Qué quieres empezar?",
    "Messaging": "Mensajería",
    "An inbox is a shared pool. Its staff see every unclaimed conversation in it.": "Una bandeja es un grupo compartido. Su personal ve todas las conversaciones sin reclamar.",
    "New inbox": "Nueva bandeja",
    "No inboxes yet. Create one and add the people who will work it.": "Aún no hay bandejas. Crea una y añade a las personas que la atenderán.",
    "Archived": "Archivada",
    "Nobody is staffing this inbox": "Nadie atiende esta bandeja",
    "Agent": "Agente",
    "Rename": "Renombrar",
    "Unarchive": "Desarchivar",
    "Archive": "Archivar",
    "Rename inbox": "Renombrar bandeja",
    "A supervisor also sees what the inbox's agents have claimed.": "Un supervisor también ve lo que los agentes de la bandeja han reclamado.",
    "Create inbox": "Crear bandeja",
    "Any number": "Cualquier número",
    "Move up": "Subir",
    "Move down": "Bajar",
    "Discard": "Descartar",
    "Channel": "Canal",
    "Type a phone number or select from contacts": "Escribe un número de teléfono o elige de los contactos",
    "Use this number": "Usar este número",
    "New conversation": "Nueva conversación",
    "Choose who to message, then write below.": "Elige a quién escribir y redacta abajo.",
    "Internal chats": "Chats internos",
    "Who works which conversations": "Quién atiende qué conversaciones",
    "Messaging route": "Ruta de mensajería",
    "Messages to this number reach nobody": "Los mensajes a este número no llegan a nadie",
    "The route could not be saved.": "No se pudo guardar la ruta.",
    "No numbers yet": "Aún no hay números",
    "Move to inbox": "Mover a la bandeja",
    "Reopen": "Reabrir",
    "Show details": "Mostrar detalles",
    "Hide details": "Ocultar detalles",
    "Join this conversation to reply.": "Únete a esta conversación para responder.",
    "Alphabetical": "Alfabético",
    "Date Created": "Fecha de creación",
    "Date Updated": "Fecha de actualización",
    "Sort": "Ordenar",
    "Ascending": "Ascendente",
    "Descending": "Descendente",
    "Clear Search": "Borrar búsqueda",
    "These numbers still feed this inbox": "Estos números aún alimentan esta bandeja",
    "The inbox could not be archived.": "No se pudo archivar la bandeja.",
    "Manage inboxes assigned to users and teams": "Gestiona las bandejas asignadas a usuarios y equipos",
    "The inbox is archived, not erased: its conversations stay, and nobody sees them until it is restored.": "La bandeja se archiva, no se borra: sus conversaciones se conservan y nadie las ve hasta que se restaure.",
    "Add inbox": "Añadir bandeja",
    "Edit inbox": "Editar bandeja",
    "Delete inbox": "Eliminar bandeja",
    "Greeting Message": "Mensaje de bienvenida",
    "Inboxes": "Bandejas",
    "Loading...": "Cargando...",
    "Enter a greeting message for inbound conversations...": "Escribe un mensaje de bienvenida para las conversaciones entrantes...",
    "When an inbound message arrives, this greeting is sent as the generic first reply. After that, an user can assign the conversation to themselves.": "Cuando llega un mensaje entrante, este saludo se envía como primera respuesta genérica. Después, un usuario puede asignarse la conversación.",
    "The inbox could not be saved.": "No se pudo guardar la bandeja.",
    "The name and greeting were saved, but the staff could not be updated.": "El nombre y el saludo se guardaron, pero no se pudo actualizar el personal.",
    "{cleared} numbers were cleared; {remaining} still feed this inbox. Try again to clear the rest.": "Se limpiaron {cleared} números; {remaining} aún alimentan esta bandeja. Inténtalo de nuevo para limpiar el resto.",
    "{cleared} of them were already cleared.": "{cleared} de ellos ya se limpiaron.",
    "chat system created": "{actor} creó el chat.",
    "chat system claimed": "{actor} se unió al chat.",
    "chat system assigned": "{actor} transfirió el chat a {target}.",
    "chat system released": "{actor} salió del chat.",
    "chat system moved": "{actor} transfirió el chat a {target}.",
    "chat system closed": "{actor} finalizó el chat.",
    "chat system reopened": "{actor} reabrió el chat.",
    "chat system member added": "{actor} añadió a {target} al chat.",
    "chat system member removed": "{actor} eliminó a {target} del chat.",
    "chat system member left": "{actor} salió del chat.",
    "chat system renamed": "{actor} cambió el nombre del chat a {target}.",
    "chat system announcement": "Anuncio\n{body}",
    "chat system more": "{count} más",
    "System": "Sistema",
    "You": "Tú",
    "A template with no inboxes is offered to nobody": "Una plantilla sin bandejas no se ofrece a nadie",
    "Team Inboxes": "Bandejas de equipo",
    "Could not load inboxes": "No se pudieron cargar las bandejas",
    "Invitation resent automatically": "Invitación reenviada automáticamente",
    "invitation_resent_to_new_email": "Se envió una nueva invitación a {email}. No es necesario reenviarla.",
    "is required": "es obligatorio",
    "Inbox Number": "Número de la bandeja",
    "Contact History": "Historial del contacto",
    "No conversations found": "No se encontraron conversaciones",
    "The inbox stopped working. Your messages are safe.": "La bandeja de entrada dejó de funcionar. Tus mensajes están a salvo.",
    "Inbox": "Bandeja",
    "TEAM INBOXES": "BANDEJAS DE EQUIPO",
    "Close conversation": "Cerrar conversación",
    "Are you sure you want to close this conversation?": "¿Seguro que quieres cerrar esta conversación?",
    "Leave conversation": "Salir de la conversación",
    "Are you sure you want to leave this conversation?": "¿Seguro que quieres salir de esta conversación?",
    "avatar": "avatar",
    "Personal Inboxes": "Bandejas personales",
    "No items": "Sin elementos",
    "My Inbox": "Mi bandeja",
    "Internal Chat": "Chat interno",
    "Logs": "Registros",
    "Calls Report": "Informe de llamadas",
    "Queues Report": "Informe de colas",
    "PBX Studio": "PBX Studio",
    "Auto Dialer": "Marcador automático",
    "SIP Trunks": "Troncales SIP",
    "SMS & MMS": "SMS y MMS",
    "Wallboards": "Paneles",
    "Channels": "Canales",
    "My Business": "Mi empresa",
    "Add IVR": "Añadir IVR",
    "Message Logs": "Registro de mensajes",
    "Send From:": "Enviar desde:",
    "Select Number": "Seleccionar número",
    "No Numbers Available": "No hay números disponibles",
    "WhatsApp": "WhatsApp",
    "Internal": "Interno",
    "All": "Todos",
    "Open": "Abiertas",
    "Closed": "Cerradas",
    "Try using different keywords.": "Prueba con otras palabras clave.",
    "No conversations": "No hay conversaciones",
    "The inbox is currently empty.": "La bandeja está vacía.",
    "Assign to me": "Asignarme",
    "Assign to": "Asignar a",
    "Unmute": "Activar sonido",
    "Join chat": "Unirse al chat",
    "Assigned To": "Asignado a",
    "Unassigned": "Sin asignar",
    "is typing...": "está escribiendo...",
    "Please select a conversation": "Selecciona una conversación",
    "Get started with Inbox": "Empieza con la bandeja",
    "Send, receive messages and keep all conversations in one place.": "Envía y recibe mensajes y mantén todas las conversaciones en un solo lugar.",
    "Start conversation": "Iniciar conversación",
    "In Progress": "En curso",
    "Done": "Finalizada",
    "To:": "Para:",
    "Group name": "Nombre del grupo",
    "Loading…": "Cargando…",
    "Display Name": "Nombre visible",
    "No phone numbers attached yet": "Aún no hay números de teléfono asociados",
    "WhatsApp Business account connected successfully": "Cuenta de WhatsApp Business conectada correctamente",
    "Connected WhatsApp Business Accounts": "Cuentas de WhatsApp Business conectadas",
    "WhatsApp business numbers": "Números de WhatsApp Business",
    "Add Inbox": "Añadir bandeja",
    "Remove {name} from this group?": "¿Eliminar a {name} de este grupo?",
    "Callback pending": "Devolución de llamada pendiente",
    "Wallboard not available": "Tablero no disponible",
    "That wallboard link is already in use. Reload the page and try again.": "Ese enlace del tablero ya está en uso. Recarga la página e inténtalo de nuevo.",
    "Live updates paused": "Actualizaciones en vivo pausadas",
    "Totals may be incomplete": "Los totales pueden estar incompletos",
    "Name is too long": "El nombre es demasiado largo",
    "The board is too large to save. Use a smaller logo image.": "El tablero es demasiado grande para guardarlo. Usa una imagen de logo más pequeña.",
    "Wallboard not found": "Tablero no encontrado",
    "No wallboard hash provided": "No se proporcionó el identificador del tablero",
    "Failed to save wallboard": "No se pudo guardar el tablero",
    "Wallboard Validation Failed": "Falló la validación del tablero",
    "Please try again later.": "Inténtalo de nuevo más tarde.",
    "Wallboard saved successfully": "Tablero guardado correctamente",
    "Failed to change status": "No se pudo cambiar el estado",
    "Reference data may be out of date": "Los datos de referencia pueden estar desactualizados",
    "We've sent you an SMS with a verification code": "Te hemos enviado un SMS con un código de verificación.",
    "We've sent you a WhatsApp message with a verification code": "Te hemos enviado un mensaje de WhatsApp con un código de verificación.",
    "This verification method is not available for your country.": "Este método de verificación no está disponible en tu país.",
    "This phone number is already in use by another account.": "Este número de teléfono ya está en uso por otra cuenta.",
    "This is already your verified number.": "Este ya es tu número verificado.",
    "Not verified": "No verificado",
    "Phone code expired": "El código ha caducado.",
    "Invalid verification code": "Código de verificación no válido.",
    "Verification Code": "Código de verificación",
    "Authentication App": "Aplicación de autenticación",
    "Authenticator app enabled": "Aplicación de autenticación activada",
    "Change 2FA": "Cambiar 2FA",
    "Email enabled": "Correo electrónico activado",
    "Enter the authentication code": "Introduce el código de autenticación",
    "Methods used for two-factor authentication": "Métodos usados para la autenticación en dos pasos",
    "Or enter this key": "O introduce esta clave",
    "Scan the QR code with your authenticator app": "Escanea el código QR con tu aplicación de autenticación",
    "TFA is required by your organization": "Tu organización requiere la autenticación en dos pasos",
    "That code is not valid. Check the code and try again": "El código no es válido. Compruébalo e inténtalo de nuevo",
    "This setup has expired. Start again": "Esta configuración ha caducado. Empieza de nuevo",
    "Two-Factor Authentication": "Autenticación en dos pasos",
    "Two-Factor Authentication updated": "Autenticación en dos pasos actualizada",
    "Use Google Authenticator or another app": "Usa Google Authenticator u otra aplicación",
    "Verify your email to use it for 2FA": "Verifica tu correo para usarlo en la autenticación en dos pasos",
    "Receive a sign-in code by email": "Recibe un código de inicio de sesión por correo",
    "We couldn't load your invoices.": "No pudimos cargar tus facturas.",
    "No invoices yet": "Aún no hay facturas",
    "Paid": "Pagada",
    "Unpaid": "Sin pagar",
    "Void": "Anulada",
    "Wallet top-up": "Recarga de saldo",
    "+{count} more": "+{count} más",
    "PDF": "PDF",
    "Complete the card verification to finish your top-up": "Completa la verificación de la tarjeta para finalizar tu recarga",
    "The card was declined.": "La tarjeta fue rechazada.",
    "This country is already used": "Este país ya está en uso",
    "You do not have permission to view phone numbers": "No tienes permiso para ver los números de teléfono",
    "Upgrade": "Mejorar",
    "You have {used} queues; {plan} allows {allowed}. Delete {delete} to continue.": "Tienes {used} colas; {plan} permite {allowed}. Elimina {delete} para continuar.",
    "Changes to {plan} on {date}": "Cambios a {plan} el {date}",
    "Keep current plan": "Mantener el plan actual",
    "Remove users before reducing seats": "{used} usuarios están activos — elimina usuarios antes de reducir los asientos.",
    "All seats are in use. Add seats to your plan to invite more users.": "Todos los puestos están en uso. Añade puestos a tu plan para invitar a más usuarios.",
    "All seats are in use. Add seats to your plan to reactivate this user.": "Todos los puestos están en uso. Añade puestos a tu plan para reactivar a este usuario.",
    "Could not load your 2FA settings": "No se pudo cargar tu configuración de autenticación en dos pasos",
    "Some changes were saved. Check your settings and try again": "Se guardaron algunos cambios. Revisa tu configuración e inténtalo de nuevo",
    "Please validate your authentication code": "Valida tu código de autenticación",
    "The new settings have been successfully saved.": "La nueva configuración se ha guardado correctamente.",
    "Regenerate QR Code": "Regenerar código QR",
    "We couldn't save your number right now. Please try again.": "No pudimos guardar tu número en este momento. Inténtalo de nuevo.",
    "We couldn't send the code by SMS. Please try another method.": "No pudimos enviar el código por SMS. Prueba otro método.",
    "We couldn't send the code over WhatsApp. Please try SMS instead.": "No pudimos enviar el código por WhatsApp. Prueba por SMS.",
    "We can't send the code right now. Please try again shortly.": "No podemos enviar el código en este momento. Inténtalo de nuevo en breve.",
    "Too many incorrect attempts. That code is no longer valid. Send a new code.": "Demasiados intentos incorrectos. Ese código ya no es válido. Envía un código nuevo.",
    "Change phone": "Cambiar teléfono",
    "resend_in_seconds": "Reenviar en {seconds} segundos",
    "resend_in_minutes": "Reenviar en {minutes} minutos",
    "resend_in_minutes_and_seconds": "Reenviar en {minutes} minutos y {seconds} segundos",
    "We couldn't load your account": "No pudimos cargar tu cuenta",
    "Try again, or log out and sign in again if the problem continues": "Inténtalo de nuevo o cierra sesión y vuelve a iniciarla si el problema continúa",
    "You can't sign in from this location ({ip}). Please contact your administrator.": "No puedes iniciar sesión desde esta ubicación ({ip}). Contacta a tu administrador.",
    "You can't sign in from this location. Please contact your administrator.": "No puedes iniciar sesión desde esta ubicación. Contacta a tu administrador.",
    "Your password has been changed, but you can't sign in from this location. Please contact your administrator.": "Tu contraseña ha sido cambiada, pero no puedes iniciar sesión desde esta ubicación. Contacta a tu administrador.",
    "Allowed IP addresses": "Direcciones IP permitidas",
    "You do not have permission to view queues": "No tienes permiso para ver las colas",
    "The role was saved, but the agent status did not update": "El rol se guardó, pero el estado de agente no se actualizó",
    "$0.00 today, cancel anytime before your trial ends on {date}": "0,00 $ hoy, cancela cuando quieras antes de que termine tu prueba el {date}",
    "You have {used} web widgets; {plan} allows {allowed}. Delete {delete} to continue.": "Tienes {used} widgets web; {plan} permite {allowed}. Elimina {delete} para continuar.",
    "{plan} allows up to {max} seats.": "{plan} permite hasta {max} asientos.",
    "Card added, but it could not be kept as non-default": "Tarjeta agregada, pero no se pudo mantener como no predeterminada",
    "Enter a valid ZIP code": "Introduce un código postal válido",
    "Business location": "Ubicación de la empresa",
    "Card verification failed. Try again or use another card.": "La verificación de la tarjeta falló. Inténtalo de nuevo o usa otra tarjeta.",
    "Payment received. Your balance will update shortly.": "Pago recibido. Tu saldo se actualizará en breve.",
    "Up to {count} email addresses": "Puedes añadir hasta {count} direcciones de correo electrónico",
    "Test email not sent to {emails}": "El correo de prueba no se envió a {emails}",
    "Voicemail saved, but where its recordings are delivered was not changed": "El buzón de voz se guardó, pero no se cambió a dónde se entregan sus grabaciones",
    "Withheld number": "Número oculto",
    "Not delivered": "No entregado",
    "Transcript": "Transcripción",
    "This conversation is closed. Reopen it to reply.": "Esta conversación está cerrada. Vuelve a abrirla para responder.",
    "Voicemails can't be answered here. Call the caller back.": "Los mensajes de voz no se pueden responder aquí. Devuelve la llamada.",
    "Voicemails can't be answered here, and this caller's number was withheld.": "Los mensajes de voz no se pueden responder aquí, y el número de quien llamó está oculto.",
    "Confirmation link sent to {email}": "Enlace de confirmación enviado a {email}",
    "The new email is pending, but the confirmation link could not be sent. Use Resend Verification Link in a minute.": "El nuevo correo electrónico está pendiente, pero no se pudo enviar el enlace de confirmación. Usa Reenviar enlace de verificación en un minuto.",
    "There is no pending email change for this user.": "No hay ningún cambio de correo electrónico pendiente para este usuario.",
    "Confirm new email": "Confirmar nuevo correo electrónico",
    "Click the button below to confirm your new email address.": "Haz clic en el botón de abajo para confirmar tu nueva dirección de correo electrónico.",
    "Your email has been changed. You can now sign in with {email}.": "Tu correo electrónico ha sido cambiado. Ahora puedes iniciar sesión con {email}.",
    "This email was already confirmed. You can sign in with {email}.": "Este correo electrónico ya fue confirmado. Puedes iniciar sesión con {email}.",
    "This confirmation link has expired. Ask your administrator to send a new one.": "Este enlace de confirmación ha caducado. Pide a tu administrador que te envíe uno nuevo.",
    "This confirmation link has already been used.": "Este enlace de confirmación ya se ha utilizado.",
    "This confirmation link is no longer valid.": "Este enlace de confirmación ya no es válido.",
    "A confirmation email was sent recently. Save the new email again in a minute.": "Se envió un correo de confirmación hace poco. Vuelve a guardar el nuevo correo electrónico en un minuto.",
    "The pending email change was cancelled.": "Se canceló el cambio de correo electrónico pendiente.",
    "We could not confirm your email right now. Your link may still work, so try again.": "No pudimos confirmar tu correo electrónico en este momento. Es posible que tu enlace aún funcione, así que inténtalo de nuevo.",
    "Time-based (TOTP), SHA1, 6 digits, 30 seconds": "Basado en tiempo (TOTP), SHA1, 6 dígitos, 30 segundos",
    "Available once the invitation is accepted": "Disponible cuando se acepte la invitación",
    "Temporarily Unavailable": "Temporalmente no disponible",
    "The user's email is not verified, so it cannot be used for 2FA": "El correo del usuario no está verificado, por lo que no se puede usar para la autenticación en dos pasos",
    "2FA cannot be turned on: the user has no verified method": "No se puede activar la autenticación en dos pasos: el usuario no tiene ningún método verificado",
    "We couldn't send the code by email. Please try again.": "No pudimos enviar el código por correo. Inténtalo de nuevo.",
    "TFA Code Incorrect": "El código de verificación en dos pasos es incorrecto. Revísalo y vuelve a introducir el código de un solo uso.",
    "Always sent to the account owner: {email}": "Siempre se envía al propietario de la cuenta: {email}",
    "The following numbers are already registered under another campaign: {numbers}": "Los siguientes números ya están registrados en otra campaña: {numbers}",
    "Some of the selected numbers are no longer available. Please pick again.": "Algunos de los números seleccionados ya no están disponibles. Vuelve a elegirlos.",
    "Campaign saved as draft": "Campaña guardada como borrador",
    "In review": "En revisión",
    "Deactivated": "Desactivada",
    "Deactivate": "Desactivar",
    "Choose how many messages you expect to send": "Elige cuántos mensajes esperas enviar",
    "{price} per month": "{price} al mes",
    "Low volume": "Volumen bajo",
    "High volume": "Volumen alto",
    "How many messages do you expect to send?": "¿Cuántos mensajes esperas enviar?",
    "A2P registration is not part of your current plan. Contact sales to add it.": "El registro A2P no forma parte de tu plan actual. Contacta con ventas para añadirlo.",
    "This campaign can no longer be edited": "Esta campaña ya no se puede editar",
    "Your brand is registered with the carriers. Contact support to change it.": "Tu marca está registrada con los operadores. Contacta con soporte para cambiarla.",
    "Your payment was declined. Update your payment method and try again.": "Tu pago fue rechazado. Actualiza tu método de pago e inténtalo de nuevo.",
    "A2P registration needs an active subscription.": "El registro A2P necesita una suscripción activa.",
    "A2P registration is not enabled for this account yet. Contact support.": "El registro A2P aún no está habilitado para esta cuenta. Contacta con soporte.",
    "Campaign deactivated": "Campaña desactivada",
    "Failed to deactivate campaign": "No se pudo desactivar la campaña",
    "{count} waiting for assignment": "{count} pendientes de asignación",
    "waiting for assignment": "pendiente de asignación",
    "Deactivate campaign": "Desactivar campaña",
    "Billing stops and its numbers can no longer text US recipients. This cannot be undone: you would have to register again.": "La facturación se detiene y sus números ya no podrán enviar mensajes a destinatarios de EE. UU. No se puede deshacer: tendrías que registrarte de nuevo.",
    "Submitted": "Enviado",
    "Stopped because of a billing problem on our side. Contact support.": "Detenida por un problema de facturación de nuestra parte. Contacta con soporte.",
    "Stopped because the account was closed.": "Detenida porque la cuenta se cerró.",
    "Stopped because your subscription ended.": "Detenida porque tu suscripción terminó.",
    "Stopped by you.": "Detenida por ti.",
    "Manage numbers": "Gestionar números",
    "Numbers updated": "Números actualizados",
    "Added numbers wait for support to assign them before they can text US recipients. Removed numbers stop sending at once.": "Los números que añadas esperan a que soporte los asigne antes de poder enviar mensajes a destinatarios de EE. UU. Los números que quites dejan de enviar al momento.",
    "This number isn't available for registration yet. Contact support to add it to your account.": "Este número aún no está disponible para el registro. Contacta con soporte para añadirlo a tu cuenta.",
    "The volume tier is fixed after the first submit. Contact support to change it.": "El nivel de volumen queda fijo tras el primer envío. Contacta con soporte para cambiarlo.",
    "{price} per year": "{price} al año",
    "Not available on your plan": "No disponible en tu plan",
    "We couldn't load the prices. Retry to see them before you submit.": "No pudimos cargar los precios. Reintenta para verlos antes de enviar.",
    "Note from support": "Nota de soporte",
    "Draft": "Borrador",
    "Rejected": "Rechazado",
    "This registration is already being submitted. Try again in a few minutes.": "Este registro ya se está enviando. Inténtalo de nuevo en unos minutos.",
    "SMS registration is unavailable while your account is restricted. Contact support.": "El registro de SMS no está disponible mientras tu cuenta está restringida. Contacta con soporte.",
    "Billing refused this registration. Contact support.": "La facturación rechazó este registro. Contacta con soporte.",
    "The volume tier changed since the price was shown. Check the price and submit again.": "El nivel de volumen cambió desde que se mostró el precio. Revisa el precio y vuelve a enviar.",
    "Campaign actions": "Acciones de la campaña",
    "Your account's billing country isn't confirmed yet. Contact support to confirm it.": "El país de facturación de tu cuenta aún no está confirmado. Contacta con soporte para confirmarlo.",
    "Up to 15,000 messages a month": "Hasta 15.000 mensajes al mes",
    "More than 15,000 messages a month": "Más de 15.000 mensajes al mes",
    "Due when you submit": "A pagar al enviar",
    "Brand registration {brand} and vetting {vetting}": "Registro de marca {brand} y verificación {vetting}",
    "Vetting {vetting}. Your brand is already registered.": "Verificación {vetting}. Tu marca ya está registrada.",
    "When approved, the first {months} months up front": "Al aprobarse, los primeros {months} meses por adelantado",
    "After that, renewed with your plan": "Después, se renueva con tu plan",
    "These are the carrier's fees and are not refunded, even when a registration is rejected. Resubmitting pays the vetting again.": "Son tarifas del operador y no se reembolsan, tampoco si se rechaza un registro. Al volver a enviar se paga de nuevo la verificación.",
    "Your balance doesn't cover the submission fees. Top up and submit again.": "Tu saldo no cubre las tarifas de envío. Recarga y vuelve a enviar.",
    "Add a payment method to your plan, then submit again.": "Añade un método de pago a tu plan y vuelve a enviar.",
    "Charged to your plan's payment method, plus tax where it applies.": "Se cobra al método de pago de tu plan, más los impuestos que correspondan.",
    "The submission fees changed since they were shown. Check them and submit again.": "Las tarifas de envío cambiaron desde que se mostraron. Revísalas y vuelve a enviar.",
    "{numbers} can no longer stay on this registration and will be removed when you save.": "{numbers} ya no puede seguir en este registro y se quitará al guardar.",
    "This account signs in with a different provider. Use that one, or choose Forgot Password to set a password.": "Esta cuenta inicia sesión con otro proveedor. Use ese, o elija ¿Olvidó su contraseña? para crear una contraseña.",
    "SSO authentication is disabled.": "La autenticación SSO está deshabilitada.",
    "Connect your {provider} account": "Conecta tu cuenta de {provider}",
    "This email already has an account. Enter your password to connect": "Este correo ya tiene una cuenta. Introduce tu contraseña para conectarla",
    "Incorrect password. Please try again.": "Contraseña incorrecta. Inténtalo de nuevo.",
    "Connect and log in": "Conectar e iniciar sesión",
    "Call Details": "Detalles de la llamada",
    "Call ended": "Llamada finalizada",
    "Call flow started": "Flujo de llamada iniciado",
    "Call rejected": "Llamada rechazada",
    "Could not load the call steps": "No se pudieron cargar los pasos de la llamada",
    "Flow finished": "Flujo finalizado",
    "Hung up": "Colgó",
    "Joined conference": "Se unió a la conferencia",
    "No steps were recorded for this call": "No se registraron pasos para esta llamada",
    "Played announcement": "Anuncio reproducido",
    "Queue option": "Opción de cola",
    "Recording": "Grabación",
    "Routed": "Enrutada",
    "Routed to call flow": "Enrutada al flujo de llamada",
    "Sent to device": "Enviada al dispositivo",
    "Sent to queue": "Enviada a la cola",
    "Step": "Paso",
    "Virtual hold": "Espera virtual",
    "Waited for keypad input": "Esperó una entrada del teclado",
    "Keypad input": "Entrada del teclado",
    "Caller hung up": "El llamante colgó",
    "Enter comma-separated emails": "Introduce correos electrónicos separados por comas",
    "User Defined": "Definido por el usuario",
    "You've reached the limit of three custom plans. Please remove one to add a new plan": "Has alcanzado el límite de tres planes personalizados. Elimina uno para añadir un plan nuevo",
    "The user has been signed out": "Se cerró la sesión del usuario",
    "Users will be signed out": "Se cerró la sesión de {count, plural, one {# usuario} other {# usuarios}}.",
    "Users could not be signed out": "No se pudo cerrar la sesión de {count, plural, one {# usuario} other {# usuarios}}. Inténtalo de nuevo.",
    "An administrator signed you out": "Un administrador cerró tu sesión",
    "A rate plan change is still being applied. Try again in a few minutes.": "Todavía se está aplicando un cambio de plan de tarifas. Inténtalo de nuevo en unos minutos.",
    "This rate plan cannot be applied to this account. Contact support.": "Este plan de tarifas no se puede aplicar a esta cuenta. Contacta con soporte.",
    "Currency": "Moneda",
    "Call rates are not available right now.": "Las tarifas de llamadas no están disponibles en este momento.",
    "Connection fee": "Tarifa de conexión",
    "This account has custom pricing. Contact support to change it.": "Esta cuenta tiene precios personalizados. Contacta con soporte para cambiarlos.",
    "Plan Details": "Detalles del plan",
    "The email was not changed because the user was deactivated.": "El correo electrónico no se cambió porque el usuario fue desactivado.",
    "Open the confirmation link from your email again.": "Vuelve a abrir el enlace de confirmación desde tu correo electrónico.",
    "Your password has expired": "Tu contraseña ha caducado",
    "Sign in to choose a new one": "Inicia sesión para elegir una nueva",
    "Choose a new password to continue": "Elige una nueva contraseña para continuar.",
    "Sign in with the account for {email}.": "Inicia sesión con la cuenta de {email}.",
    "Your organization has no free seats. Contact your administrator.": "Tu organización no tiene licencias disponibles. Contacta con tu administrador.",
    "This email already has an account. Please log in.": "Este correo ya tiene una cuenta. Inicia sesión.",
    "Something went wrong. Please try again.": "Algo salió mal. Inténtalo de nuevo.",
    "Your organization has no active subscription. Contact your administrator.": "Tu organización no tiene una suscripción activa. Contacta con tu administrador.",
    "We couldn't check your organization's seats. Please try again in a few minutes.": "No pudimos comprobar las licencias de tu organización. Inténtalo de nuevo en unos minutos.",
    "Delete this integration? Its API keys stop working at once.": "¿Eliminar esta integración? Sus claves API dejarán de funcionar de inmediato.",
    "On save the API key is revoked and requests using it are refused.": "Al guardar, la clave API se revoca y se rechazan las solicitudes que la usan.",
    "Show key": "Mostrar clave",
    "Hide key": "Ocultar clave",
    "Regenerate API key": "Regenerar clave API",
    "Refuse": "Rechazar",
    "Browser session": "Sesión del navegador",
    "Browser session enabled": "Sesión del navegador activada",
    "Browser session disabled": "Sesión del navegador desactivada",
    "On save the browser session will be enabled for all integrations": "Al guardar, la sesión del navegador se activará para todas las integraciones",
    "On save the browser session will be disabled for all integrations": "Al guardar, la sesión del navegador se desactivará para todas las integraciones",
    "Failed to generate API key": "No se pudo generar la clave API",
    "URL:": "URL: {url}",
    "The phone number is not valid": "El número de teléfono no es válido",
    "C2C through the browser is disabled": "El C2C a través del navegador está desactivado",
    "Click 2 Call Integration": "Integración de Click 2 Call",
    "Click 2 Call": "Click 2 Call",
    "Integration name": "Nombre de la integración",
    "Authentication": "Autenticación",
    "Allow Access From IP Whitelist Only": "Permitir el acceso solo desde la lista blanca de IP",
    "Please enable microphone permission in order to initiate a call": "Habilita el permiso del micrófono para iniciar una llamada",
    "The browser session dials phone numbers only.": "La sesión del navegador solo marca números de teléfono.",
    "This key can't be shown. Regenerate to get a new one.": "Esta clave no se puede mostrar. Regénerala para obtener una nueva.",
    "A new key replaces this integration's keys, which keep working until you save.": "Una clave nueva reemplaza las claves de esta integración, que siguen funcionando hasta que guardes.",
    "The new key could not be saved, so a new one is shown. Copy it again, then save.": "No se pudo guardar la clave nueva, así que se muestra otra. Cópiala de nuevo y luego guarda.",
    "Agent keys made through the API are revoked too when a new key is saved or the API is turned off.": "Las claves de agente creadas mediante la API también se revocan al guardar una clave nueva o al desactivar la API.",
    "Recommended: allow only the IP addresses your clicks come from, so a leaked key cannot be used elsewhere. A link the CRM opens in the agent's browser comes from your office's public IP.": "Recomendado: permite solo las direcciones IP desde las que llegan los clics, para que una clave filtrada no pueda usarse en otro lugar. Un enlace que el CRM abre en el navegador del agente llega desde la IP pública de tu oficina.",
    "Select users to remove": "Selecciona los usuarios a eliminar",
    "Pick {count} users to remove. They are deactivated on the next billing date.": "Elige {count} usuarios a eliminar. Se desactivarán en la próxima fecha de facturación.",
    "Remove {name}": "Eliminar a {name}",
    "Account Owner": "Propietario de la cuenta",
    "Invited": "Invitado",
    "Loading users…": "Cargando usuarios…",
    "{picked} of {count} selected": "{picked} de {count} seleccionados",
    "Your card was declined. The seat count has not changed.": "Tu tarjeta fue rechazada. El número de asientos no cambió.",
    "Trial seat limit reached. Start your paid plan to add more users.": "Alcanzaste el límite de asientos de la prueba. Inicia tu plan de pago para añadir más usuarios.",
    "Another plan change is still being processed. Please try again in a moment.": "Otro cambio de plan aún se está procesando. Inténtalo de nuevo en un momento.",
    "Pick which users to remove before lowering the seats.": "Elige qué usuarios eliminar antes de reducir los asientos.",
    "Seat change scheduled": "Cambio de asientos programado",
    "Seat change scheduled for {date}.": "Cambio de asientos programado para el {date}.",
    "Review seat change": "Revisar el cambio de asientos",
    "Users removed on the billing date": "Usuarios que se eliminan en la fecha de facturación",
    "{plan} requires at least {min} seats.": "{plan} requiere al menos {min} asientos.",
    "You have {count} users. Next, you'll choose who to remove.": "Tienes {count} usuarios. A continuación elegirás a quién eliminar.",
    "{plan} includes a minimum of {min} seats. You're using {used}, so {free} are free to assign.": "{plan} incluye un mínimo de {min} asientos. Usas {used}, así que {free} quedan libres para asignar.",
    "Cancel the scheduled seat change?": "¿Cancelar el cambio de asientos programado?",
    "You keep your {count} seats and nobody is removed.": "Conservas tus {count} asientos y no se elimina a nadie.",
    "Undo change": "Deshacer el cambio",
    "Seat change cancelled. You keep {count} seats.": "Cambio de asientos cancelado. Conservas {count} asientos.",
    "Scheduled changes": "Cambios programados",
    "Seats {from} → {to}": "Asientos {from} → {to}",
    "{count} seats scheduled for removal on {date}": "{count} asientos programados para eliminarse el {date}",
    "Leaving": "Salen",
    "Undo": "Deshacer",
    "Your {plan} plan has started": "Tu plan {plan} ha comenzado",
    "You can now add more users.": "Ya puedes añadir más usuarios.",
    "We couldn't start your paid plan. Your trial is unchanged.": "No pudimos iniciar tu plan de pago. Tu prueba no ha cambiado.",
    "Not now": "Ahora no",
    "Start {plan} plan": "Iniciar el plan {plan}",
    "Plan": "Plan",
    "Seats": "Asientos",
    "Current Seats": "Asientos actuales",
    "Yearly": "Anual",
    "Trial seat limit reached. Free trials include up to {cap} users.": "Alcanzaste el límite de asientos de la prueba. Las pruebas gratuitas incluyen hasta {cap} usuarios.",
    "Start paid plan now": "Iniciar el plan de pago ahora",
    "Trial": "Prueba",
    "Trial ends on {date}": "La prueba termina el {date}",
    "Free trial": "Prueba gratuita",
    "{count} trial seats left after this invite": "Quedarán {count} asientos de prueba tras esta invitación",
    "This invitation has expired. Ask your administrator to send a new one.": "Esta invitación ha caducado. Pide a tu administrador que envíe una nueva.",
    "This invitation was already accepted. Log in with your email and password instead.": "Esta invitación ya fue aceptada. Inicia sesión con tu correo y contraseña.",
    "This invitation was revoked. Ask your administrator to send a new one.": "Esta invitación fue revocada. Pide a tu administrador que envíe una nueva.",
    "That invitation no longer exists. Ask your administrator to send a new one.": "Esa invitación ya no existe. Pide a tu administrador que envíe una nueva.",
    "This billing cycle is being charged right now. Please try again in a few minutes.": "Este ciclo de facturación se está cobrando ahora mismo. Inténtalo de nuevo en unos minutos.",
    "Your wallet balance is too low for this change. Top up and try again.": "El saldo de tu monedero es insuficiente para este cambio. Recárgalo e inténtalo de nuevo.",
    "That is below your plan's minimum number of seats.": "Eso está por debajo del número mínimo de puestos de tu plan.",
    "One of the picked users can't be removed. Close this window and pick again.": "No se puede eliminar a uno de los usuarios seleccionados. Cierra esta ventana y vuelve a elegir.",
    "Users removed now": "Usuarios que se eliminan ahora",
    "Your card was declined. Your trial is unchanged.": "Tu tarjeta fue rechazada. Tu prueba no ha cambiado.",
    "Your paid plan has already started.": "Tu plan de pago ya ha comenzado.",
    "Your paid plan has already started. Check your seats in Manage Seats.": "Tu plan de pago ya ha comenzado. Revisa tus puestos en Gestionar puestos.",
    "We couldn't confirm your payment. Check your plan in a few minutes before you try again.": "No pudimos confirmar tu pago. Revisa tu plan en unos minutos antes de volver a intentarlo.",
    "Plus tax and any one-time fees.": "Más impuestos y cualquier cargo único.",
    "Your organization has reached its free trial user limit. Contact your administrator.": "Tu organización alcanzó el límite de usuarios de la prueba gratuita. Contacta a tu administrador.",
    "Charged today": "Cobrado hoy",
    "Every node must be connected to the phone number": "Cada nodo debe estar conectado al número de teléfono",
    "This destination is not allowed here": "Este destino no está permitido aquí",
    "An output can only go to one destination": "Una salida solo puede ir a un destino",
    "Choose a destination": "Elige un destino",
    "A node cannot point to itself": "Un nodo no puede apuntar a sí mismo",
    "Too many outputs on this node": "Demasiadas salidas en este nodo",
    "A phone number or extension can only start a flow, not be a step in it": "Un número de teléfono o una extensión solo puede iniciar un flujo, no ser un paso dentro de él",
    "This output does not exist on this node": "Esta salida no existe en este nodo",
    "A connection starts from a node that is not in the flow": "Una conexión parte de un nodo que no está en el flujo",
    "A node could not be identified. Reload and try again.": "No se pudo identificar un nodo. Recarga e inténtalo de nuevo.",
    "A destination no longer exists. Pick another one.": "Un destino ya no existe. Elige otro.",
    "This flow was changed elsewhere since you opened it. Reload to get the latest version.": "Este flujo se modificó en otro lugar desde que lo abriste. Recarga para obtener la versión más reciente.",
    "This number/extension already starts another flow": "Este número/extensión ya inicia otro flujo",
    "These extension digits are already in use": "Estos dígitos de extensión ya están en uso",
    "This item is in use elsewhere, so this change is not allowed": "Este elemento se usa en otro lugar, por lo que este cambio no está permitido",
    "This change conflicts with the current routing. Reload and try again.": "Este cambio entra en conflicto con el enrutamiento actual. Recarga e inténtalo de nuevo.",
    "You don't have permission to change this flow": "No tienes permiso para cambiar este flujo",
    "This node could not be loaded, so saving could change its routing. Reload and try again.": "No se pudo cargar este nodo, por lo que guardar podría cambiar su enrutamiento. Recarga e inténtalo de nuevo.",
    "Choose a phone number or extension to start the flow": "Elige un número de teléfono o una extensión para iniciar el flujo",
    "This flow already starts at another number or extension. Put it back to save.": "Este flujo ya inicia en otro número o extensión. Vuelve a ponerlo para guardar.",
    "The flow could not be saved. Try again.": "No se pudo guardar el flujo. Inténtalo de nuevo.",
    "The flow is saved, but its new name is not. Try again.": "El flujo se guardó, pero su nuevo nombre no. Inténtalo de nuevo.",
    "{node} could not be saved: {detail}": "No se pudo guardar {node}: {detail}",
    "The flow could not be saved: {detail}": "No se pudo guardar el flujo: {detail}",
    "You don't have permission to change {node}": "No tienes permiso para cambiar {node}",
    "This could not be loaded. Try again.": "No se pudo cargar. Inténtalo de nuevo.",
    "Regenerate password": "Regenerar contraseña",
    "Choose Existing Queue": "Elige una cola existente",
    "How long a caller waits before the Timeout destination": "Cuánto espera una persona que llama antes del destino de tiempo de espera",
    "When this many callers are waiting, the next one goes to the Queue full destination": "Cuando esperan tantos llamantes, el siguiente va al destino de cola llena",
    "A caller whose estimated wait is longer goes to the Wait too long destination instead of waiting": "Un llamante cuya espera estimada sea mayor va al destino de espera demasiado larga en lugar de esperar",
    "Keys used by other queue options: {keys}": "Teclas usadas por otras opciones de la cola: {keys}",
    "This key is used by another queue option": "Esta tecla la usa otra opción de la cola",
    "A queue key can only hang up without a reason": "Una tecla de la cola solo puede colgar sin motivo",
    "Could not load the inputs from other flows": "No se pudieron cargar las entradas de otros flujos",
    "DND ON": "NO MOLESTAR ACTIVO",
    "An unset Busy/DND or No Answer goes to the user's voicemail.": "Un Ocupado/No molestar o Sin respuesta sin configurar va al buzón de voz del usuario.",
    "An unset Busy/DND or No Answer hangs up.": "Un Ocupado/No molestar o Sin respuesta sin configurar cuelga la llamada.",
    "Queue full needs a caller limit, set on the Call queue screen": "Cola llena necesita un límite de llamantes, configurado en la pantalla de la cola de llamadas",
    "Wait too long needs an estimated-wait limit, set on the Call queue screen": "Espera demasiado larga necesita un límite de espera estimada, configurado en la pantalla de la cola de llamadas",
    "The flow is saved, but this user's settings were not: the user has no account in the app": "El flujo se guardó, pero la configuración de este usuario no: el usuario no tiene una cuenta en la aplicación",
    "The flow is saved, but the user's settings did not reach the phone system. Try again.": "El flujo se guardó, pero la configuración del usuario no llegó al sistema telefónico. Inténtalo de nuevo.",
    "{name} on {date}": "{name} el {date}",
    "Last Edited By": "Última edición por",
    "Annual invoice": "Factura anual",
    "Cancel the scheduled plan change?": "¿Cancelar el cambio de plan programado?",
    "Confirm change": "Confirmar el cambio",
    "Confirm changes": "Confirmar los cambios",
    "Confirm plan change": "Confirmar el cambio de plan",
    "Contact sales": "Contactar con ventas",
    "Current plan": "Plan actual",
    "Downgrade": "Bajar de plan",
    "Downgrade cancelled. You stay on {plan}.": "Bajada de plan cancelada. Sigues en {plan}.",
    "Downgrade to {plan}": "Bajar a {plan}",
    "Free during your trial · You'll be charged {amount} on {date}": "Gratis durante la prueba · Se te cobrará {amount} el {date}",
    "Free trials include up to {cap} users.": "Las pruebas gratuitas incluyen hasta {cap} usuarios.",
    "No refund": "Sin reembolso",
    "Plan changed to {plan} · {seats} seats · {total} / {period}.": "Plan cambiado a {plan} · {seats} asientos · {total} / {period}.",
    "Seats drop to {count} on your next billing date": "Los asientos bajan a {count} en tu próxima fecha de facturación",
    "Switch to monthly": "Cambiar a mensual",
    "Switch to yearly": "Cambiar a anual",
    "Takes effect on {date}": "Entra en vigor el {date}",
    "Takes effect today": "Entra en vigor hoy",
    "These changes take effect on {date}, your next billing date.": "Estos cambios entran en vigor el {date}, tu próxima fecha de facturación.",
    "Year": "Año",
    "You stay on {plan}.": "Sigues en {plan}.",
    "You're now on {plan}. Your trial continues until {date}.": "Ahora estás en {plan}. Tu prueba continúa hasta el {date}.",
    "You're using {count} seats. Deactivate users to go lower.": "Usas {count} asientos. Desactiva usuarios para bajar.",
    "Your plan changed, but the seat count could not be lowered. Try Manage Seats.": "Tu plan cambió, pero no se pudo reducir el número de asientos. Prueba en Gestionar asientos.",
    "Your plan changes to {plan} on {date}.": "Tu plan cambia a {plan} el {date}.",
    "{amount} charged now (prorated)": "{amount} cobrados ahora (prorrateado)",
    "{count} seats ({plan} minimum)": "{count} asientos (mínimo de {plan})",
    "{plan} includes a minimum of {min} seats. You'll be billed for {seats} seats; you're using {used}, so {free} are free to assign.": "{plan} incluye un mínimo de {min} asientos. Se te facturarán {seats} asientos; usas {used}, así que {free} quedan libres para asignar.",
    "{price} / user / {period}": "{price} / usuario / {period}",
    "To upgrade, stay on yearly billing. You can switch to monthly at the end of your term.": "Para mejorar el plan, mantén la facturación anual. Puedes cambiar a mensual al final de tu periodo.",
    "Your billing period can't change while phone numbers are billed on this plan. Contact support.": "No puedes cambiar el periodo de facturación mientras haya números de teléfono facturados en este plan. Contacta con soporte.",
    "We couldn't change your plan. Please try again.": "No pudimos cambiar tu plan. Inténtalo de nuevo.",
    "We couldn't price that change. Please try again.": "No pudimos calcular el precio de ese cambio. Inténtalo de nuevo.",
    "Monthly invoice": "Factura mensual",
    "Price / Seat": "Precio / puesto",
    "We couldn't load the plans right now. Please try again shortly.": "No pudimos cargar los planes ahora. Inténtalo de nuevo en breve.",
    "Total file size exceeds the 4MB limit.": "El tamaño total de los archivos supera el límite de 4MB.",
    "ticket created without number": "¡Listo! He creado tu ticket de soporte. Nuestro equipo te responderá en cuanto tengamos novedades. Revisa tu bandeja de entrada",
    "Locked": "Bloqueado",
    "Resume subscription": "Reanudar la suscripción",
    "We couldn't resume your subscription. Please try again.": "No pudimos reanudar tu suscripción. Inténtalo de nuevo.",
    "WhatsApp needs an active subscription": "WhatsApp requiere una suscripción activa",
    "{plan} has no WhatsApp. These numbers are disconnected on the change date: {numbers}": "{plan} no incluye WhatsApp. Estos números se desconectan en la fecha del cambio: {numbers}",
    "WhatsApp switched off": "WhatsApp desactivado",
    "Plan change cancelled. You stay on your current plan.": "Cambio de plan cancelado. Sigues en tu plan actual.",
    "WhatsApp isn't on your next plan": "WhatsApp no está en tu próximo plan",
    "Your plan is set to change to one without WhatsApp. Keep your current plan to connect WhatsApp.": "Tu plan va a cambiar a uno sin WhatsApp. Mantén tu plan actual para conectar WhatsApp.",
    "Your scheduled plan has no WhatsApp. Undo the plan change to connect WhatsApp.": "Tu plan programado no incluye WhatsApp. Deshaz el cambio de plan para conectar WhatsApp.",
    "Your subscription is set to cancel. Resume it to connect WhatsApp.": "Tu suscripción está configurada para cancelarse. Reanúdala para conectar WhatsApp.",
    "Your subscription will continue.": "Tu suscripción continuará.",
    "Cancellation scheduled. Your plan ends on {date}.": "Cancelación programada. Tu plan termina el {date}.",
    "Go back": "Volver",
    "Keep subscription": "Mantener la suscripción",
    "Keep your subscription?": "¿Mantener tu suscripción?",
    "Minimum {count} characters.": "Mínimo {count} caracteres.",
    "Please tell us more": "Cuéntanos más",
    "Select a reason": "Selecciona un motivo",
    "Type CANCEL to confirm": "Escribe CANCEL para confirmar",
    "Undo cancellation": "Deshacer la cancelación",
    "We couldn't cancel your subscription. Please try again.": "No pudimos cancelar tu suscripción. Inténtalo de nuevo.",
    "What's the main reason for cancelling?": "¿Cuál es el motivo principal de la cancelación?",
    "Your cancellation is scheduled for {date}.": "Tu cancelación está programada para el {date}.",
    "Your phone numbers are held for 30 days, then released. To keep them, port them to another provider before cancelling.": "Tus números se conservan 30 días y luego se liberan. Para conservarlos, pórtalos a otro proveedor antes de cancelar.",
    "Your plan stays active until {date}. No refunds are given for the current billing period.": "Tu plan sigue activo hasta el {date}. No se reembolsa el periodo de facturación actual.",
    "Your team loses access to calls, messages and the app.": "Tu equipo pierde el acceso a llamadas, mensajes y la aplicación.",
    "Your {plan} plan will continue and renew on {date}. Scheduled changes you had before cancelling are not restored.": "Tu plan {plan} continuará y se renovará el {date}. Los cambios programados que tenías antes de cancelar no se restauran.",
    "Too expensive": "Demasiado caro",
    "Missing a feature we need": "Falta una función que necesitamos",
    "Call quality or reliability issues": "Problemas de calidad o fiabilidad de las llamadas",
    "Switching to another provider": "Nos cambiamos a otro proveedor",
    "Too difficult to set up or use": "Demasiado difícil de configurar o usar",
    "We no longer need a phone system": "Ya no necesitamos un sistema telefónico",
    "No contacts left to call. Every number in the call list was already dialed or skipped": "No quedan contactos por llamar. Todos los números de la lista de llamadas ya se marcaron o se omitieron",
    "Wrong number": "Número equivocado",
    "Network error": "Error de red",
    "On the Do Not Call list": "En la lista de No llamar",
    "Your account closes now. You won't be charged.": "Tu cuenta se cierra ahora. No se te cobrará.",
    "Users can't sign in. Calls and messages stop.": "Los usuarios no podrán iniciar sesión. Las llamadas y los mensajes se detienen.",
    "Numbers are held for 30 days, then released.": "Los números se reservan durante 30 días y luego se liberan.",
    "Data is deleted after 30 days.": "Los datos se eliminan después de 30 días.",
    "Your trial has already ended.": "Tu prueba ya ha finalizado.",
    "We couldn't end your trial. Please try again.": "No pudimos finalizar tu prueba. Inténtalo de nuevo.",
    "This account is closed. Ask the account owner to reactivate it.": "Esta cuenta está cerrada. Pide al propietario de la cuenta que la reactive.",
    "Your account is still closing. Please try again in a minute.": "Tu cuenta aún se está cerrando. Inténtalo de nuevo en un minuto.",
    "Your card was declined. Your account is still closed.": "Tu tarjeta fue rechazada. Tu cuenta sigue cerrada.",
    "There's no card on file. Contact support to reactivate your account.": "No hay ninguna tarjeta registrada. Contacta con soporte para reactivar tu cuenta.",
    "We couldn't reactivate your account. Please try again.": "No pudimos reactivar tu cuenta. Inténtalo de nuevo.",
    "Account reactivated. Your {plan} plan has started.": "Cuenta reactivada. Tu plan {plan} ha comenzado.",
    "Cancelled": "Cancelado",
    "Reactivate account": "Reactivar cuenta",
    "Account closed {closed} · Number held until {held}": "Cuenta cerrada el {closed} · Número reservado hasta el {held}",
    "No upcoming invoice": "No hay próxima factura",
    "Reactivating starts your plan today and charges your saved card.": "Al reactivar, tu plan empieza hoy y se cobra en tu tarjeta guardada.",
    "Sign out": "Cerrar sesión",
    "This account is closed. The account owner can sign in to reactivate it.": "Esta cuenta está cerrada. El propietario de la cuenta puede iniciar sesión para reactivarla.",
    "A ring group cannot route to itself": "Un grupo de timbre no puede enrutar hacia sí mismo",
    "A forward cannot route to itself": "Un reenvío no puede enrutar hacia sí mismo",
    "An announcement cannot route to itself": "Un anuncio no puede enrutar hacia sí mismo",
    "The flow is saved, but you don't have permission to change this user's settings": "El flujo se guardó, pero no tienes permiso para cambiar la configuración de este usuario",
    "The flow is saved, but the user's settings could not be saved. Try again.": "El flujo se guardó, pero no se pudo guardar la configuración del usuario. Inténtalo de nuevo.",
    "Not started": "No iniciado",
    "These changes take effect today.": "Estos cambios se aplican hoy.",
    "IVRs": "IVR",
    "Call flows": "Flujos de llamadas",
    "Web widgets": "Widgets web",
    "AI hours": "Horas de IA",
    "Choose what to keep": "Elige qué conservar",
    "Turned off automatically": "Desactivado automáticamente",
    "Settings that are turned off are kept, and come back on when you upgrade.": "La configuración desactivada se conserva y vuelve a activarse cuando mejoras el plan.",
    "A wallboard can have at most {max} stats resets.": "Un tablero puede tener como máximo {max} reinicios de estadísticas.",
    "The server rejected these wallboard settings: {fields}": "El servidor rechazó estos ajustes del tablero: {fields}",
    "Texting campaigns": "Campañas de mensajes de texto",
    "{plan} includes {count} texting campaigns. Choose what happens to each one.": "{plan} incluye {count, plural, one {# campaña de mensajes de texto} other {# campañas de mensajes de texto}}. Elige qué pasa con cada una.",
    "What happens to {name}": "Qué pasa con {name}",
    "Keep · included": "Conservar · incluida",
    "Keep · {price}/mo": "Conservar · {price}/mes",
    "Keep · paid": "Conservar · de pago",
    "Deregister": "Dar de baja",
    "WhatsApp numbers": "Números de WhatsApp",
    "Data at risk": "Datos en riesgo",
    "These WhatsApp numbers stop receiving messages on the change date: {numbers}": "Estos números de WhatsApp dejarán de recibir mensajes en la fecha del cambio: {numbers}",
    "Texting campaigns kept free: {count}": "Campañas de mensajes de texto conservadas gratis: {count}",
    "Texting campaigns kept and paid: {count}": "Campañas de mensajes de texto conservadas de pago: {count}",
    "Texting campaigns deregistered: {count}": "Campañas de mensajes de texto dadas de baja: {count}",
    "WhatsApp numbers kept: {count}": "Números de WhatsApp conservados: {count}",
    "WhatsApp numbers disconnected: {count}": "Números de WhatsApp desconectados: {count}",
    "Keep · {price}/yr": "Conservar · {price}/año",
    "We couldn't load your texting campaigns and WhatsApp numbers. Close this window and try again.": "No pudimos cargar tus campañas de mensajes de texto y números de WhatsApp. Cierra esta ventana e inténtalo de nuevo.",
    "Your texting campaigns or WhatsApp numbers changed. Close this window and try again.": "Tus campañas de mensajes de texto o números de WhatsApp cambiaron. Cierra esta ventana e inténtalo de nuevo.",
    "Disconnect": "Desconectar",
    "Call flows {list} use this queue. Edit them before {when}.": "Los flujos de llamadas {list} usan esta cola. Edítalos antes del {when}.",
    "Call queues are not available on the new plan.": "Las colas de llamadas no están disponibles en el nuevo plan.",
    "Call queues redirected: {count}": "Colas de llamadas redirigidas: {count}",
    "Call recording becomes manual": "La grabación de llamadas pasa a ser manual",
    "Convert queues to ring groups": "Convertir colas en grupos de timbrado",
    "Dialer campaigns are paused": "Las campañas del marcador se pausan",
    "Download recordings": "Descargar grabaciones",
    "I understand these routes will stop working": "Entiendo que estas rutas dejarán de funcionar",
    "IVR": "IVR",
    "Inbound · {route} → {trunk}": "Entrante · {route} → {trunk}",
    "Live wallboards turn off": "Los paneles en vivo se desactivan",
    "New destination for {name}": "Nuevo destino para {name}",
    "Outbound · {route} → {trunk}": "Saliente · {route} → {trunk}",
    "Recordings kept for {months} months": "Grabaciones conservadas {months} meses",
    "Recordings older than {months} months become read-only on {when} and are deleted 30 days later.": "Las grabaciones de más de {months} meses pasan a ser de solo lectura el {when} y se eliminan 30 días después.",
    "Redirect calls": "Redirigir llamadas",
    "Ring group": "Grupo de timbrado",
    "Ring group with the same agents": "Grupo de timbrado con los mismos agentes",
    "SIP trunks stop working on {when}.": "Los troncales SIP dejan de funcionar el {when}.",
    "SIP trunks switched off": "Troncales SIP desactivados",
    "SMS to email turns off": "SMS a correo se desactiva",
    "Sticky agent, skill-based routing and call barging turn off": "Agente fijo, enrutamiento por habilidades e intrusión en llamadas se desactivan",
    "Used by {list}": "Usado por {list}",
    "Web widget is removed": "Se elimina el widget web",
    "Web widget: chat is removed, calls only": "Widget web: se elimina el chat, solo llamadas",
    "WhatsApp inbox turns off": "La bandeja de WhatsApp se desactiva",
    "Whisper turns off": "El susurro se desactiva",
    "today": "hoy",
    "Auto Top-up saved. Your card was charged {amount}.": "Recarga automática guardada. Se cobró {amount} a tu tarjeta.",
    "Your balance is below {threshold}, so your card will be charged {amount} now. Then it tops up whenever the balance falls below {threshold}.": "Tu saldo está por debajo de {threshold}, así que se cobrarán {amount} a tu tarjeta ahora. Después se recargará cada vez que el saldo baje de {threshold}.",
    "Save and top up": "Guardar y recargar",
    "The card was not charged, so auto top-up was not saved. Check your card and try again.": "No se cobró a la tarjeta, así que la recarga automática no se guardó. Revisa tu tarjeta e inténtalo de nuevo.",
    "We couldn't confirm whether your card was charged. Check your balance before trying again.": "No pudimos confirmar si se cobró a tu tarjeta. Revisa tu saldo antes de volver a intentarlo.",
    "Complete the card verification, then save auto top-up again.": "Completa la verificación de la tarjeta y luego vuelve a guardar la recarga automática.",
    "Payment received. Once your balance updates, save auto top-up again.": "Pago recibido. Cuando se actualice tu saldo, vuelve a guardar la recarga automática.",
    "Your card was charged {amount}, but auto top-up was not saved. Save it again.": "Se cobró {amount} a tu tarjeta, pero la recarga automática no se guardó. Vuelve a guardarla.",
    "Your balance could not be loaded. Try again in a moment.": "No se pudo cargar tu saldo. Inténtalo de nuevo en un momento.",
    "Choose destination": "Elegir destino",
    "Only someone who can manage call queues can make this change.": "Solo alguien que pueda gestionar las colas de llamadas puede hacer este cambio.",
    "We couldn't load your call queues and SIP trunks.": "No pudimos cargar tus colas de llamadas y troncales SIP.",
    "We couldn't check which call flows use this queue.": "No pudimos comprobar qué flujos de llamadas usan esta cola.",
    "Your call queues or SIP trunks changed. Close this window and try again.": "Tus colas de llamadas o troncales SIP cambiaron. Cierra esta ventana e inténtalo de nuevo.",
    "Back to your account": "Volver a tu cuenta",
    "Your account's data was deleted 30 days after it closed. Sign up again to start over.": "Los datos de tu cuenta se eliminaron 30 días después del cierre. Regístrate de nuevo para empezar otra vez.",
    "Your data was deleted": "Tus datos se eliminaron",
    "Your data": "Tus datos",
    "You can view and download your call logs, recordings and reports until {date}. After that they are deleted for good.": "Puedes ver y descargar tus registros de llamadas, grabaciones e informes hasta el {date}. Después se eliminan para siempre.",
    "Logging out in {seconds}s": "Cerrando sesión en {seconds}s",
    "Your account signs in with Google or Microsoft. Set a password to also log in with your email.": "Tu cuenta inicia sesión con Google o Microsoft. Define una contraseña para iniciar sesión también con tu correo.",
    "Set a password": "Definir una contraseña",
    "Check your email": "Revisa tu correo",
    "We've emailed you a link to set your password.": "Te enviamos un enlace por correo para definir tu contraseña.",
    "Link sent": "Enlace enviado",
    "Download your invoices before then too. After that, email support@pbx.im for a copy.": "Descarga también tus facturas antes de esa fecha. Después, escribe a support@pbx.im para pedir una copia.",
    "Need an invoice? Email support@pbx.im for a copy.": "¿Necesitas una factura? Escribe a support@pbx.im para pedir una copia.",
    "Could not change the password": "No se pudo cambiar la contraseña",
    "Change your own password from your Profile page": "Cambia tu propia contraseña desde tu página de Perfil",
    "This user is deactivated": "Este usuario está desactivado",
    "Set user password intro": "Elige una nueva contraseña para {name} y compártela de forma segura. Su contraseña actual dejará de funcionar.",
    "This Google or Microsoft account is already connected to a PBX account. Sign in instead.": "Esta cuenta de Google o Microsoft ya está conectada a una cuenta de PBX. Inicia sesión en su lugar.",
    "Your account was created. Please sign in.": "Tu cuenta se creó. Inicia sesión.",
    "sso account already linked": "Esta cuenta de Google o Microsoft ya está vinculada a otro usuario. Elige otra cuenta.",
    "This node is deactivated. Calls routed to it won't go through.": "Este nodo está desactivado. Las llamadas dirigidas a él no se completarán.",
    "SMS isn't active on this number yet": "El SMS aún no está activo en este número",
    "You don't have permission to change the linked inbox": "No tienes permiso para cambiar la bandeja vinculada",
    "You're not allowed to send from this number": "No tienes permiso para enviar desde este número",
    "You're not a member of this inbox": "No eres miembro de esta bandeja",
    "This number is no longer available for messaging": "Este número ya no está disponible para mensajes",
    "This number is routed to another inbox": "Este número está enrutado a otra bandeja",
    "Could not load SMS settings": "No se pudo cargar la configuración de SMS",
    "This message is too long to send": "Este mensaje es demasiado largo para enviarlo",
    "Attempted": "Intentado",
    "Could not load your numbers": "No se pudieron cargar tus números",
    "Busy/DND": "Ocupado/No molestar",
    "A number changed while syncing. Run Sync Numbers again.": "Un número cambió durante la sincronización. Vuelve a ejecutar Sincronizar números.",
    "Could not import the message templates. Run Sync Templates to try again.": "No se pudieron importar las plantillas de mensajes. Ejecuta Sincronizar plantillas para intentarlo de nuevo.",
    "Could not read the WhatsApp Business Account details from Meta: {reason}": "No se pudieron leer los datos de la cuenta de WhatsApp Business desde Meta: {reason}",
    "Could not read the phone numbers from Meta. Run Sync Numbers to try again.": "No se pudieron leer los números de teléfono desde Meta. Ejecuta Sincronizar números para intentarlo de nuevo.",
    "Could not refresh the number status from Meta. Run Sync Numbers to update it.": "No se pudo actualizar el estado del número desde Meta. Ejecuta Sincronizar números para actualizarlo.",
    "Could not subscribe to Meta webhooks, so template status updates will not arrive. Disconnect and connect again to retry.": "No se pudo suscribir a los webhooks de Meta, por lo que no llegarán las actualizaciones de estado de las plantillas. Desconecta y vuelve a conectar para reintentarlo.",
    "Could not unsubscribe from Meta webhooks: {reason}": "No se pudo cancelar la suscripción a los webhooks de Meta: {reason}",
    "Failed to complete WhatsApp connection.": "No se pudo completar la conexión con WhatsApp.",
    "Failed to disconnect the WhatsApp Business Account. Please try again.": "No se pudo desconectar la cuenta de WhatsApp Business. Inténtalo de nuevo.",
    "Failed to start the WhatsApp connection. Please try again.": "No se pudo iniciar la conexión con WhatsApp. Inténtalo de nuevo.",
    "Failed to sync WhatsApp numbers. Please try again.": "No se pudieron sincronizar los números de WhatsApp. Inténtalo de nuevo.",
    "Failed to sync WhatsApp templates. Please try again.": "No se pudieron sincronizar las plantillas de WhatsApp. Inténtalo de nuevo.",
    "Failed to update the assignment. Please try again.": "No se pudo actualizar la asignación. Inténtalo de nuevo.",
    "Meta could not complete the sign-in. Please try again.": "Meta no pudo completar el inicio de sesión. Inténtalo de nuevo.",
    "Meta could not complete the sign-in: {reason}": "Meta no pudo completar el inicio de sesión: {reason}",
    "Meta is limiting requests right now. Try again in a few minutes.": "Meta está limitando las solicitudes en este momento. Inténtalo de nuevo en unos minutos.",
    "Meta is not responding right now. Try again later.": "Meta no responde en este momento. Inténtalo de nuevo más tarde.",
    "Meta rejected the request.": "Meta rechazó la solicitud.",
    "Meta rejected the request: {reason}": "Meta rechazó la solicitud: {reason}",
    "No WhatsApp Business Account is connected. Connect one first.": "No hay ninguna cuenta de WhatsApp Business conectada. Conecta una primero.",
    "No WhatsApp Business Account was shared. In the Meta window, select a WhatsApp Business Account and try again.": "No se compartió ninguna cuenta de WhatsApp Business. En la ventana de Meta, selecciona una cuenta de WhatsApp Business e inténtalo de nuevo.",
    "Not all numbers could be read from Meta, so some may be out of date. Run Sync Numbers again.": "No se pudieron leer todos los números desde Meta, así que algunos pueden estar desactualizados. Vuelve a ejecutar Sincronizar números.",
    "Not all templates could be read from Meta. Run Sync Templates to finish importing them.": "No se pudieron leer todas las plantillas desde Meta. Ejecuta Sincronizar plantillas para terminar de importarlas.",
    "Number {number} cannot send messages yet because its ownership is not verified. Verify it in WhatsApp Manager, then run Sync Numbers.": "El número {number} aún no puede enviar mensajes porque su titularidad no está verificada. Verifícalo en WhatsApp Manager y luego ejecuta Sincronizar números.",
    "Number {number} cannot send messages yet because its ownership verification has expired. Verify it again in WhatsApp Manager, then run Sync Numbers.": "El número {number} aún no puede enviar mensajes porque la verificación de su titularidad caducó. Vuelve a verificarlo en WhatsApp Manager y luego ejecuta Sincronizar números.",
    "Number {number} could not be registered for sending because Meta blocked it after too many attempts. Try again in 72 hours.": "No se pudo registrar el número {number} para enviar porque Meta lo bloqueó tras demasiados intentos. Inténtalo de nuevo en 72 horas.",
    "Number {number} could not be registered for sending because its two-step verification PIN does not match. Contact support.": "No se pudo registrar el número {number} para enviar porque su PIN de verificación en dos pasos no coincide. Contacta con soporte.",
    "Number {number} isn't ready to send messages yet. Check it in WhatsApp Manager, wait a few minutes, then run Sync Numbers.": "El número {number} aún no está listo para enviar mensajes. Revísalo en WhatsApp Manager, espera unos minutos y luego ejecuta Sincronizar números.",
    "Number {number} could not be synced: {reason}": "No se pudo sincronizar el número {number}: {reason}",
    "Number {number} is already connected to another PBX.IM account. Disconnect it there first, then run Sync Numbers.": "El número {number} ya está conectado a otra cuenta de PBX.IM. Desconéctalo allí primero y luego ejecuta Sincronizar números.",
    "Numbers were not registered for sending because the registration PIN is not configured. Contact support.": "Los números no se registraron para enviar porque el PIN de registro no está configurado. Contacta con soporte.",
    "One of the selected users no longer exists.": "Uno de los usuarios seleccionados ya no existe.",
    "The WhatsApp sign-in expired or was already used. Please try again.": "El inicio de sesión de WhatsApp caducó o ya se usó. Inténtalo de nuevo.",
    "The connection to WhatsApp has expired. Disconnect and connect again.": "La conexión con WhatsApp caducó. Desconecta y vuelve a conectar.",
    "The sign-in window was blocked. Allow pop-ups for this site and try again.": "Se bloqueó la ventana de inicio de sesión. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.",
    "This WhatsApp Business Account is already being connected. Wait a moment, then refresh the page.": "Esta cuenta de WhatsApp Business ya se está conectando. Espera un momento y luego actualiza la página.",
    "This WhatsApp Business Account is already connected to another PBX.IM account. Disconnect it there first, then try again.": "Esta cuenta de WhatsApp Business ya está conectada a otra cuenta de PBX.IM. Desconéctala allí primero e inténtalo de nuevo.",
    "This WhatsApp sign-in was started from a different account. Please try again from this account.": "Este inicio de sesión de WhatsApp se inició desde otra cuenta. Inténtalo de nuevo desde esta cuenta.",
    "This account already has a different WhatsApp Business Account connected. Disconnect it first, then try again.": "Esta cuenta ya tiene conectada otra cuenta de WhatsApp Business. Desconéctala primero e inténtalo de nuevo.",
    "WhatsApp Business Account {ids} is already connected to another PBX.IM account, so it was not connected here.": "La cuenta de WhatsApp Business {ids} ya está conectada a otra cuenta de PBX.IM, por lo que no se conectó aquí.",
    "WhatsApp is not configured on this environment.": "WhatsApp no está configurado en este entorno.",
    "{count} number(s) are no longer on this WhatsApp Business Account and were removed.": "{count} número(s) ya no están en esta cuenta de WhatsApp Business y se eliminaron.",
    "Sync Numbers": "Sincronizar números",
    "WhatsApp Business account disconnected successfully": "La cuenta de WhatsApp Business se desconectó correctamente",
    "Voicemail delete timeout exit hint": "Las llamadas a {names} se desvían aquí. Para cambiarlo, vaya a Configuraciones > Usuarios > Editar usuario > Manejo de llamadas.",
    "Voicemail delete kept missed-call hint": "{names} todavía lo usan como su antiguo buzón de llamadas perdidas, y aún no hay una pantalla para quitarlo. Contacte con soporte para quitarlo.",
    "Archiving this inbox unroutes": "Archivar esta bandeja quita el enrutamiento de {items}. No se entregarán a nadie hasta que vuelva a enrutarlos, y desarchivarla no los restaura.",
    "Name deactivated": "{name} (desactivado)",
    "Where this voicemail delivers could not be loaded.": "No se pudo cargar a dónde entrega este buzón de voz.",
    "Where these voicemails deliver could not be loaded, so Type and Destination read Unknown.": "No se pudo cargar a dónde entregan estos buzones de voz, por lo que Tipo y Destino muestran Desconocido.",
    "Missed-call voicemail": "Buzón de voz para llamadas perdidas",
    "The selected voicemail no longer exists": "El buzón de voz seleccionado ya no existe",
    "This user has no phone account": "Este usuario no tiene una cuenta telefónica",
    "Too many changes at once. Try again in a minute": "Demasiados cambios a la vez. Inténtelo de nuevo en un minuto",
    "Campaign": "Campaña",
    "Name archived": "{name} (archivada)",
    "Unrecognised route": "Ruta no reconocida",
    "This account has too many inboxes to show where voicemails deliver, so Type and Destination read Unknown.": "Esta cuenta tiene demasiadas bandejas para mostrar a dónde entregan los buzones de voz, por lo que Tipo y Destino muestran Desconocido.",
    "Destinations were not searched, only names and emails.": "No se buscó en los destinos, solo en nombres y correos electrónicos.",
    "Filtering by Type is unavailable right now, so all voicemails are shown.": "Filtrar por Tipo no está disponible en este momento, por lo que se muestran todos los buzones de voz.",
    "People's names are not searched without permission to view users.": "Los nombres de las personas no se buscan sin permiso para ver los usuarios.",
    "You are about to leave this group.": "Estás a punto de salir de este grupo.",
    "The flow is saved, but the voicemail's owner was not changed. Try again.": "El flujo se guardó, pero no se cambió el propietario del buzón de voz. Inténtalo de nuevo.",
    "Account balance too low — contact your administrator": "Saldo de la cuenta insuficiente — comunícate con tu administrador",
    "This person opted out of your messages.": "Esta persona se dio de baja de tus mensajes.",
    "This number can't receive texts. Check the number.": "Este número no puede recibir SMS. Revisa el número.",
    "Texts from this number can't carry attachments.": "Los SMS desde este número no pueden incluir archivos adjuntos.",
    "This message could not be sent.": "No se pudo enviar este mensaje.",
    "Change Plan": "Cambiar plan",
    "{count} seats have been added to your account.": "{count, plural, one {Se añadió # puesto a tu cuenta.} other {Se añadieron # puestos a tu cuenta.}}",
    "{count} seats will be removed on {date}.": "{count, plural, one {Se quitará # puesto el {date}.} other {Se quitarán # puestos el {date}.}}",
    "{count} seats have been removed from your account.": "{count, plural, one {Se quitó # puesto de tu cuenta.} other {Se quitaron # puestos de tu cuenta.}}",
    "Seats Changed Successfully": "Puestos cambiados correctamente",
    "Remove Users To Decrease Seats": "Quitar usuarios para reducir puestos",
    "More than {cap} seats starts your paid plan.": "Más de {cap} puestos inicia tu plan de pago.",
    "To decrease the seats <b>{count}</b> users need to be removed.": "{count, plural, one {Para reducir los puestos hay que quitar <b>#</b> usuario.} other {Para reducir los puestos hay que quitar <b>#</b> usuarios.}}",
    "Yearly invoice after trial": "Factura anual tras la prueba",
    "Monthly invoice after trial": "Factura mensual tras la prueba",
    "Trial Seats": "Puestos de prueba",
    "Change Seats": "Cambiar puestos",
    "Trial includes {cap} seats.": "La prueba incluye {cap} puestos.",
    "Seats used": "Puestos usados",
    "{used} of {total}": "{used} de {total}",
    "Price / Seat after trial": "Precio / puesto tras la prueba",
    "scheduled for deactivation": "programado para desactivación",
    "Max Number Of Users": "Número máximo de usuarios",
    "ACD, Auto Attendant, Skill-Based Routing": "ACD, operadora automática, enrutamiento por habilidades",
    "MP3 Call Recordings Storage": "Almacenamiento de grabaciones MP3",
    "Support Channels": "Canales de soporte",
    "Support Availability": "Disponibilidad del soporte",
    "Available Seats": "Puestos disponibles",
    "Trial limit: {cap}": "Límite de prueba: {cap}",
    "Plan Max Users": "Máximo de usuarios del plan",
    "Trial • {days, plural, one {# day} other {# days}} left": "Prueba • {days, plural, one {queda # día} other {quedan # días}}",
    "The new plan has been added to your account.": "El nuevo plan se añadió a tu cuenta.",
    "Transaction didn’t go through": "La transacción no se completó",
    "Please update your payment method or add funds to complete your purchase.": "Actualiza tu método de pago o añade fondos para completar la compra.",
    "Start Plan": "Iniciar plan",
    "Need More Than {cap} Users?": "¿Necesitas más de {cap} usuarios?",
    "Trial includes {cap} seats. Start your {plan} plan to add more users, buy numbers and send business SMS.": "La prueba incluye {cap} puestos. Inicia tu plan {plan} para añadir usuarios, comprar números y enviar SMS empresariales.",
    "Your trial ends today.": "Tu prueba termina hoy.",
    "Plan Max Seats": "Máximo de puestos del plan",
    "Plus tax, numbers, add-ons and any one-time fees.": "Más impuestos, números, complementos y cualquier cargo único.",
    "Your price list: {name}": "Tu lista de precios: {name}",
    "Contact support to change your prices.": "Contacta con soporte para cambiar tus precios.",
    "Your price list is being updated": "Tu lista de precios se está actualizando",
    "Check back in a few minutes.": "Vuelve a consultar en unos minutos.",
    "Your price list is being updated. Your prices will show here when it is ready.": "Tu lista de precios se está actualizando. Tus precios aparecerán aquí cuando esté lista.",
    "This account has its own price list. Contact support to change it.": "Esta cuenta tiene su propia lista de precios. Contacta con soporte para cambiarla.",
    "Your own price list": "Tu lista de precios",
    "Available on paid plans.": "Disponible en planes de pago.",
    "Upgrade To Continue": "Mejora tu plan para continuar",
    "This feature is included in {plan}, a paid plan.": "Esta función está incluida en {plan}, un plan de pago.",
    "Before You Downgrade": "Antes de bajar de plan",
    "Remove these features": "Elimina estas funciones",
    "Not available in new plan": "No disponible en el nuevo plan",
    "Upon switching you will lose access to these features.": "Al cambiar perderás el acceso a estas funciones.",
    "Some features will have to be removed before you can downgrade the plan.": "Debes eliminar algunas funciones antes de poder bajar de plan.",
    "Plan change scheduled": "Cambio de plan programado",
    "Prorated Charges": "Cargos prorrateados",
    "/ user / {period}": "/ usuario / {period}",
    "{plan} Plan": "Plan {plan}",
    "Nevermind": "No importa",
    "On {date}": "El {date}",
    "Your remaining credit balance of {amount} expires.": "Tu saldo de crédito restante de {amount} caduca.",
    "Tell us what we can improve": "Cuéntanos qué podemos mejorar",
    "Optional answer": "Respuesta opcional",
    "Cancel your free plan?": "¿Cancelar tu plan gratuito?",
    "End Trial": "Finalizar prueba",
    "What happens next": "Qué pasa ahora",
    "Extend Trial": "Extender prueba",
    "Need more time to decide?": "¿Necesitas más tiempo para decidir?",
    "We'll add {days} free days to your trial so you can finish evaluating.": "Añadiremos {days} días gratis a tu prueba para que puedas terminar de evaluar.",
    "Your trial now ends on {date}.": "Tu prueba ahora termina el {date}.",
    "Your trial was already extended.": "Tu prueba ya se extendió.",
    "We couldn't extend your trial. Please try again.": "No pudimos extender tu prueba. Inténtalo de nuevo.",
    "Verification attempts": "Intentos de verificación",
    "Attempt {current} of {max}": "Intento {current} de {max}",
    "We couldn't place the holds on your card. Please try again.": "No pudimos aplicar las retenciones en tu tarjeta. Inténtalo de nuevo.",
    "Your bank didn't confirm the hold. Try again to finish the check.": "Tu banco no confirmó la retención. Inténtalo de nuevo para terminar la comprobación.",
    "These holds have expired. Place new ones to verify your card.": "Estas retenciones han caducado. Aplica unas nuevas para verificar tu tarjeta.",
    "Your card is verified.": "Tu tarjeta está verificada.",
    "Place new holds": "Aplicar nuevas retenciones",
    "Verify Your Card": "Verifica tu tarjeta",
    "Placing two small holds on your card…": "Aplicando dos pequeñas retenciones en tu tarjeta…",
    "We've placed two temporary holds under $1.00 each on your card. Check your bank app or statement, then enter both exact amounts to verify your card.": "Hemos aplicado dos retenciones temporales de menos de $1.00 cada una en tu tarjeta. Revisa la app o el extracto de tu banco e introduce ambos importes exactos para verificar tu tarjeta.",
    "They show as {descriptor} on your statement.": "Aparecen como {descriptor} en tu extracto.",
    "First Transaction Amount": "Importe de la primera transacción",
    "Second Transaction Amount": "Importe de la segunda transacción",
    "Card verification failed": "La verificación de la tarjeta falló",
    "I couldn't verify my card ending in {last4}. Please help me verify it.": "No pude verificar mi tarjeta terminada en {last4}. Por favor, ayudadme a verificarla.",
    "I couldn't verify my card. Please help me verify it.": "No pude verificar mi tarjeta. Por favor, ayudadme a verificarla.",
    "You've reached the limit of card verifications for now. Please contact support to verify your card.": "Has alcanzado el límite de verificaciones de tarjeta por ahora. Contacta con soporte para verificar tu tarjeta.",
    "Your card ending in {last4} was removed and its authorization holds were released. Please add a card to continue.": "Tu tarjeta terminada en {last4} se eliminó y sus retenciones de autorización se liberaron. Añade una tarjeta para continuar.",
    "Your card was removed and its authorization holds were released. Please add a card to continue.": "Tu tarjeta se eliminó y sus retenciones de autorización se liberaron. Añade una tarjeta para continuar.",
    "Add Card": "Añadir tarjeta",
    "We Couldn't Verify This Card": "No pudimos verificar esta tarjeta",
    "Verify Card": "Verificar tarjeta",
    "Verify your card first": "Primero verifica tu tarjeta",
    "Your card can't be charged until it's verified. Enter the two small hold amounts from your bank app to finish.": "No se puede cobrar a tu tarjeta hasta que esté verificada. Introduce los dos pequeños importes retenidos que ves en la app de tu banco para terminar.",
    "Verify your card. Confirm the two small holds on your card to activate billing.": "Verifica tu tarjeta. Confirma las dos pequeñas retenciones en tu tarjeta para activar la facturación.",
    "You can finish buying your numbers now.": "Ya puedes terminar de comprar tus números.",
    "Contact Support": "Contactar con soporte",
    "We couldn't verify your card ending in {last4}. Add another card, or contact support for help.": "No pudimos verificar tu tarjeta terminada en {last4}. Añade otra tarjeta o contacta con soporte para obtener ayuda.",
    "We couldn't verify your card. Add another card, or contact support for help.": "No pudimos verificar tu tarjeta. Añade otra tarjeta o contacta con soporte para obtener ayuda.",
    "Forwarded": "Desviada",
    "Terminate call": "Finalizar llamada",
    "This user is deactivated or removed. Choose another user.": "Este usuario está desactivado o se eliminó. Elige otro usuario.",
    "This device is disabled, removed, or has no active user. Choose another device.": "Este dispositivo está deshabilitado, se eliminó o no tiene un usuario activo. Elige otro dispositivo.",
    "This extension is removed, or no longer rings an active user. Choose another extension.": "Esta extensión se eliminó o ya no llama a un usuario activo. Elige otra extensión.",
    "Click 2 Call integration created": "Integración de Click 2 Call creada",
    "Click 2 Call integration updated": "Integración de Click 2 Call actualizada",
    "Forwarded to": "Desviada a",
    "No numbers available for this country or these filters right now.": "No hay números disponibles para este país o estos filtros en este momento.",
    "Phone numbers can't be purchased during a trial. Upgrade your plan to buy numbers.": "No se pueden comprar números de teléfono durante una prueba. Mejora tu plan para comprar números.",
    "Reconnect": "Volver a conectar",
    "Disconnect WhatsApp number": "Desconectar número de WhatsApp",
    "{number} stops sending and receiving messages. Any monthly charge for it stops at the end of the billing period. Your other numbers stay connected.": "{number} deja de enviar y recibir mensajes. Cualquier cargo mensual por él termina al final del período de facturación. Tus otros números siguen conectados.",
    "Failed to disconnect the WhatsApp number. Please try again.": "No se pudo desconectar el número de WhatsApp. Inténtalo de nuevo.",
    "Failed to reconnect the WhatsApp number. Please try again.": "No se pudo volver a conectar el número de WhatsApp. Inténtalo de nuevo.",
    "WhatsApp is available on the Core and Advanced plans.": "WhatsApp está disponible en los planes Core y Advanced.",
    "Reconnect WhatsApp number": "Volver a conectar número de WhatsApp",
    "{number} starts sending and receiving messages again. If your plan charges per WhatsApp number, a new charge for the rest of this billing period starts today.": "{number} vuelve a enviar y recibir mensajes. Si tu plan cobra por número de WhatsApp, hoy empieza un nuevo cargo por el resto de este período de facturación.",
    "Rang": "Sonó",
    "Callee hung up": "El destinatario colgó",
    "Ended by the system": "Finalizada por el sistema",
    "Holiday": "Festivo",
    "Transfer hold": "En espera por transferencia",
    "Pressed {digit}": "Pulsó {digit}",
    "Rang: {names}": "Sonó: {names}",
    "Rang: {names} +{more} more": "Sonó: {names} y {more} más",
    "Could not load the call details": "No se pudieron cargar los detalles de la llamada",
    "No details were recorded for this call": "No se registraron detalles para esta llamada",
    "Device": "Dispositivo",
    "Trunk": "Troncal",
    "Feature code": "Código de función",
    "Queue full": "Cola llena",
    "Wait time too long": "Tiempo de espera demasiado largo",
    "No agents available": "No hay agentes disponibles",
    "Call Flow": "Flujo de llamada",
    "Transfer": "Transferencia",
    "Price Sheet": "Hoja de precios",
    "This person already accepted the invitation. Open them again from the refreshed list to edit.": "Esta persona ya aceptó la invitación. Ábrela de nuevo desde la lista actualizada para editarla.",
    "This invitation was revoked": "Esta invitación fue revocada",
    "That invitation no longer exists": "Esa invitación ya no existe",
    "Failed": "Error",
    "Due now (each)": "A pagar ahora (c/u)",
    "You haven't accepted your invitation yet. Open the invitation email to set up your account.": "Aún no ha aceptado su invitación. Abra el correo de invitación para configurar su cuenta.",
    "A new invitation was sent to {name}. There is no need to resend it.": "Se envió una nueva invitación a {name}. No es necesario reenviarla.",
    "{name} has been notified by email.": "Se notificó a {name} por correo electrónico.",
    "You are about to invite {name} as a team member": "Está a punto de invitar a {name} como miembro del equipo",
    "This person still receives calls from a phone number, extension, IVR, queue, flow or another user. Change those first, then delete the invitation.": "Esta persona todavía recibe llamadas de un número, extensión, IVR, cola, flujo u otro usuario. Cámbielos primero y luego elimine la invitación.",
    "Deleting the invitation did not finish. Please try again.": "No se terminó de eliminar la invitación. Inténtelo de nuevo.",
    "We couldn't load this flow. Check your connection and try again.": "No pudimos cargar este flujo. Comprueba tu conexión e inténtalo de nuevo.",
    "The embed code is not available in this environment.": "El código de inserción no está disponible en este entorno.",
    "This widget moved from the previous platform. Its old embed code still works for now: replace it with the code below on every site that uses it.": "Este widget se trasladó desde la plataforma anterior. Su código de inserción antiguo aún funciona por ahora: sustitúyelo por el código de abajo en cada sitio que lo use.",
    "This widget was changed elsewhere. Reload the page and try again.": "Este widget se modificó en otro lugar. Vuelve a cargar la página e inténtalo de nuevo.",
    "Your plan allows no more web widgets.": "Tu plan no permite más widgets web.",
    "This widget no longer exists.": "Este widget ya no existe.",
    "Back to integrations": "Volver a integraciones",
    "Delete this widget? Every site that embeds it stops showing it.": "¿Eliminar este widget? Todos los sitios que lo insertan dejarán de mostrarlo.",
    "Switched off, the widget shows on no website.": "Desactivado, el widget no se muestra en ningún sitio web.",
    "Remove “{label}” from the question library? Routes that already ask it keep their copy.": "¿Quitar “{label}” de la biblioteca de preguntas? Las rutas que ya la preguntan conservan su copia.",
    "Visitors are not offered chat until you pick who answers it": "Los visitantes no verán el chat hasta que elijas quién lo atiende",
    "The widget was saved, but some chats are not routed yet.": "El widget se guardó, pero algunos chats aún no tienen destino.",
    "This person can no longer answer chats": "Esta persona ya no puede atender chats",
    "This inbox is no longer available": "Esta bandeja ya no está disponible",
    "Chat could not be routed here. Save again to retry.": "No se pudo dirigir el chat aquí. Guarda de nuevo para reintentar.",
    "Where chats go could not be loaded. Reload the page to change it.": "No se pudo cargar a dónde van los chats. Recarga la página para cambiarlo.",
    "This widget could not be loaded.": "No se pudo cargar el widget.",
    "Website chat": "Chat del sitio web",
    "Website visitor": "Visitante del sitio web",
    "This chat has ended.": "Este chat ha finalizado.",
    "chat system visitor left": "El visitante salió del chat.",
    "chat system visitor ended": "El visitante finalizó el chat.",
    "chat system timed out": "El chat expiró.",
    "chat system route removed": "El chat finalizó porque se eliminó su ruta.",
    "chat system route changed": "El chat finalizó porque se cambió su ruta.",
    "Visitors can send files": "Los visitantes pueden enviar archivos",
    "Files: images, PDF, Office documents, text, audio and MP4 video.": "Archivos: imágenes, PDF, documentos de Office, texto, audio y video MP4.",
    "Show agent names to visitors": "Mostrar los nombres de los agentes a los visitantes",
    "When off, visitors see \"Agent\" instead of names.": "Si está desactivado, los visitantes ven \"Agent\" en lugar de los nombres.",
    "Send offline messages to": "Enviar los mensajes sin conexión a",
    "When this route is closed, visitors can leave a message that is emailed here.": "Cuando esta ruta está cerrada, los visitantes pueden dejar un mensaje que se envía por correo electrónico a estas direcciones.",
    "Name shown in website chats": "Nombre que se muestra en los chats del sitio web",
    "Website visitors see this name when you chat with them. Leave empty to use your first name.": "Los visitantes del sitio web ven este nombre cuando chateas con ellos. Déjalo vacío para usar tu nombre.",
    "Website visitors see this name when this user chats with them. Leave empty to use their first name.": "Los visitantes del sitio web ven este nombre cuando este usuario chatea con ellos. Déjalo vacío para usar su nombre.",
    "This name cannot contain @": "Este nombre no puede contener @",
    "This name is reserved. Choose another one.": "Este nombre está reservado. Elige otro.",
    "Allowed websites": "Sitios web permitidos",
    "Only these websites can show the widget, one per line (example.com and www.example.com count as two). Leave empty to let any website show it.": "Solo estos sitios web pueden mostrar el widget, uno por línea (example.com y www.example.com cuentan como dos). Déjalo vacío para que cualquier sitio web pueda mostrarlo.",
    "Enter a website address like https://example.com": "Introduce una dirección web como https://example.com",
    "Up to {count} websites": "Hasta {count} sitios web",
    "Privately held company": "Empresa privada",
    "NYSE American (AMEX)": "NYSE American (AMEX)",
    "Euronext Amsterdam (AMX)": "Euronext Amsterdam (AMX)",
    "Gambling and Lottery": "Juegos de azar y lotería",
    "tax number": "número fiscal",
    "ZIP code": "código ZIP",
    "postal code": "código postal",
    "Postal Code": "Código postal",
    "{field} must not exceed {count} characters": "{field} no debe superar los {count} caracteres",
    "{field} must be at least {count} characters": "{field} debe tener al menos {count} caracteres",
    "Your plan, or the one you're moving to, doesn't include WhatsApp. Update your plan to use it.": "Tu plan, o el plan al que vas a cambiar, no incluye WhatsApp. Actualiza tu plan para usarlo.",
    "This card was removed, so there's nothing to verify.": "Esta tarjeta se eliminó, así que no hay nada que verificar.",
    "Enter both amounts.": "Introduce ambos importes.",
    "Enter each amount in dollars with up to 2 decimals, for example 0.57.": "Introduce cada importe en dólares con hasta 2 decimales, por ejemplo 0.57.",
    "Each hold is between $0.01 and $0.99. Enter it in dollars, for example 0.57.": "Cada retención está entre $0.01 y $0.99. Introdúcela en dólares, por ejemplo 0.57.",
    "Outside calls start once the account's card is verified": "Las llamadas externas empiezan cuando se verifique la tarjeta de la cuenta",
    "Some features are unavailable. Your account admin needs to finish billing setup.": "Algunas funciones no están disponibles. El administrador de tu cuenta debe terminar de configurar la facturación.",
    "Invalid authorization amounts, please try again. You have {count} attempts left.": "Los importes de autorización no son válidos, inténtalo de nuevo. Te quedan {count} intentos.",
    "Invalid authorization amounts. You have 1 attempt left: a wrong answer removes this card.": "Los importes de autorización no son válidos. Te queda 1 intento: una respuesta incorrecta eliminará esta tarjeta.",
    "Partly saved": "Guardado parcialmente",
    "This person still receives calls from {routes}. Change those first, then delete the invitation.": "Esta persona todavía recibe llamadas de {routes}. Cámbielos primero y luego elimine la invitación."
}
